(function () {
    'use strict';

    if (!Array.prototype.find) {
        
        Object.defineProperty(Array.prototype, 'find', {
            
            value: function (predicate) {
                
                // 1. Let O be ? ToObject(this value).
                if (this == null) {

                    throw new TypeError('"this" is null or not defined');

                }

                var o = Object(this);            
                var len = o.length >>> 0; // 2. Let len be ? ToLength(? Get(O, "length")).
                
                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    
                    throw new TypeError('predicate must be a function');
                
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];            
                var k = 0; // 5. Let k be 0.

                // 6. Repeat, while k < len
                while (k < len) {

                    var kValue = o[k];
                    
                    if (predicate.call(thisArg, kValue, k, o)) {
                    
                        return kValue;
                    
                    }
                    
                    // e. Increase k by 1.
                    k++;
                
                }

                // 7. Return undefined.
                return undefined;
            },

            configurable: true,
            writable: true

        });

    }

    // Array.from()
    if (!Array.from) {

        Array.from = function(object) {
            return [].slice.call(object);

        };

    }

    // Element.closest()
    if (!Element.prototype.closest) {
    	
    	Element.prototype.closest = function(css) {
    		
    		let node = this,
    			result,
    			matches = node.matches || node.matchesSelector || node.webkitMatchesSelector || node.mozMatchesSelector || node.msMatchesSelector;	
    		

    		// polyfill matches					
    		if (!matches) {
    		
    			(node.matches = node.matchesSelector = function matches(selector) {
    		        
    		        var matches = document.querySelectorAll(selector),
    		        	th = this;
    		        
    		        return Array.prototype.some.call(matches, function(e) {
    		        
    		            return e === th;
    		        
    		        });
    		    
    		    });
    		
    		} else {
    			
    			node.matches = node.matchesSelector = matches;
    		
    		}


    		result = node.matches(css);


    		while (node) {
    		
    			if (result){
    				
    				return node;	
    			
    			} else {

    				node = node.parentElement;

    			}	 
    	   	
    	   	} 
    	   	
    	   	return null; 
    		
    	};

    }

    if (Number.parseInt === undefined) Number.parseInt = window.parseInt;

    if (!String.prototype.startsWith) {
        
        Object.defineProperty(String.prototype, 'startsWith', {
            enumerable: false,
            configurable: false,
            writable: false,
            value: function(searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            }
        });

    }

    (function() {

        if (typeof window.CustomEvent === "function") return false;


        function CustomEvent(event, params) {
            
            params = params || { bubbles: false, cancelable: false, detail: null };
            
            var evt = document.createEvent('CustomEvent');        
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            
            return evt;
        
        }


        window.CustomEvent = CustomEvent;

    })();

    const CommonTypography = (() => {

        class Core {

            constructor() {

                this.body = document.body;
                this.build();

            }


            build() {

                this.table();

            }


            table() {

                let parent = null,
                    wrapper = null,
                    tables = Array.from(this.body.querySelectorAll('.table'));


                if (tables.length > 0) {

                    tables.forEach((variable) => {

                        parent = variable.parentNode;

                        wrapper = document.createElement('div');
                        wrapper.classList.add('table-wrapper');
                        wrapper.appendChild(variable);
                        
                        parent.appendChild(wrapper);

                    });

                }

            }

        }

        
        let active = null;


        const init = () => {

            active = new Core();
            return active;

        };


        return { init };

    })();


    window.CommonTypography = CommonTypography;

    const LayoutMenu = (() => {

        class Core {

            constructor() {

                this.$menuUser = document.querySelector('.menu-user') || false,
                this.$hamburgerBlock = document.querySelector('.hamburger-block') || false;
            

                this.build_menu_user();

            }


            build_menu_user() {

                if (this.$hamburgerBlock !== false && this.$menuUser !== false) {

                    if (window.innerWidth <= 980) this.$hamburgerBlock.insertAdjacentElement('beforebegin', this.$menuUser);

                }

            }

        }


        let active = null;


        const init = () => {

            active = new Core();
            return active;

        };


        return { init };

    })();


    window.LayoutMenu = LayoutMenu;

    const ComponentReceiptAction = (() => {

        class Core {

            constructor() {
                
                this.receiptAction = document.querySelector('.receipt-action') || false;          
            
            }

        }


        /**
         * Загрузить фото чека
         */
        class PhotoReceipt extends Core {

            constructor() {
                
                super();            
                this.el = document.querySelector('.js-photo-receipt') || false;


                if (this.el !== false) {
                    
                    this.variables();
                    this.event();
                    
                }
                
            }


            variables() {

                this.stepArray = Array.from(document.querySelectorAll('.photo-receipt__step'));
                this.preview = this.el.querySelector('.photo-receipt__preview');
                this.buttonLoadPhoto = this.el.querySelector('.receipt-action__btn.--photo');
                this.buttonLoadMorePhoto = this.el.querySelector('.--photo-load-more');

            }
            
            
            event() {
                
                this.el.addEventListener('submit', this.listener_submit_photo.bind(this), false);
                this.buttonLoadPhoto.addEventListener('change', this.listener_load_photo.bind(this), false);
                this.buttonLoadMorePhoto.addEventListener('click', () => this.method_step_active('--start'), false);

            }


            listener_submit_photo(event) {

                event.target;


                this.method_step_active('--end'); // show end
                
                event.preventDefault();

            }


            listener_load_photo(event) {

                let target = event.target,
                    file = target.files[0],
                    reader = new FileReader();
                

                reader.onloadend = () => {
                    
                    this.preview.src = reader.result;
                    this.method_step_active('--preview'); // show preview
                
                };

                if (file) {
                
                    reader.readAsDataURL(file);
                
                } else {
                    
                    this.preview.src = "";
                
                }

            }


            method_step_active(type) {

                this.stepArray.find((step, index) => {

                    if (step.classList.contains(type) == true) {

                        this.stepActive = {
                            el: step,
                            index: index
                        };

                        step.classList.add('--active');

                    } else {

                        step.classList.remove('--active');

                    }

                });

            }

        }


        /**
         * Сканирование QR-кода
         */
        class QrScannerReceipt extends Core {

            constructor() {
                
                super();            
                this.el = document.querySelector('.js-qr-scanner') || false;
                

                if (this.el !== false) {
                    
                    this.variables();
                    this.build();
                    this.event();

                }
            
            }


            variables() {

                this.result = null;
                this.qrScanner = null;
                this.preview = this.el.querySelector('.qr-scanner__preview');
                this.video = this.preview.querySelector('.qr-scanner__video');
                this.buttonStart = this.el.querySelector('.--qr-start') || false;

            }


            build() {

                let notificationElement = null;

                notificationElement = document.createElement('div');
                notificationElement.classList.add('qr-scanner__notification');
                

                this.el.appendChild(notificationElement);
                this.notification = this.el.querySelector('.qr-scanner__notification');
            }

        
            event() {
                
                this.buttonStart.addEventListener('click', this.listener_start.bind(this), false);
                
                if (this.receiptAction !== false) {

                    this.receiptAction.addEventListener('popup toggle', this.listener_popup.bind(this), false);

                }
                
            }
        

            listener_popup(event) {

                // popup hide
                if (event.detail.hidden == true) {

                    this.method_stop();

                }

            }


            listener_start() {

                this.method_init();
                this.method_start();

            }


            method_init() {

                this.qrScanner = new QrScanner(this.video, result => {

                    this.result = result;

                    this.notification.setAttribute('data-type', 'success');
                    this.notification.innerHTML = `<strong>QR-код отсканирован</strong>`;
                    this.notification.classList.add('--show');

                }, {

                    onDecodeError: error => {
                        
                        this.notification.setAttribute('data-type', 'error');
                        this.notification.innerHTML = `<strong>QR-код не найден</strong>`;
                        this.notification.classList.add('--show');

                    },

                    highlightScanRegion: true,
                    highlightCodeOutline: true,

                });

            }

            
            method_start() {

                if (this.qrScanner !== null) {

                    this.qrScanner.start().then(() => {

                        this.preview.classList.add('--show');

                    });
                
                }

            }


            method_stop() {

                if (this.qrScanner !== null) {

                    this.qrScanner.stop();
                    this.qrScanner.destroy();

                    this.preview.classList.remove('--show');
                    this.notification.classList.remove('--show');
                
                }

            }

        }


        class Init {

            constructor() {

                this.object = {};
                this.object.photo   = new PhotoReceipt();
                this.object.scanner = new QrScannerReceipt();
                
                return this.object;

            }

        } 


        let active = null;

        const init          = () => active = new Init();
        const scannerResult = () => active.scanner.result;


        return { init, scannerResult };

    })();


    window.ComponentReceiptAction = ComponentReceiptAction;

    /**
     * Main core libs
     * @namespaces
     * @property {function} BasicCore.variables — build variables;
     * @property {object}   BasicCore.logging   — message logging.
     */
    const BasicCore$1 = {

        variables: (variable, defaultClass) => {

            let result = null;
            
            if (variable == undefined) 		  result = Array.from(document.querySelectorAll(defaultClass));
            if (typeof variable == 'string')  result = [document.querySelector(variable)] || false;	
            if (typeof variable == 'object')  result = (variable.length !== undefined) ? Array.from(variable) : [variable] || false;
        
            return result;
        
        },

        logging: {
            'name': '#BasicUI',
            'error': {
                'missing': `\n *Eng: "Element missing"\n *Rus: "Отсутствует элемент"`,    
                'type': `\n *Eng: "Invalid input value. Accepts values of type String or Object"\n *Rus: "Неправильное входное значение. Принимает значения типа String или Object"`,        
                'popup': {
                    'missing': {
                        'modal':   `\n *Eng: "Missing popup element"\n *Rus: "Отсутствует попап элемент"`,
                        'trigger': `\n *Eng: "Missing trigger element"\n *Rus: "Отсутствует триггер элемент"`
                    },
                }
            }
        }
    };


    window.BasicCore = BasicCore$1;

    /**
     * Basic UI: Accordion.
     */
    const BasicAccordion = (() => {

    	class Core {

    	    constructor(element) {

    			let list = Array.from(document.querySelectorAll('.accordion'));
    				list.push(this.$el);								
    				
    			this.$el = element;			      	
            	this.$children = Array.from(this.$el.children);

    			this.$options = {
    				index: list.indexOf(this.$el),
    				offHide: (this.$el.getAttribute('data-accordion-off-hide') == 'true') ? true : false,
    				className: {
    					selected: 'accordion--selected'
    				}
    			};

    			this.$customEventChoice = new CustomEvent('accordion choice', { 
    				bubbles: true,
    				detail:  {
    					'index': null,
    					'accordion': null,
    					'previous': null
    				}
    			});
    	        		    	
    	    }


    		init() {				
    						
    			this.build();
            	this.event();

    		}


    	    build() {
    												
    			// build accordion children
    			this.$children.forEach((value, index) => {

    				let trigger = value.querySelector('.accordion-trigger'),
    					content = value.querySelector('.accordion-content'),
    					idContent = `accordion-${this.$options.index}-content-${index}`;


    				// selected
    				if (trigger.getAttribute('aria-expanded') == 'true') {
    					
    					content.style.maxHeight = '';
    					content.style.overflow = '';					
    					trigger.setAttribute('aria-disabled', true);
    					value.classList.add(this.$options.className.selected);

    				} else {
    					
    					content.style.maxHeight = '0px';
    					content.style.overflow = 'hidden';
    					trigger.setAttribute('aria-expanded', false);
    				
    				}
    									
    				content.setAttribute('id', idContent);
    				content.setAttribute('role', 'region');
    				trigger.setAttribute('aria-controls', idContent);

    			});


    			this.$el.classList.add('accordion');
    			this.$el.classList.add('accordion-init');
    			this.$el.setAttribute('data-accordion-id', this.$options.index);
    				
    	    }


    	    event() {

    			if (this.$options.offHide == false) {

    				this.$el.addEventListener('click', this.listener_default.bind(this), false);

    			} else {

    				this.$el.addEventListener('click', this.listener_off_close.bind(this), false);
    			
    			}			

    	    }


    	    listener_default(event) {
    		
    			let target = event.target,
    				selected = {
    					current: target.parentElement,
    					previous: this.$children.find((value) => value.classList.contains(this.$options.className.selected) == true)
    				},
    				current = {
    					parent:  selected.current,
    					index: 	 this.$children.indexOf(selected.current),
    					trigger: target.closest('.accordion-trigger') || false,
    					content: selected.current.querySelector('.accordion-content')
    				},
    				previous = {
    					parent: selected.previous || false,
    					trigger: selected.previous.querySelector('.accordion-trigger'),
    					content: selected.previous.querySelector('.accordion-content')
    				};
    				
    			
    			// switch accordion
    			if (current.parent.classList.contains(this.$options.className.selected) == false && current.trigger !== false) {	

    				// previous selected accordion
    				if (previous.parent !== false) {
    																											
    					previous.trigger.removeAttribute('aria-disabled');
    					previous.trigger.setAttribute('aria-expanded', false);												
    					previous.content.style.maxHeight = `${previous.content.scrollHeight}px`;

    					setTimeout(() => {

    						previous.content.style.maxHeight = '0px';
    						previous.content.style.overflow = 'hidden';
    						previous.parent.classList.remove(this.$options.className.selected);								
    					
    					}, 120);												

    				}
    								
    				// current accordion
    				current.parent.classList.add(this.$options.className.selected);					
    				current.trigger.setAttribute('aria-disabled', true);				
    				current.trigger.setAttribute('aria-expanded', true);
    				current.content.style.overflow = '';					
    				current.content.style.maxHeight = `${current.content.scrollHeight}px`;
    				setTimeout(() => current.content.style.maxHeight = '', 120);

    				// custom event: accordion choice
    				this.$customEventChoice.detail.index = current.index;
    				this.$customEventChoice.detail.previous = previous.parent;
    				this.$customEventChoice.detail.accordion = current.parent;
    				this.$el.dispatchEvent(this.$customEventChoice); 	
    			
    			}	

    		
    		}


    		listener_off_close(event) {		
    		
    			let status = false,
    				target = event.target,				
    				current = {
    					parent: target.parentElement,
    					index: this.$children.indexOf(target.parentElement),
    					trigger: target.closest('.accordion-trigger') || false,
    					content: target.parentElement.querySelector('.accordion-content')
    				};

    							
    			if (current.trigger !== false) {
    									
    				current.trigger.setAttribute('aria-expanded', status);
    				current.parent.classList.toggle(this.$options.className.selected);
    				current.content.style.maxHeight = `${current.content.scrollHeight}px`;				
    				status = current.parent.classList.contains(this.$options.className.selected);				

    				setTimeout(() => {

    					current.content.style.maxHeight = (status == false) ? '0px' : '';
    					current.content.style.overflow =  (status == false) ? 'hidden' : '';
    				
    				}, 120);
    																	
    				// custom event: accordion choice
    				this.$customEventChoice.detail.index = current.index;
    				this.$customEventChoice.detail.accordion = current.parent;
    				this.$el.dispatchEvent(this.$customEventChoice); 	

    			}
    		
    		}	

    	}


    	let active = null;


    	/**
    	 * Accordion initialization
    	 * @param {Object|string} variable - element for initializing accordion 
    	 */
    	const init = (variable) => {
    		
    		let element = null,
    			elements = BasicCore.variables(variable, '.js-accordion:not(.accordion-init)');

    			
    		try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
    						
    			elements.forEach((value) => {

    				element = value;
    				
    				active = new Core(value);
    				active.init();

    			});
    			
    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Accordion init. \nMessage: ${error.message} \nElement: `, element);
    			return false;

    		}

    	};   


    	return { init };

    })();


    window.BasicAccordion = BasicAccordion;

    /**
     * Basic UI: Popup.
     */
    const BasicPopup = (() => {

    	class Core {

    	    constructor({trigger, popup, content}) {
    			
    			this.$trigger = trigger || null;
    			
    			this.$popup = {
    				el: 	 popup   || null,
    				content: content || ''
    			};		

    			this.$options = {
    				className: {
    					main:  	 'popup',
    					show: 	 'popup--show',
    					close: 	 'popup-main-close',
    					content: 'popup-content'
    				}
    			};

    			this.$customEventToggle = new CustomEvent('popup toggle', { 
    				bubbles: true,
    				detail:  {
    					'popup': null,
    					'trigger': null,
    					'hidden': false
    				}
    			});
    			
    			
    			this.build();
    			this.events();
    	    	
    	    }

    		
    		build() {

    			let popupModal = null;


    	    	if (this.$popup.el !== null && this.$popup.el.classList.contains('popup-init') == false) {
    				
    				popupModal = document.createElement('div');
    				popupModal.classList.add('popup-modal');
    				popupModal.setAttribute('role', 'dialog');
    				popupModal.setAttribute('aria-modal', 'true');
    				popupModal.innerHTML = `
					<button class="${this.$options.className.close}" type="button" title="Close popup" aria-label="Close popup" data-popup-close>
						<svg width="512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
							<path d="M256 334.769L433.231 512L512 433.231L334.769 256L512 78.7692L433.231 0L256 177.231L78.7692 0L0 78.7692L177.231 256L0 433.231L78.7692 512L256 334.769Z"/>
						</svg>	
					</button>
					<div class="${this.$options.className.content}"></div>
				`;
    				
    				while (this.$popup.el.firstChild) {

    					popupModal.querySelector(`.${this.$options.className.content}`).appendChild(this.$popup.el.firstChild);

    				}
    				
    				this.$popup.el.classList.add(this.$options.className.main);
    				this.$popup.el.classList.add('popup-init');
    				this.$popup.el.appendChild(popupModal);

    	    	}
    		
    	    }


    		events() {

    			if (this.$trigger !== null)  this.$trigger.addEventListener('click', this.listener_trigger.bind(this), false);
    			if (this.$popup.el !== null) this.$popup.el.addEventListener('click', this.listener_popup.bind(this), false);

    		}


    		listener_trigger() {

    			this.method_show();

    	    	// custom event: popup toggle
    			this.$customEventToggle.detail.hidden = false;
    			this.$customEventToggle.detail.trigger = this.$trigger;
    			this.$customEventToggle.detail.popup = this.$popup.el;
    			this.$popup.el.dispatchEvent(this.$customEventToggle);	

    	    }

    	
    		listener_popup(event) {

    	    	let target = event.target;
    			

    			if (
    				target.closest('.popup-close') !== null			 ||
    				target.getAttribute('data-popup-close') !== null ||
    				target.classList.contains(this.$options.className.main) == true				
    			) {

    				this.method_hide();				

    			}

    			
    	    	// custom event: popup toggle
    			this.$customEventToggle.detail.hidden = true;
    			this.$customEventToggle.detail.popup = this.$popup.el;
    			this.$customEventToggle.detail.trigger = this.$trigger;
    			this.$popup.el.dispatchEvent(this.$customEventToggle);	

    	    }


    		method_show() {
    						
    			document.body.classList.add('body-popup');
    	    	this.$popup.el.classList.add(this.$options.className.show);

    	    }


    	    method_hide() {

    			document.body.classList.remove('body-popup');
    			this.$popup.el.classList.remove(this.$options.className.show);

    	    }


    		method_html() {

    			this.$popup.el.querySelector(`.${this.$options.className.content}`).innerHTML = this.$popup.content;
    			this.method_show();

    		}

    	}


    	let active = null;


    	/**
    	 * Popup initialization
    	 * @param {(Object|string)} config.trigger - trigger element
    	 * @param {string} 			config.popup   - popup element
    	 */
    	const init = (config) => {

    		let options = config || {},
    			elements = BasicCore.variables(options.trigger, '.js-trigger-popup');


    		try {

    			if (elements == false && options.trigger !== undefined) throw new Error(BasicCore.logging['error']['popup']['missing']['trigger']);
    			if (elements == null  && options.trigger !== undefined) throw new Error(BasicCore.logging['error']['type']);			
    							
    			elements.forEach((value) => {

    				options.trigger = value;
    				options.popup = document.querySelector(`#${value.getAttribute('data-popup-id')}`) || document.querySelector(options.popup);
    				
    				active = new Core(options);
    			
    			});
    			
    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Popup init. \nMessage: ${error.message} \nElement: `, options.trigger);

    		}

    	};


    	/**
    	 * Method: Show a popup
    	 * @param {(Object|string)} popup - show a popup element
    	 */
    	const show = (popup) => {

    		let options = {
    			popup: (typeof popup == 'object') ? popup : document.querySelector(popup)
    		};
    				

    		try {

    			if (options.popup == null) throw new Error(BasicCore.logging['error']['popup']['missing']['modal']);
    			
    			active = new Core(options);
    			active.method_show();
    			
    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Popup show. \nMessage: ${error.message} \nElement:`, popup);

    		}	

    	};	


    	/**
    	 * Method: Hide a popup
    	 * @param {(Object|string)} popup - hide a popup element
    	 */
    	const hide = (popup) => {

    		let options = {
    			popup: (typeof popup == 'object') ? popup : document.querySelector(popup)
    		};	

    		
    		try {

    			if (options.popup == null) throw new Error(BasicCore.logging['error']['popup']['missing']['modal']);
    			
    			active = new Core(options);
    			active.method_hide();

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Popup hide. \nMessage: ${error.message} \nElement:`, popup);

    		}	

    	};


    	/**
    	 * Method: add dynamic content in popup
    	 * @param {(Object|string)} popup   - popup element
    	 * @param {(String)} 		content - popup content
    	 */
    	const html = (config) => {

    		let options = config || {};	

    		options.popup = (typeof options.popup == 'object') ? options.popup : document.querySelector(options.popup);
    		
    		try {

    			if (options.popup == null) throw new Error(BasicCore.logging['error']['popup']['missing']['modal']);
    			
    			active = new Core(options);
    			active.method_html();

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Popup html. \nMessage: ${error.message} \nElement:`, config.popup);
    		
    		}	

    	};


    	return { init, show, hide, html };

    })();
    	

    window.BasicPopup = BasicPopup;

    /**
     * Basic UI: Readmore.
     */
    const BasicReadmore = (() => {

    	class Core {

    	    constructor(element) {
    	        
    	        this.$el = element;
    			this.$trigger = this.$el.nextSibling;			
    			
    			let dataReadmoreOptions = JSON.parse(this.$el.getAttribute('data-readmore-options')) || {};
    			this.$options = {
    				trigger: {
    					show: dataReadmoreOptions['textShow'] || 'Показать ещё',
    					hide: dataReadmoreOptions['textHide'] || 'Скрыть',
    					classes: dataReadmoreOptions['classTrigger'] ? `readmore-trigger,${dataReadmoreOptions['classTrigger']}`.split(',') : ['readmore-trigger']
    				},

    				className: {
    					show: 'readmore--show',
    					selected: 'readmore-trigger--selected'
    				}
    			};
    						
    			this.$customEvent = new CustomEvent('readmore switched', { 
    				bubbles: true,
    				detail:  {
    					'readmore': null,
    					'trigger': null,
    					'hidden': true
    				}
    			});			
    	        		    	
    	    }


    		init() {

    			this.build();
    			this.$trigger.addEventListener('click', this.listener_readmore.bind(this), false);

    		}


    		build() {

    			let readmoreArray = Array.from(document.querySelectorAll('.readmore-init'));				
    			
    			readmoreArray.push(this.$el);

    			this.$el.classList.add('readmore');
    			this.$el.classList.add('readmore-init');
    			this.$el.setAttribute('id', `readmore-id-${readmoreArray.indexOf(this.$el)}`);


    			// build trigger
    			let triggerElement = document.createElement('button');
    		
    			triggerElement.setAttribute('title', 'More');
    			triggerElement.setAttribute('aria-label', 'More');		
    			triggerElement.setAttribute('aria-expanded', false);
    			triggerElement.setAttribute('aria-controls', this.$el.getAttribute('id'));		
    			triggerElement.innerHTML = this.$options.trigger.show;
    					
    			// add classes
    			this.$options.trigger.classes.forEach((value) => triggerElement.classList.add(value));
    	
    			// init and add trigger
    			if (this.$el.scrollHeight > this.$el.getBoundingClientRect().height) { 
    				
    				this.$el.classList.add('more');
    				this.$el.parentElement.insertBefore(triggerElement, this.$el.nextSibling);
    			
    			}
    			
    			this.$trigger = triggerElement;
    			// /build trigger

    		}


    		listener_readmore() {
    			
    			// show
    			if (this.$el.style.maxHeight == '') {

    				this.show();
    			
    			// hide
    			} else if (this.$el.style.maxHeight !== '') {

    				this.hide();

    			}


    			// custom event: readmore switched
    			this.$customEvent.detail.readmore = this.$el;
    			this.$customEvent.detail.trigger = this.$trigger;
    			this.$el.dispatchEvent(this.$customEvent);	
    			
    		}
    		
    		
    		show() {
    			
    			this.$el.classList.add(this.$options.className.show);
    			this.$el.style.maxHeight = `${this.$el.scrollHeight}px`;
    						
    			this.$trigger.setAttribute('aria-expanded', true);
    			this.$trigger.innerHTML = this.$options.trigger.hide;
    			this.$trigger.classList.add(this.$options.className.selected);

    			this.$customEvent.detail.hidden = false;

    		}


    		hide() {
    			
    			this.$el.style.maxHeight = '';
    			this.$el.classList.remove(this.$options.className.show);					
    												
    			this.$trigger.setAttribute('aria-expanded', false);
    			this.$trigger.innerHTML = this.$options.trigger.show;
    			this.$trigger.classList.remove(this.$options.className.selected);					
    			
    			this.$customEvent.detail.hidden = true;

    		}	

    	}


    	let active = null;


    	/**
    	 * Readmore initialization
    	 * @param {object|string} variable - element for initializing readmore 
    	 */
    	const init = (variable) => {

    		let element = null,
    			elements = BasicCore.variables(variable, '.js-readmore');
    			

    		try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);

    			elements.forEach((value) => {

    				element = value;

    				active = new Core(value);
    				active.init();

    			});

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Readmore init. \nMessage: ${error.message} \nElement: `, element);

    		}

    	};


    	/**
    	 * Method: Readmore show
    	 * @param {object|string} variable - element show 
    	 */
    	const show = (variable) => {

    		let element = (typeof variable == 'string') ? document.querySelector(variable) : variable;


    		try {

    			if (element == null) throw new Error(BasicCore.logging['error']['type']);
    			
    			active = new Core(element);
    			active.show();

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Readmore show. \nMessage: ${error.message} \nElement:`, variable);

    		}

    	};	   
    	

    	/**
    	 * Method: Readmore hide
    	 * @param {object|string} variable - element hide 
    	 */
    	const hide = (variable) => {

    		let element = (typeof variable == 'string') ? document.querySelector(variable) : variable;


    		try {

    			if (element == null) throw new Error(BasicCore.logging['error']['type']);
    			
    			active = new Core(element);
    			active.hide();

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Readmore hide. \nMessage: ${error.message} \nElement:`, variable);

    		}

    	};	   


    	return { init, show, hide };

    })();


    window.BasicReadmore = BasicReadmore;

    /**
     * Basic UI: Tabs.
     */
    const BasicTabs = (() => {

    	class Core {

    	    constructor(element) {
    	        
    	        this.$el = element;
    								
    			this.$customEvent = new CustomEvent('tabs choice', { 
    				bubbles: true,
    				detail:  {
    					'index':   null,
    					'trigger': null,
    					'content': null
    				}
    			});

    			this.build();
    			this.refer();			
    			this.event();	
    	        		    	
    	    }


    		build() {

    			let list = [],
    				elIndex = null, elNav = null, elMain = null;
    			
    			
    			list = Array.from(document.querySelectorAll('.tab-init'));							
    			list.push(this.$el);

    			elIndex = list.indexOf(this.$el);
    			elNav = this.$el.querySelector('.tab-nav');
    			elMain = this.$el.querySelector('.tab-main');


    			this.$triggers = Array.from(elNav.getElementsByClassName('tab-trigger'));
    			this.$contents = Array.from(elMain.getElementsByClassName('tab-content'));


    			this.$el.classList.add('tab');
    			this.$el.classList.add('tab-init');
    			elNav.setAttribute('role', 'tablist');


    			// build trigger
    			this.$triggers.forEach((trigger, index) => {

    				trigger.setAttribute('role', 'tab');
    				trigger.setAttribute('id', `tab-${elIndex}-trigger-${index}`);

    				if (trigger.getAttribute('aria-selected') == 'true') {

    					trigger.classList.add('tab-trigger--selected');

    					this.$contents[index].setAttribute('tabindex', 0);
    					this.$contents[index].setAttribute('aria-selected', true);
    					this.$contents[index].classList.add('tab-content--selected');

    				} else {

    					trigger.setAttribute('tabindex', -1);
    					trigger.setAttribute('aria-selected', false);

    				}

    			});


    			// build content
    			this.$contents.forEach((content, index) => {
    				
    				content.setAttribute('role', 'tabpanel');				
    				content.setAttribute('aria-labelledby', `tab-${elIndex}-trigger-${index}`);
    				
    				
    				// selected
    				if (content.getAttribute('aria-selected') !== 'true') {

    					content.setAttribute('tabindex', -1);
    					content.setAttribute('aria-selected', false);

    				}

    				// id
    				if (content.getAttribute('id')) {

    					this.$triggers[index].setAttribute('aria-controls', content.getAttribute('id'));

    				} else {

    					content.setAttribute('id', `tab-${elIndex}-content-${index}`);
    					this.$triggers[index].setAttribute('aria-controls', `tab-${elIndex}-content-${index}`);

    				}

    			});

    			
    			// init selected
    			if (this.$el.querySelector('.tab-trigger--selected') == null && this.$el.querySelector('.tab-content--selected') == null) {

    				this.$triggers[0].setAttribute('tabindex', 0);
    				this.$triggers[0].setAttribute('aria-selected', true);
    				this.$triggers[0].classList.add('tab-trigger--selected');

    				this.$contents[0].setAttribute('aria-selected', true);
    				this.$contents[0].classList.add('tab-content--selected');

    			}

    		}


    		refer() {

    			if (location.hash !== '')  {

    				let selected = {
    						trigger: this.$el.querySelector('.tab-trigger.tab-trigger--selected'),
    						content: this.$el.querySelector('.tab-content.tab-content--selected')
    					};


    				this.$contents.forEach((content, index) => {

    					let idContent = `#${content.getAttribute('id')}`;


    					if (idContent == location.hash) {

    						// selected
    						selected.trigger.setAttribute('tabindex', -1);
    						selected.trigger.setAttribute('aria-selected', false);
    						selected.trigger.classList.remove('tab-trigger--selected');
    						selected.content.setAttribute('tabindex', -1);
    						selected.content.classList.remove('tab-content--selected');					


    						if (this.$triggers[index]) {

    							this.$triggers[index].classList.add('tab-trigger--selected');
    							this.$triggers[index].setAttribute('tabindex', 0);	
    							this.$triggers[index].setAttribute('aria-selected', true);
    						
    						}

    						
    						content.setAttribute('tabindex', 0);						
    						content.classList.add('tab-content--selected');
    				
    					}

    				});

    			}

    		}


    		event() {
    			
    			this.$el.addEventListener('click', this.listener_click.bind(this), false);
    			this.$el.addEventListener('keydown', this.listener_keydown.bind(this), false);

    		}


    		listener_click(event) {

    			let target = event.target,
    				trigger = target.closest('.tab-trigger:not(.tab-trigger--selected)') || false;
    				

    			if (trigger !== false) {

    				let current = {
    						index: this.$triggers.indexOf(trigger),
    						trigger: trigger,
    						content: this.$contents[this.$triggers.indexOf(trigger)]
    					},
    					
    					selected = {
    						trigger: this.$el.querySelector('.tab-trigger.tab-trigger--selected') || this.$triggers[0],
    						content: this.$el.querySelector('.tab-content.tab-content--selected') || this.$contents[0]
    					};


    				// selected				
    				selected.trigger.setAttribute('tabindex', -1);
    				selected.trigger.setAttribute('aria-selected', false);				
    				selected.trigger.classList.remove('tab-trigger--selected');
    				
    				if (selected.content) {

    					selected.content.setAttribute('tabindex', -1);
    					selected.content.classList.remove('tab-content--selected');

    				}

    				
    				// current
    				current.trigger.setAttribute('tabindex', 0);
    				current.trigger.setAttribute('aria-selected', true);				
    				current.trigger.classList.add('tab-trigger--selected');
    				
    				if (current.content) {

    					current.content.setAttribute('tabindex', 0);
    					current.content.classList.add('tab-content--selected');

    				}


    				// custom event: tabs choice
    				this.$customEvent.detail.index   = current.index;
    				this.$customEvent.detail.trigger = current.trigger;
    				this.$customEvent.detail.content = current.content;
    				this.$el.dispatchEvent(this.$customEvent);	

    			}

    		}


    		listener_keydown(event) {

    			let code = event.code;


    			// ArrowLeft and ArrowRight	
    			if (code == 'ArrowLeft' || code == 'ArrowRight') {

    				let current = {
    						index: false,
    						trigger: false,
    						content: false
    					},
    					
    					selected = {
    						trigger: this.$el.querySelector('.tab-trigger.tab-trigger--selected') || this.$triggers[0],
    						content: this.$el.querySelector('.tab-content.tab-content--selected') || this.$contents[0]
    					};


    				// selected
    				selected.trigger.setAttribute('tabindex', -1);
    				selected.trigger.setAttribute('aria-selected', false);							
    				selected.trigger.classList.remove('tab-trigger--selected');
    				selected.content.setAttribute('tabindex', -1);
    				selected.content.classList.remove('tab-content--selected');	
    				

    				if (code == 'ArrowRight') current.trigger = (selected.trigger.nextElementSibling !== null) ? selected.trigger.nextElementSibling : this.$triggers[0];
    				if (code == 'ArrowLeft')  current.trigger = (selected.trigger.previousElementSibling !== null) ? selected.trigger.previousElementSibling : this.$triggers[this.$triggers.length - 1];


    				// current
    				current.trigger.focus();
    				current.trigger.setAttribute('tabindex', 0);
    				current.trigger.setAttribute('aria-selected', true);
    				current.trigger.classList.add('tab-trigger--selected');
    				current.index = this.$triggers.indexOf(current.trigger);
    				current.content = this.$contents[current.index];
    				
    				if (current.content != undefined) {

    					current.content.setAttribute('tabindex', 0);
    					current.content.classList.add('tab-content--selected');
    				
    				}

    			
    				// custom event: tabs choice
    				this.$customEvent.detail.index   = current.index;
    				this.$customEvent.detail.trigger = current.trigger;
    				this.$customEvent.detail.content = current.content;
    				this.$el.dispatchEvent(this.$customEvent);	
    			
    			}			

    		}

    	}

    	
    	let active = null;


    	/**
    	 * Tabs initialization
    	 * @param {object|string} variable - element for initializing tab 
    	 */
    	const init = (variable) => {

    		let element = null,
    			elements = BasicCore.variables(variable, '.js-tab');

    			
    		try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
    			
    			elements.forEach((value) => {

    				element = value;
    				active = new Core(value);
    			
    			});

    			return active;

    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Tabs init. \nMessage: ${error.message} \nElement: `, element);

    		}				

    	};   


    	return { init };

    })();


    window.BasicTabs = BasicTabs;

    /**
     * Basic UI: Toggle visible content.
     */
    const BasicToggleVisibleContent = (() => {

    	class Core {

    	    constructor(element) {
    	        
    	        this.$el = element;
    			this.$trigger = this.$el.querySelector('.toggle-visible-trigger') || null; 
    	        this.$content = this.$el.querySelector('.toggle-visible-content') || null;

    			this.$options = {
    				className:  {
    					show: 'toggle-visible--show'
    				}
    			};
    			
    			this.$customEvent = new CustomEvent('toggleVisible switched', { 
    				bubbles: true,
    				detail:  {
    					'element': null,
    					'hidden': true
    				}
    			});						
    	        		    	
    	    }


    		init() {

    			this.build();
    			this.$trigger.addEventListener('click', this.listener.bind(this), false);
    		
    		}



    		build() {

    			// show content
    			if (this.$trigger !== null && this.$trigger.getAttribute('aria-expanded') == "true") {

    				this.method_show();
    			
    			}
    			
    			this.$el.classList.add('toggle-visible');

    		}


    	    listener(event) {

    			let active = false;

    			
    			this.$el.classList.toggle(this.$options.className.show);
    			active = this.$el.classList.contains(this.$options.className.show);
    			
    			this.$trigger.setAttribute('aria-expanded', active);			
    			
    			this.$content.style.height = `${this.$content.scrollHeight}px`;
    			setTimeout(() => this.$content.style.height = (active) ? 'auto' : '', 150);
    			

    			// custom event: toggle visible switched
    			this.$customEvent.detail.element = this.$el;
    			this.$customEvent.detail.hidden = !active;
    			this.$el.dispatchEvent(this.$customEvent);			
    		
    		}


    		method_show() {
    			
    			this.$trigger.setAttribute('aria-expanded', true);
    			this.$el.classList.add(this.$options.className.show);
    			
    			this.$content.style.height = `${this.$content.scrollHeight}px`;
    			setTimeout(() => this.$content.style.height = 'auto', 150);

    		}


    		method_hide() {

    			this.$trigger.setAttribute('aria-expanded', false);			
    			this.$el.classList.remove(this.$options.className.show);
    			
    			this.$content.style.height = `${this.$content.scrollHeight}px`;
    			setTimeout(() => this.$content.style.height = '', 150);
    		
    		}

    	}


    	let active = null;


    	/**
    	 * Toggle Visible initialization
    	 * @param {object|string} variable - element for initializing toggle visible 
    	 */
    	const init = (variable) => {

    		let element = null,
    			elements = BasicCore.variables(variable, '.js-toggle-visible');


    		try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);

    			elements.forEach((value) => {
    				
    				element = value;

    				active = new Core(value);
    				active.init();
    			
    			});
    			
    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Toggle Visible init. \nMessage: ${error.message} \nElement: `, element);

    		}
    		
    	};
    	
    	
    	/**
    	 * Toggle show
    	 * @param {object|string} variable - element show
    	 */
    	const show = (variable) => {

    		let element = (typeof variable == 'string') ? document.querySelector(variable) : variable;


    		try {

    			if (element == null ) throw new Error(BasicCore.logging['error']['type']);

    			active = new Core(element);
    			active.method_show();
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Toggle Visible show. \nMessage: ${error.message} \nElement:`, variable);

    		}

    	};
    	
    	
    	/**
    	 * Toggle hide
    	 * @param {object|string} variable - element hide
    	 */
    	const hide = (variable) => {

    		let element = (typeof variable == 'string') ? document.querySelector(variable) : variable;

    		
    		try {

    			if (element == null ) throw new Error(BasicCore.logging['error']['type']);

    			active = new Core(element);
    			active.method_hide();
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Toggle Visible hide. \nMessage: ${error.message} \nElement:`, variable);

    		}

    	};


    	return { init, show, hide };

    })();


    window.BasicToggleVisibleContent = BasicToggleVisibleContent;

    /**
     * Basic UI: Class transfer.
     */
    const BasicClassTransfer = (() => {

    	class Core {

    	    constructor(element) {
    	        
    	        this.$el = element;	       
    			this.$children = Array.from(this.$el.children);
    			
    			this.$options = {
    				className: {
    					selected: 'class-transfer--selected' 
    				}
    			};			
    			
    			this.$customEventChoice = new CustomEvent('classTransfer choice', { 
    				bubbles: true,
    				detail:  {
    					'index': null,
    					'target': null,
    					'previous': false,
    					'selected': false
    				}
    			});
    							        		    	
    	    }


    		init() {

    			this.build();
    			this.event();

    		}


    		build() {

    			this.$children.forEach((value) => {

    				value.setAttribute('role', 'listitem');

    				if (value.getAttribute('aria-selected') == 'true') {

    					value.classList.add(this.$options.className.selected);

    				} else {

    					value.setAttribute('aria-selected', false);

    				}

    			});

    			this.$el.setAttribute('role', 'listbox');
    			this.$el.classList.add('class-transfer');
    			this.$el.classList.add('class-transfer-init');

    		}


    		event() {

    			this.$el.addEventListener('click', this.listener.bind(this), false);

    		}


    	    listener(event) {
    		
    			let target = event.target,
    				current = target.closest('.class-transfer-item') || false,
    				previous = this.$el.querySelector(`.class-transfer-item.${this.$options.className.selected}`) || false;

    			
    			if (current !== false) {

    				current.classList.toggle(this.$options.className.selected);
    				current.setAttribute('aria-selected', current.getAttribute('aria-selected') == 'true');

    				// remove selected
    				if (previous !== false) {

    					previous.setAttribute('aria-selected', false);				
    					previous.classList.remove(this.$options.className.selected);
    				
    				}
    				
    				// custom event: classTransfer choice
    				this.$customEventChoice.detail.target = current;
    				this.$customEventChoice.detail.previous = previous;
    				this.$customEventChoice.detail.index = this.$children.indexOf(current);
    				this.$customEventChoice.detail.selected = (current.classList.contains(this.$options.className.selected) == true) ? true : false;
    				this.$el.dispatchEvent(this.$customEventChoice);

    			}
    		
    		}

    	}


    	let active = null;


    	/**
    	 * Class transfer initialization
    	 * @param {object|string} variable - element for initializing class-transfer 
    	 */
    	const init = (variable) => {

    		let element = null,
    			elements = BasicCore.variables(variable, '.js-class-transfer:not(.class-transfer-init)');

    			
    		try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
    					
    			elements.forEach((value) => {

    				element = value;
    				
    				active = new Core(value);				
    				active.init();

    			});

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Class Transfer init. \nMessage: ${error.message} \nElement: `, element);

    		}		

    	};   


    	return { init };

    })();


    window.BasicClassTransfer = BasicClassTransfer;

    /**
     * Basic UI: Tooltip.
     */
    const BasicTooltip = (() => {

    	class Core {

    	    constructor({trigger, content, mobile, mobileScreen, addClass}) {
    	        
    	        this.$trigger = trigger;			
    			this.$container = document.querySelector('.tooltip');
    			this.$content = content || this.$trigger.getAttribute('data-tooltip-content');

    			this.$options = {
    				mobile:   	  mobile || true,
    				mobileScreen: mobileScreen || 480,
    				addClass: 	  addClass || 'tooltip',
    				position: 	  this.$trigger.getAttribute('data-tooltip-position') || 'top',
    				className: {
    					show: 'tooltip--show'
    				}
    			};
    					
    			this.$customEvent = new CustomEvent('tooltip event', { 
                    bubbles: true,
                    detail:  {
                        'trigger': null,
                        'tooltip': this.$container,
    					'hidden': true
                    }
                });				
    	        		    	
    	    }


    		init() {

    			this.$trigger.classList.add('tooltip-trigger');
    			this.$trigger.setAttribute('aria-describedby', 'tooltip');
    			this.$container.classList.add(this.$options.addClass);

    			this.event();

    		}


    	    event() {

    			// show
    			this.$trigger.addEventListener('mouseover', this.show.bind(this), false);
    			this.$trigger.addEventListener('focus', this.show.bind(this), false);

    			
    			// hide	
    			this.$trigger.addEventListener('blur', this.hide.bind(this), false);
    			this.$trigger.addEventListener('mouseout', this.hide.bind(this), false);

    		}


    		show() {					
    			
    			this.$container.setAttribute('style', 
    				`--triggerWidth: ${Math.round(this.$trigger.getBoundingClientRect().width)}px; 
				--triggerHeight: ${Math.round(this.$trigger.getBoundingClientRect().height)}px`
    			);
    			this.$container.querySelector('.tooltip-content').innerHTML = this.$content;		
    	    	

    			this.position();		    	    		    							
    			this.$container.classList.add(this.$options.className.show);


    			// custom event: tooltip event
    			this.$customEvent.detail.trigger = this.$trigger;
    			this.$customEvent.detail.tooltip = this.$container;
    			this.$customEvent.detail.hidden = false;
    			this.$trigger.dispatchEvent(this.$customEvent); 

    		}


    		hide() {

    			this.$container.classList.remove(this.$options.position);
    			this.$container.classList.remove(this.$options.className.show);			


    			// custom event: tooltip event
    			this.$customEvent.detail.trigger = this.$trigger;
    			this.$customEvent.detail.tooltip = this.$container;
    			this.$customEvent.detail.hidden = true;
    			this.$trigger.dispatchEvent(this.$customEvent); 

    		}


    		position() {

    			// mobile true
    			if (this.$options.mobile == true) {

    				if (window.innerWidth <= this.$options.mobileScreen) {

    					this.position_mobile();
    				
    				} else {

    					this.$container.classList.remove('top-default');
    					this.position_desktop();

    				}	

    			}
    			
    			
    			// mobile false
    			if (this.$options.mobile == false) {

    				this.position_desktop();

    			}

    		}


    		position_desktop() {

    			// 1.top
    			if (this.$options.position == 'top' || this.$options.position == 'top-left' || this.$options.position == 'top-right') {
    	
    				this.top();
    			
    			}

    			// 4.right		
    			if (this.$options.position == 'right') {

    				this.right();

    			}

    			//  2.bottom
    			if (this.$options.position == 'bottom' || this.$options.position == 'bottom-left') {

    				this.bottom();

    			}
    			
    			// 3.left
    			if (this.$options.position == 'left') {

    				this.left();

    			}

    		}


    		position_mobile() {
    			
    			this.$container.classList.add('top-default');
    		    this.$container.style = '';		    		
    		    this.$container.style.top = `${this.$trigger.getBoundingClientRect().top + window.pageYOffset - this.$container.getBoundingClientRect().height - 8}px`;
    				
    		}


    		top() {

    			let coordTrigger = this.$trigger.getBoundingClientRect(),
    				coordTooltip = this.$container.getBoundingClientRect(),
    				position = {
    					name : '',
    					top: 0,
    					right: coordTrigger.right + 8,
    					left: coordTrigger.left  + (coordTrigger.width / 2) - (this.$container.offsetWidth / 2)
    				},				

    				status = {
    					right: ((position.right + coordTooltip.width) < window.innerWidth),
    					left: (position.left < 0)
    				};
    			
    			
    			// top
    			if (coordTrigger.top > 20) {
    				
    				if (!status.left && status.right)  position.name = 'top'; 		  				
    				if (status.left  && status.right)  position.name = 'top-left';    								
    				if (!status.left && !status.right) position.name = 'top-right';
    				
    	    		position.top = coordTrigger.top + window.pageYOffset - coordTooltip.height - 8;
    			
    			// bottom
    			} else {

    				if (status.left && status.right) position.name = 'bottom-left';
    				if (!status.left && status.right) position.name = 'bottom';
    				
    				position.top = coordTrigger.top + window.pageYOffset + coordTrigger.height + 8;

    			}


    			position.left = (status.left) ? (coordTrigger.left - 5) : position.left;
    			position.left = (!status.left && !status.right) ? (coordTrigger.right - this.$container.offsetWidth + 5) : position.left;


    			// result
    			this.$options.position = position.name;	
    			this.$container.classList.add(position.name);	
    			this.$container.style.top  = `${position.top}px`;
    			this.$container.style.left = `${position.left}px`;	

    		}


    		bottom() {

    			let coordTrigger = this.$trigger.getBoundingClientRect(),
    				coordTooltip = this.$container.getBoundingClientRect(),
    				position = {
    					top: 0,
    					name: '',
    					left: coordTrigger.left  + (coordTrigger.width / 2) - (this.$container.offsetWidth / 2)
    				};


    			if (coordTrigger.bottom < (window.innerHeight - 20)) {

    				if (position.left >= 0) position.name = 'bottom';
    				if (position.left < 0)  position.name = 'bottom-left';
    				
    				position.top = coordTrigger.top + window.pageYOffset + coordTrigger.height + 8;
    			
    			} else {

    				if (position.left >= 0) position.name = 'top';
    				if (position.left < 0)  position.name = 'top-left';
    					    		
    	    		position.top = coordTrigger.top + window.pageYOffset - coordTooltip.height - 8;
    			
    			}

    	
    			position.left = (position.left < 0) ? coordTrigger.left : position.left;


    			// result
    			this.$options.position = position.name;	
    			this.$container.classList.add(position.name);	
    			this.$container.style.top  = `${position.top}px`;
    			this.$container.style.left = `${position.left}px`;
    		
    		}


    		left() {

    			let coordTrigger = this.$trigger.getBoundingClientRect(),
    				coordTooltip = this.$container.getBoundingClientRect(),
    				positionLeft = coordTrigger.left - coordTooltip.width - 8;

    				
    			if (positionLeft > 0) {

    				this.$options.position = 'left';

    	    		this.$container.classList.add('left');
    				this.$container.style.top = `${coordTrigger.top + window.pageYOffset + (coordTrigger.height / 2) - (coordTooltip.height / 2)}px`;
    				this.$container.style.left = `${positionLeft}px`;

    			} else {
    				
    				this.top();
    			
    			}
    		
    		}


    		right() {

    			let coordTrigger = this.$trigger.getBoundingClientRect(),
    				coordTooltip = this.$container.getBoundingClientRect(),
    				positionRight = coordTrigger.right + 8;


    			if ((positionRight + this.$container.getBoundingClientRect().width) < window.innerWidth) {

    				this.$options.position = 'right';

    	    		this.$container.classList.add('right');					
    				this.$container.style.top = `${coordTrigger.top + window.pageYOffset + (coordTrigger.height / 2) - (coordTooltip.height / 2)}px`;
    				this.$container.style.left = `${positionRight}px`;

    			} else {

    				this.top();
    			
    			}
    		
    		}

    	}


    	let active = null;


    	/**
    	 * Tooltip initialization
    	 * @param {object|string} config - configuration tooltip
    	 */
    	const init = (config) => {

    		let container = null,
    			options = config || {},			
    			elements = BasicCore.variables(options.trigger, '[data-tooltip-content]');

    			
    		// build container
    		container = document.createElement('div');		
    		container.classList.add('tooltip');
    		container.setAttribute('role', 'tooltip');			
    		container.innerHTML = '<div class="tooltip-content"></div>';				
    		
    		document.body.appendChild(container);
    		// /build container


    		try {

    			if (elements == false && options.tooltip !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && options.tooltip !== undefined) throw new Error(BasicCore.logging['error']['type']);
    	
    			elements.forEach((value) => {

    				options.trigger = value;
    				active = new Core(options);
    				active.init();
    				
    			});

    			return active;
    		
    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Tooltip init. \nMessage: ${error.message} \nElement: `, options.trigger);

    		}

    	};


    	return { init };

    })();


    window.BasicTooltip = BasicTooltip;
    // --- /ToolTip ---

    !function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).IMask={});}(undefined,(function(t){var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=function(t){return t&&t.Math==Math&&t},i=n("object"==typeof globalThis&&globalThis)||n("object"==typeof window&&window)||n("object"==typeof self&&self)||n("object"==typeof e&&e)||function(){return this}()||Function("return this")(),r={},u=function(t){try{return !!t()}catch(t){return !0}},s=!u((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),a=!u((function(){var t=function(){}.bind();return "function"!=typeof t||t.hasOwnProperty("prototype")})),o=a,l=Function.prototype.call,h=o?l.bind(l):function(){return l.apply(l,arguments)},c={},f={}.propertyIsEnumerable,p=Object.getOwnPropertyDescriptor,d=p&&!f.call({1:2},1);c.f=d?function(t){var e=p(this,t);return !!e&&e.enumerable}:f;var v,g,k=function(t,e){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},y=a,m=Function.prototype,b=m.bind,_=m.call,A=y&&b.bind(_,_),C=y?function(t){return t&&A(t)}:function(t){return t&&function(){return _.apply(t,arguments)}},E=C,F=E({}.toString),S=E("".slice),w=function(t){return S(F(t),8,-1)},B=C,D=u,x=w,M=i.Object,O=B("".split),P=D((function(){return !M("z").propertyIsEnumerable(0)}))?function(t){return "String"==x(t)?O(t,""):M(t)}:M,T=i.TypeError,I=function(t){if(null==t)throw T("Can't call method on "+t);return t},j=P,R=I,V=function(t){return j(R(t))},L=function(t){return "function"==typeof t},N=L,U=function(t){return "object"==typeof t?null!==t:N(t)},z=i,q=L,H=function(t){return q(t)?t:void 0},Y=function(t,e){return arguments.length<2?H(z[t]):z[t]&&z[t][e]},Z=C({}.isPrototypeOf),G=Y("navigator","userAgent")||"",K=i,$=G,W=K.process,X=K.Deno,J=W&&W.versions||X&&X.version,Q=J&&J.v8;Q&&(g=(v=Q.split("."))[0]>0&&v[0]<4?1:+(v[0]+v[1])),!g&&$&&(!(v=$.match(/Edge\/(\d+)/))||v[1]>=74)&&(v=$.match(/Chrome\/(\d+)/))&&(g=+v[1]);var tt=g,et=u,nt=!!Object.getOwnPropertySymbols&&!et((function(){var t=Symbol();return !String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&tt&&tt<41})),it=nt&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,rt=Y,ut=L,st=Z,at=it,ot=i.Object,lt=at?function(t){return "symbol"==typeof t}:function(t){var e=rt("Symbol");return ut(e)&&st(e.prototype,ot(t))},ht=i.String,ct=L,ft=function(t){try{return ht(t)}catch(t){return "Object"}},pt=i.TypeError,dt=function(t){if(ct(t))return t;throw pt(ft(t)+" is not a function")},vt=h,gt=L,kt=U,yt=i.TypeError,mt={exports:{}},bt=i,_t=Object.defineProperty,At=function(t,e){try{_t(bt,t,{value:e,configurable:!0,writable:!0});}catch(n){bt[t]=e;}return e},Ct=At,Et="__core-js_shared__",Ft=i[Et]||Ct(Et,{}),St=Ft;(mt.exports=function(t,e){return St[t]||(St[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.21.0",mode:"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.21.0/LICENSE",source:"https://github.com/zloirock/core-js"});var wt=I,Bt=i.Object,Dt=function(t){return Bt(wt(t))},xt=Dt,Mt=C({}.hasOwnProperty),Ot=Object.hasOwn||function(t,e){return Mt(xt(t),e)},Pt=C,Tt=0,It=Math.random(),jt=Pt(1..toString),Rt=function(t){return "Symbol("+(void 0===t?"":t)+")_"+jt(++Tt+It,36)},Vt=i,Lt=mt.exports,Nt=Ot,Ut=Rt,zt=nt,qt=it,Ht=Lt("wks"),Yt=Vt.Symbol,Zt=Yt&&Yt.for,Gt=qt?Yt:Yt&&Yt.withoutSetter||Ut,Kt=function(t){if(!Nt(Ht,t)||!zt&&"string"!=typeof Ht[t]){var e="Symbol."+t;zt&&Nt(Yt,t)?Ht[t]=Yt[t]:Ht[t]=qt&&Zt?Zt(e):Gt(e);}return Ht[t]},$t=h,Wt=U,Xt=lt,Jt=function(t,e){var n=t[e];return null==n?void 0:dt(n)},Qt=function(t,e){var n,i;if("string"===e&&gt(n=t.toString)&&!kt(i=vt(n,t)))return i;if(gt(n=t.valueOf)&&!kt(i=vt(n,t)))return i;if("string"!==e&&gt(n=t.toString)&&!kt(i=vt(n,t)))return i;throw yt("Can't convert object to primitive value")},te=Kt,ee=i.TypeError,ne=te("toPrimitive"),ie=function(t,e){if(!Wt(t)||Xt(t))return t;var n,i=Jt(t,ne);if(i){if(void 0===e&&(e="default"),n=$t(i,t,e),!Wt(n)||Xt(n))return n;throw ee("Can't convert object to primitive value")}return void 0===e&&(e="number"),Qt(t,e)},re=lt,ue=function(t){var e=ie(t,"string");return re(e)?e:e+""},se=U,ae=i.document,oe=se(ae)&&se(ae.createElement),le=function(t){return oe?ae.createElement(t):{}},he=!s&&!u((function(){return 7!=Object.defineProperty(le("div"),"a",{get:function(){return 7}}).a})),ce=s,fe=h,pe=c,de=k,ve=V,ge=ue,ke=Ot,ye=he,me=Object.getOwnPropertyDescriptor;r.f=ce?me:function(t,e){if(t=ve(t),e=ge(e),ye)try{return me(t,e)}catch(t){}if(ke(t,e))return de(!fe(pe.f,t,e),t[e])};var be={},_e=s&&u((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype})),Ae=i,Ce=U,Ee=Ae.String,Fe=Ae.TypeError,Se=function(t){if(Ce(t))return t;throw Fe(Ee(t)+" is not an object")},we=s,Be=he,De=_e,xe=Se,Me=ue,Oe=i.TypeError,Pe=Object.defineProperty,Te=Object.getOwnPropertyDescriptor,Ie="enumerable",je="configurable",Re="writable";be.f=we?De?function(t,e,n){if(xe(t),e=Me(e),xe(n),"function"==typeof t&&"prototype"===e&&"value"in n&&Re in n&&!n.writable){var i=Te(t,e);i&&i.writable&&(t[e]=n.value,n={configurable:je in n?n.configurable:i.configurable,enumerable:Ie in n?n.enumerable:i.enumerable,writable:!1});}return Pe(t,e,n)}:Pe:function(t,e,n){if(xe(t),e=Me(e),xe(n),Be)try{return Pe(t,e,n)}catch(t){}if("get"in n||"set"in n)throw Oe("Accessors not supported");return "value"in n&&(t[e]=n.value),t};var Ve=be,Le=k,Ne=s?function(t,e,n){return Ve.f(t,e,Le(1,n))}:function(t,e,n){return t[e]=n,t},Ue={exports:{}},ze=L,qe=Ft,He=C(Function.toString);ze(qe.inspectSource)||(qe.inspectSource=function(t){return He(t)});var Ye,Ze,Ge,Ke=qe.inspectSource,$e=L,We=Ke,Xe=i.WeakMap,Je=$e(Xe)&&/native code/.test(We(Xe)),Qe=mt.exports,tn=Rt,en=Qe("keys"),nn={},rn=Je,un=i,sn=C,an=U,on=Ne,ln=Ot,hn=Ft,cn=function(t){return en[t]||(en[t]=tn(t))},fn=nn,pn="Object already initialized",dn=un.TypeError,vn=un.WeakMap;if(rn||hn.state){var gn=hn.state||(hn.state=new vn),kn=sn(gn.get),yn=sn(gn.has),mn=sn(gn.set);Ye=function(t,e){if(yn(gn,t))throw new dn(pn);return e.facade=t,mn(gn,t,e),e},Ze=function(t){return kn(gn,t)||{}},Ge=function(t){return yn(gn,t)};}else {var bn=cn("state");fn[bn]=!0,Ye=function(t,e){if(ln(t,bn))throw new dn(pn);return e.facade=t,on(t,bn,e),e},Ze=function(t){return ln(t,bn)?t[bn]:{}},Ge=function(t){return ln(t,bn)};}var _n={set:Ye,get:Ze,has:Ge,enforce:function(t){return Ge(t)?Ze(t):Ye(t,{})},getterFor:function(t){return function(e){var n;if(!an(e)||(n=Ze(e)).type!==t)throw dn("Incompatible receiver, "+t+" required");return n}}},An=s,Cn=Ot,En=Function.prototype,Fn=An&&Object.getOwnPropertyDescriptor,Sn=Cn(En,"name"),wn=Sn&&"something"===function(){}.name,Bn=Sn&&(!An||An&&Fn(En,"name").configurable),Dn=i,xn=L,Mn=Ot,On=Ne,Pn=At,Tn=Ke,In={EXISTS:Sn,PROPER:wn,CONFIGURABLE:Bn}.CONFIGURABLE,jn=_n.get,Rn=_n.enforce,Vn=String(String).split("String");(Ue.exports=function(t,e,n,i){var r,u=!!i&&!!i.unsafe,s=!!i&&!!i.enumerable,a=!!i&&!!i.noTargetGet,o=i&&void 0!==i.name?i.name:e;xn(n)&&("Symbol("===String(o).slice(0,7)&&(o="["+String(o).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Mn(n,"name")||In&&n.name!==o)&&On(n,"name",o),(r=Rn(n)).source||(r.source=Vn.join("string"==typeof o?o:""))),t!==Dn?(u?!a&&t[e]&&(s=!0):delete t[e],s?t[e]=n:On(t,e,n)):s?t[e]=n:Pn(e,n);})(Function.prototype,"toString",(function(){return xn(this)&&jn(this).source||Tn(this)}));var Ln={},Nn=Math.ceil,Un=Math.floor,zn=function(t){var e=+t;return e!=e||0===e?0:(e>0?Un:Nn)(e)},qn=zn,Hn=Math.max,Yn=Math.min,Zn=zn,Gn=Math.min,Kn=function(t){return t>0?Gn(Zn(t),9007199254740991):0},$n=Kn,Wn=V,Xn=function(t,e){var n=qn(t);return n<0?Hn(n+e,0):Yn(n,e)},Jn=function(t){return $n(t.length)},Qn=function(t){return function(e,n,i){var r,u=Wn(e),s=Jn(u),a=Xn(i,s);if(t&&n!=n){for(;s>a;)if((r=u[a++])!=r)return !0}else for(;s>a;a++)if((t||a in u)&&u[a]===n)return t||a||0;return !t&&-1}},ti={includes:Qn(!0),indexOf:Qn(!1)},ei=Ot,ni=V,ii=ti.indexOf,ri=nn,ui=C([].push),si=function(t,e){var n,i=ni(t),r=0,u=[];for(n in i)!ei(ri,n)&&ei(i,n)&&ui(u,n);for(;e.length>r;)ei(i,n=e[r++])&&(~ii(u,n)||ui(u,n));return u},ai=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],oi=si,li=ai.concat("length","prototype");Ln.f=Object.getOwnPropertyNames||function(t){return oi(t,li)};var hi={};hi.f=Object.getOwnPropertySymbols;var ci=Y,fi=Ln,pi=hi,di=Se,vi=C([].concat),gi=ci("Reflect","ownKeys")||function(t){var e=fi.f(di(t)),n=pi.f;return n?vi(e,n(t)):e},ki=Ot,yi=gi,mi=r,bi=be,_i=u,Ai=L,Ci=/#|\.prototype\./,Ei=function(t,e){var n=Si[Fi(t)];return n==Bi||n!=wi&&(Ai(e)?_i(e):!!e)},Fi=Ei.normalize=function(t){return String(t).replace(Ci,".").toLowerCase()},Si=Ei.data={},wi=Ei.NATIVE="N",Bi=Ei.POLYFILL="P",Di=Ei,xi=i,Mi=r.f,Oi=Ne,Pi=Ue.exports,Ti=At,Ii=function(t,e,n){for(var i=yi(e),r=bi.f,u=mi.f,s=0;s<i.length;s++){var a=i[s];ki(t,a)||n&&ki(n,a)||r(t,a,u(e,a));}},ji=Di,Ri=function(t,e){var n,i,r,u,s,a=t.target,o=t.global,l=t.stat;if(n=o?xi:l?xi[a]||Ti(a,{}):(xi[a]||{}).prototype)for(i in e){if(u=e[i],r=t.noTargetGet?(s=Mi(n,i))&&s.value:n[i],!ji(o?i:a+(l?".":"#")+i,t.forced)&&void 0!==r){if(typeof u==typeof r)continue;Ii(u,r);}(t.sham||r&&r.sham)&&Oi(u,"sham",!0),Pi(n,i,u,t);}},Vi=si,Li=ai,Ni=Object.keys||function(t){return Vi(t,Li)},Ui=s,zi=C,qi=h,Hi=u,Yi=Ni,Zi=hi,Gi=c,Ki=Dt,$i=P,Wi=Object.assign,Xi=Object.defineProperty,Ji=zi([].concat),Qi=!Wi||Hi((function(){if(Ui&&1!==Wi({b:1},Wi(Xi({},"a",{enumerable:!0,get:function(){Xi(this,"b",{value:3,enumerable:!1});}}),{b:2})).b)return !0;var t={},e={},n=Symbol(),i="abcdefghijklmnopqrst";return t[n]=7,i.split("").forEach((function(t){e[t]=t;})),7!=Wi({},t)[n]||Yi(Wi({},e)).join("")!=i}))?function(t,e){for(var n=Ki(t),i=arguments.length,r=1,u=Zi.f,s=Gi.f;i>r;)for(var a,o=$i(arguments[r++]),l=u?Ji(Yi(o),u(o)):Yi(o),h=l.length,c=0;h>c;)a=l[c++],Ui&&!qi(s,o,a)||(n[a]=o[a]);return n}:Wi,tr=Qi;Ri({target:"Object",stat:!0,forced:Object.assign!==tr},{assign:tr});var er={};er[Kt("toStringTag")]="z";var nr=i,ir="[object z]"===String(er),rr=L,ur=w,sr=Kt("toStringTag"),ar=nr.Object,or="Arguments"==ur(function(){return arguments}()),lr=ir?ur:function(t){var e,n,i;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=ar(t),sr))?n:or?ur(e):"Object"==(i=ur(e))&&rr(e.callee)?"Arguments":i},hr=i.String,cr=function(t){if("Symbol"===lr(t))throw TypeError("Cannot convert a Symbol value to a string");return hr(t)},fr=zn,pr=cr,dr=I,vr=i.RangeError,gr=function(t){var e=pr(dr(this)),n="",i=fr(t);if(i<0||i==1/0)throw vr("Wrong number of repetitions");for(;i>0;(i>>>=1)&&(e+=e))1&i&&(n+=e);return n};Ri({target:"String",proto:!0},{repeat:gr});var kr=C,yr=Kn,mr=cr,br=I,_r=kr(gr),Ar=kr("".slice),Cr=Math.ceil,Er=function(t){return function(e,n,i){var r,u,s=mr(br(e)),a=yr(n),o=s.length,l=void 0===i?" ":mr(i);return a<=o||""==l?s:((u=_r(l,Cr((r=a-o)/l.length))).length>r&&(u=Ar(u,0,r)),t?s+u:u+s)}},Fr={start:Er(!1),end:Er(!0)},Sr=/Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(G),wr=Fr.start;Ri({target:"String",proto:!0,forced:Sr},{padStart:function(t){return wr(this,t,arguments.length>1?arguments[1]:void 0)}});var Br=Fr.end;function Dr(t){return Dr="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Dr(t)}function xr(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Mr(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i);}}function Or(t,e,n){return e&&Mr(t.prototype,e),n&&Mr(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function Pr(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Ir(t,e);}function Tr(t){return Tr=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},Tr(t)}function Ir(t,e){return Ir=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},Ir(t,e)}function jr(t,e){if(null==t)return {};var n,i,r=function(t,e){if(null==t)return {};var n,i,r={},u=Object.keys(t);for(i=0;i<u.length;i++)n=u[i],e.indexOf(n)>=0||(r[n]=t[n]);return r}(t,e);if(Object.getOwnPropertySymbols){var u=Object.getOwnPropertySymbols(t);for(i=0;i<u.length;i++)n=u[i],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(t,n)&&(r[n]=t[n]);}return r}function Rr(t,e){if(e&&("object"==typeof e||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t)}function Vr(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return !1}}();return function(){var n,i=Tr(t);if(e){var r=Tr(this).constructor;n=Reflect.construct(i,arguments,r);}else n=i.apply(this,arguments);return Rr(this,n)}}function Lr(t,e){for(;!Object.prototype.hasOwnProperty.call(t,e)&&null!==(t=Tr(t)););return t}function Nr(){return Nr="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(t,e,n){var i=Lr(t,e);if(i){var r=Object.getOwnPropertyDescriptor(i,e);return r.get?r.get.call(arguments.length<3?t:n):r.value}},Nr.apply(this,arguments)}function Ur(t,e,n,i){return Ur="undefined"!=typeof Reflect&&Reflect.set?Reflect.set:function(t,e,n,i){var r,u=Lr(t,e);if(u){if((r=Object.getOwnPropertyDescriptor(u,e)).set)return r.set.call(i,n),!0;if(!r.writable)return !1}if(r=Object.getOwnPropertyDescriptor(i,e)){if(!r.writable)return !1;r.value=n,Object.defineProperty(i,e,r);}else !function(t,e,n){e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n;}(i,e,n);return !0},Ur(t,e,n,i)}function zr(t,e,n,i,r){if(!Ur(t,e,n,i||t)&&r)throw new Error("failed to set property");return n}function qr(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var n=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==n)return;var i,r,u=[],s=!0,a=!1;try{for(n=n.call(t);!(s=(i=n.next()).done)&&(u.push(i.value),!e||u.length!==e);s=!0);}catch(t){a=!0,r=t;}finally{try{s||null==n.return||n.return();}finally{if(a)throw r}}return u}(t,e)||function(t,e){if(!t)return;if("string"==typeof t)return Hr(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return Hr(t,e)}(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Hr(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,i=new Array(e);n<e;n++)i[n]=t[n];return i}Ri({target:"String",proto:!0,forced:Sr},{padEnd:function(t){return Br(this,t,arguments.length>1?arguments[1]:void 0)}}),Ri({global:!0},{globalThis:i});var Yr=function(){function t(e){xr(this,t),Object.assign(this,{inserted:"",rawInserted:"",skip:!1,tailShift:0},e);}return Or(t,[{key:"aggregate",value:function(t){return this.rawInserted+=t.rawInserted,this.skip=this.skip||t.skip,this.inserted+=t.inserted,this.tailShift+=t.tailShift,this}},{key:"offset",get:function(){return this.tailShift+this.inserted.length}}]),t}();function Zr(t){return "string"==typeof t||t instanceof String}var Gr="NONE",Kr="LEFT",$r="FORCE_LEFT",Wr="RIGHT",Xr="FORCE_RIGHT";function Jr(t){return t.replace(/([.*+?^=!:${}()|[\]\/\\])/g,"\\$1")}function Qr(t){return Array.isArray(t)?t:[t,new Yr]}function tu(t,e){if(e===t)return !0;var n,i=Array.isArray(e),r=Array.isArray(t);if(i&&r){if(e.length!=t.length)return !1;for(n=0;n<e.length;n++)if(!tu(e[n],t[n]))return !1;return !0}if(i!=r)return !1;if(e&&t&&"object"===Dr(e)&&"object"===Dr(t)){var u=e instanceof Date,s=t instanceof Date;if(u&&s)return e.getTime()==t.getTime();if(u!=s)return !1;var a=e instanceof RegExp,o=t instanceof RegExp;if(a&&o)return e.toString()==t.toString();if(a!=o)return !1;var l=Object.keys(e);for(n=0;n<l.length;n++)if(!Object.prototype.hasOwnProperty.call(t,l[n]))return !1;for(n=0;n<l.length;n++)if(!tu(t[l[n]],e[l[n]]))return !1;return !0}return !(!e||!t||"function"!=typeof e||"function"!=typeof t)&&e.toString()===t.toString()}var eu=function(){function t(e,n,i,r){for(xr(this,t),this.value=e,this.cursorPos=n,this.oldValue=i,this.oldSelection=r;this.value.slice(0,this.startChangePos)!==this.oldValue.slice(0,this.startChangePos);)--this.oldSelection.start;}return Or(t,[{key:"startChangePos",get:function(){return Math.min(this.cursorPos,this.oldSelection.start)}},{key:"insertedCount",get:function(){return this.cursorPos-this.startChangePos}},{key:"inserted",get:function(){return this.value.substr(this.startChangePos,this.insertedCount)}},{key:"removedCount",get:function(){return Math.max(this.oldSelection.end-this.startChangePos||this.oldValue.length-this.value.length,0)}},{key:"removed",get:function(){return this.oldValue.substr(this.startChangePos,this.removedCount)}},{key:"head",get:function(){return this.value.substring(0,this.startChangePos)}},{key:"tail",get:function(){return this.value.substring(this.startChangePos+this.insertedCount)}},{key:"removeDirection",get:function(){return !this.removedCount||this.insertedCount?Gr:this.oldSelection.end!==this.cursorPos&&this.oldSelection.start!==this.cursorPos||this.oldSelection.end!==this.oldSelection.start?Kr:Wr}}]),t}(),nu=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2?arguments[2]:void 0;xr(this,t),this.value=e,this.from=n,this.stop=i;}return Or(t,[{key:"toString",value:function(){return this.value}},{key:"extend",value:function(t){this.value+=String(t);}},{key:"appendTo",value:function(t){return t.append(this.toString(),{tail:!0}).aggregate(t._appendPlaceholder())}},{key:"state",get:function(){return {value:this.value,from:this.from,stop:this.stop}},set:function(t){Object.assign(this,t);}},{key:"unshift",value:function(t){if(!this.value.length||null!=t&&this.from>=t)return "";var e=this.value[0];return this.value=this.value.slice(1),e}},{key:"shift",value:function(){if(!this.value.length)return "";var t=this.value[this.value.length-1];return this.value=this.value.slice(0,-1),t}}]),t}();function iu(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return new iu.InputMask(t,e)}var ru=function(){function t(e){xr(this,t),this._value="",this._update(Object.assign({},t.DEFAULTS,e)),this.isInitialized=!0;}return Or(t,[{key:"updateOptions",value:function(t){Object.keys(t).length&&this.withValueRefresh(this._update.bind(this,t));}},{key:"_update",value:function(t){Object.assign(this,t);}},{key:"state",get:function(){return {_value:this.value}},set:function(t){this._value=t._value;}},{key:"reset",value:function(){this._value="";}},{key:"value",get:function(){return this._value},set:function(t){this.resolve(t);}},{key:"resolve",value:function(t){return this.reset(),this.append(t,{input:!0},""),this.doCommit(),this.value}},{key:"unmaskedValue",get:function(){return this.value},set:function(t){this.reset(),this.append(t,{},""),this.doCommit();}},{key:"typedValue",get:function(){return this.doParse(this.value)},set:function(t){this.value=this.doFormat(t);}},{key:"rawInputValue",get:function(){return this.extractInput(0,this.value.length,{raw:!0})},set:function(t){this.reset(),this.append(t,{raw:!0},""),this.doCommit();}},{key:"isComplete",get:function(){return !0}},{key:"isFilled",get:function(){return this.isComplete}},{key:"nearestInputPos",value:function(t,e){return t}},{key:"extractInput",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length;return this.value.slice(t,e)}},{key:"extractTail",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length;return new nu(this.extractInput(t,e),t)}},{key:"appendTail",value:function(t){return Zr(t)&&(t=new nu(String(t))),t.appendTo(this)}},{key:"_appendCharRaw",value:function(t){return t?(this._value+=t,new Yr({inserted:t,rawInserted:t})):new Yr}},{key:"_appendChar",value:function(t){var e,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2?arguments[2]:void 0,r=this.state,u=Qr(this.doPrepare(t,n)),s=qr(u,2);if(t=s[0],(e=(e=s[1]).aggregate(this._appendCharRaw(t,n))).inserted){var a,o=!1!==this.doValidate(n);if(o&&null!=i){var l=this.state;!0===this.overwrite&&(a=i.state,i.unshift(this.value.length));var h=this.appendTail(i);(o=h.rawInserted===i.toString())&&h.inserted||"shift"!==this.overwrite||(this.state=l,a=i.state,i.shift(),o=(h=this.appendTail(i)).rawInserted===i.toString()),o&&h.inserted&&(this.state=l);}o||(e=new Yr,this.state=r,i&&a&&(i.state=a));}return e}},{key:"_appendPlaceholder",value:function(){return new Yr}},{key:"_appendEager",value:function(){return new Yr}},{key:"append",value:function(t,e,n){if(!Zr(t))throw new Error("value should be string");var i=new Yr,r=Zr(n)?new nu(String(n)):n;e&&e.tail&&(e._beforeTailState=this.state);for(var u=0;u<t.length;++u)i.aggregate(this._appendChar(t[u],e,r));return null!=r&&(i.tailShift+=this.appendTail(r).tailShift),this.eager&&null!=e&&e.input&&t&&i.aggregate(this._appendEager()),i}},{key:"remove",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length;return this._value=this.value.slice(0,t)+this.value.slice(e),new Yr}},{key:"withValueRefresh",value:function(t){if(this._refreshing||!this.isInitialized)return t();this._refreshing=!0;var e=this.rawInputValue,n=this.value,i=t();return this.rawInputValue=e,this.value&&this.value!==n&&0===n.indexOf(this.value)&&this.append(n.slice(this.value.length),{},""),delete this._refreshing,i}},{key:"runIsolated",value:function(t){if(this._isolated||!this.isInitialized)return t(this);this._isolated=!0;var e=this.state,n=t(this);return this.state=e,delete this._isolated,n}},{key:"doPrepare",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.prepare?this.prepare(t,this,e):t}},{key:"doValidate",value:function(t){return (!this.validate||this.validate(this.value,this,t))&&(!this.parent||this.parent.doValidate(t))}},{key:"doCommit",value:function(){this.commit&&this.commit(this.value,this);}},{key:"doFormat",value:function(t){return this.format?this.format(t,this):t}},{key:"doParse",value:function(t){return this.parse?this.parse(t,this):t}},{key:"splice",value:function(t,e,n,i){var r,u=t+e,s=this.extractTail(u);this.eager&&(i=function(t){switch(t){case Kr:return $r;case Wr:return Xr;default:return t}}(i),r=this.extractInput(0,u,{raw:!0}));var a=this.nearestInputPos(t,e>1&&0!==t&&!this.eager?Gr:i),o=new Yr({tailShift:a-t}).aggregate(this.remove(a));if(this.eager&&i!==Gr&&r===this.rawInputValue)if(i===$r)for(var l;r===this.rawInputValue&&(l=this.value.length);)o.aggregate(new Yr({tailShift:-1})).aggregate(this.remove(l-1));else i===Xr&&s.unshift();return o.aggregate(this.append(n,{input:!0},s))}},{key:"maskEquals",value:function(t){return this.mask===t}}]),t}();function uu(t){if(null==t)throw new Error("mask property should be defined");return t instanceof RegExp?iu.MaskedRegExp:Zr(t)?iu.MaskedPattern:t instanceof Date||t===Date?iu.MaskedDate:t instanceof Number||"number"==typeof t||t===Number?iu.MaskedNumber:Array.isArray(t)||t===Array?iu.MaskedDynamic:iu.Masked&&t.prototype instanceof iu.Masked?t:t instanceof iu.Masked?t.constructor:t instanceof Function?iu.MaskedFunction:(console.warn("Mask not found for mask",t),iu.Masked)}function su(t){if(iu.Masked&&t instanceof iu.Masked)return t;var e=(t=Object.assign({},t)).mask;if(iu.Masked&&e instanceof iu.Masked)return e;var n=uu(e);if(!n)throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");return new n(t)}ru.DEFAULTS={format:function(t){return t},parse:function(t){return t}},iu.Masked=ru,iu.createMask=su;var au=["mask"],ou={0:/\d/,a:/[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,"*":/./},lu=function(){function t(e){xr(this,t);var n=e.mask,i=jr(e,au);this.masked=su({mask:n}),Object.assign(this,i);}return Or(t,[{key:"reset",value:function(){this.isFilled=!1,this.masked.reset();}},{key:"remove",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length;return 0===t&&e>=1?(this.isFilled=!1,this.masked.remove(t,e)):new Yr}},{key:"value",get:function(){return this.masked.value||(this.isFilled&&!this.isOptional?this.placeholderChar:"")}},{key:"unmaskedValue",get:function(){return this.masked.unmaskedValue}},{key:"isComplete",get:function(){return Boolean(this.masked.value)||this.isOptional}},{key:"_appendChar",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this.isFilled)return new Yr;var n=this.masked.state,i=this.masked._appendChar(t,e);return i.inserted&&!1===this.doValidate(e)&&(i.inserted=i.rawInserted="",this.masked.state=n),i.inserted||this.isOptional||this.lazy||e.input||(i.inserted=this.placeholderChar),i.skip=!i.inserted&&!this.isOptional,this.isFilled=Boolean(i.inserted),i}},{key:"append",value:function(){var t;return (t=this.masked).append.apply(t,arguments)}},{key:"_appendPlaceholder",value:function(){var t=new Yr;return this.isFilled||this.isOptional||(this.isFilled=!0,t.inserted=this.placeholderChar),t}},{key:"_appendEager",value:function(){return new Yr}},{key:"extractTail",value:function(){var t;return (t=this.masked).extractTail.apply(t,arguments)}},{key:"appendTail",value:function(){var t;return (t=this.masked).appendTail.apply(t,arguments)}},{key:"extractInput",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,n=arguments.length>2?arguments[2]:void 0;return this.masked.extractInput(t,e,n)}},{key:"nearestInputPos",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Gr,n=0,i=this.value.length,r=Math.min(Math.max(t,n),i);switch(e){case Kr:case $r:return this.isComplete?r:n;case Wr:case Xr:return this.isComplete?r:i;default:return r}}},{key:"doValidate",value:function(){var t,e;return (t=this.masked).doValidate.apply(t,arguments)&&(!this.parent||(e=this.parent).doValidate.apply(e,arguments))}},{key:"doCommit",value:function(){this.masked.doCommit();}},{key:"state",get:function(){return {masked:this.masked.state,isFilled:this.isFilled}},set:function(t){this.masked.state=t.masked,this.isFilled=t.isFilled;}}]),t}(),hu=function(){function t(e){xr(this,t),Object.assign(this,e),this._value="",this.isFixed=!0;}return Or(t,[{key:"value",get:function(){return this._value}},{key:"unmaskedValue",get:function(){return this.isUnmasking?this.value:""}},{key:"reset",value:function(){this._isRawInput=!1,this._value="";}},{key:"remove",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._value.length;return this._value=this._value.slice(0,t)+this._value.slice(e),this._value||(this._isRawInput=!1),new Yr}},{key:"nearestInputPos",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Gr,n=0,i=this._value.length;switch(e){case Kr:case $r:return n;default:return i}}},{key:"extractInput",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._value.length,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return n.raw&&this._isRawInput&&this._value.slice(t,e)||""}},{key:"isComplete",get:function(){return !0}},{key:"isFilled",get:function(){return Boolean(this._value)}},{key:"_appendChar",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new Yr;if(this._value)return n;var i=this.char===t,r=i&&(this.isUnmasking||e.input||e.raw)&&!this.eager&&!e.tail;return r&&(n.rawInserted=this.char),this._value=n.inserted=this.char,this._isRawInput=r&&(e.raw||e.input),n}},{key:"_appendEager",value:function(){return this._appendChar(this.char)}},{key:"_appendPlaceholder",value:function(){var t=new Yr;return this._value||(this._value=t.inserted=this.char),t}},{key:"extractTail",value:function(){return arguments.length>1&&void 0!==arguments[1]||this.value.length,new nu("")}},{key:"appendTail",value:function(t){return Zr(t)&&(t=new nu(String(t))),t.appendTo(this)}},{key:"append",value:function(t,e,n){var i=this._appendChar(t[0],e);return null!=n&&(i.tailShift+=this.appendTail(n).tailShift),i}},{key:"doCommit",value:function(){}},{key:"state",get:function(){return {_value:this._value,_isRawInput:this._isRawInput}},set:function(t){Object.assign(this,t);}}]),t}(),cu=["chunks"],fu=function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;xr(this,t),this.chunks=e,this.from=n;}return Or(t,[{key:"toString",value:function(){return this.chunks.map(String).join("")}},{key:"extend",value:function(e){if(String(e)){Zr(e)&&(e=new nu(String(e)));var n=this.chunks[this.chunks.length-1],i=n&&(n.stop===e.stop||null==e.stop)&&e.from===n.from+n.toString().length;if(e instanceof nu)i?n.extend(e.toString()):this.chunks.push(e);else if(e instanceof t){if(null==e.stop)for(var r;e.chunks.length&&null==e.chunks[0].stop;)(r=e.chunks.shift()).from+=e.from,this.extend(r);e.toString()&&(e.stop=e.blockIndex,this.chunks.push(e));}}}},{key:"appendTo",value:function(e){if(!(e instanceof iu.MaskedPattern))return new nu(this.toString()).appendTo(e);for(var n=new Yr,i=0;i<this.chunks.length&&!n.skip;++i){var r=this.chunks[i],u=e._mapPosToBlock(e.value.length),s=r.stop,a=void 0;if(null!=s&&(!u||u.index<=s)&&((r instanceof t||e._stops.indexOf(s)>=0)&&n.aggregate(e._appendPlaceholder(s)),a=r instanceof t&&e._blocks[s]),a){var o=a.appendTail(r);o.skip=!1,n.aggregate(o),e._value+=o.inserted;var l=r.toString().slice(o.rawInserted.length);l&&n.aggregate(e.append(l,{tail:!0}));}else n.aggregate(e.append(r.toString(),{tail:!0}));}return n}},{key:"state",get:function(){return {chunks:this.chunks.map((function(t){return t.state})),from:this.from,stop:this.stop,blockIndex:this.blockIndex}},set:function(e){var n=e.chunks,i=jr(e,cu);Object.assign(this,i),this.chunks=n.map((function(e){var n="chunks"in e?new t:new nu;return n.state=e,n}));}},{key:"unshift",value:function(t){if(!this.chunks.length||null!=t&&this.from>=t)return "";for(var e=null!=t?t-this.from:t,n=0;n<this.chunks.length;){var i=this.chunks[n],r=i.unshift(e);if(i.toString()){if(!r)break;++n;}else this.chunks.splice(n,1);if(r)return r}return ""}},{key:"shift",value:function(){if(!this.chunks.length)return "";for(var t=this.chunks.length-1;0<=t;){var e=this.chunks[t],n=e.shift();if(e.toString()){if(!n)break;--t;}else this.chunks.splice(t,1);if(n)return n}return ""}}]),t}(),pu=function(){function t(e,n){xr(this,t),this.masked=e,this._log=[];var i=e._mapPosToBlock(n)||(n<0?{index:0,offset:0}:{index:this.masked._blocks.length,offset:0}),r=i.offset,u=i.index;this.offset=r,this.index=u,this.ok=!1;}return Or(t,[{key:"block",get:function(){return this.masked._blocks[this.index]}},{key:"pos",get:function(){return this.masked._blockStartPos(this.index)+this.offset}},{key:"state",get:function(){return {index:this.index,offset:this.offset,ok:this.ok}},set:function(t){Object.assign(this,t);}},{key:"pushState",value:function(){this._log.push(this.state);}},{key:"popState",value:function(){var t=this._log.pop();return this.state=t,t}},{key:"bindBlock",value:function(){this.block||(this.index<0&&(this.index=0,this.offset=0),this.index>=this.masked._blocks.length&&(this.index=this.masked._blocks.length-1,this.offset=this.block.value.length));}},{key:"_pushLeft",value:function(t){for(this.pushState(),this.bindBlock();0<=this.index;--this.index,this.offset=(null===(e=this.block)||void 0===e?void 0:e.value.length)||0){var e;if(t())return this.ok=!0}return this.ok=!1}},{key:"_pushRight",value:function(t){for(this.pushState(),this.bindBlock();this.index<this.masked._blocks.length;++this.index,this.offset=0)if(t())return this.ok=!0;return this.ok=!1}},{key:"pushLeftBeforeFilled",value:function(){var t=this;return this._pushLeft((function(){if(!t.block.isFixed&&t.block.value)return t.offset=t.block.nearestInputPos(t.offset,$r),0!==t.offset||void 0}))}},{key:"pushLeftBeforeInput",value:function(){var t=this;return this._pushLeft((function(){if(!t.block.isFixed)return t.offset=t.block.nearestInputPos(t.offset,Kr),!0}))}},{key:"pushLeftBeforeRequired",value:function(){var t=this;return this._pushLeft((function(){if(!(t.block.isFixed||t.block.isOptional&&!t.block.value))return t.offset=t.block.nearestInputPos(t.offset,Kr),!0}))}},{key:"pushRightBeforeFilled",value:function(){var t=this;return this._pushRight((function(){if(!t.block.isFixed&&t.block.value)return t.offset=t.block.nearestInputPos(t.offset,Xr),t.offset!==t.block.value.length||void 0}))}},{key:"pushRightBeforeInput",value:function(){var t=this;return this._pushRight((function(){if(!t.block.isFixed)return t.offset=t.block.nearestInputPos(t.offset,Gr),!0}))}},{key:"pushRightBeforeRequired",value:function(){var t=this;return this._pushRight((function(){if(!(t.block.isFixed||t.block.isOptional&&!t.block.value))return t.offset=t.block.nearestInputPos(t.offset,Gr),!0}))}}]),t}(),du=function(t){Pr(n,t);var e=Vr(n);function n(){return xr(this,n),e.apply(this,arguments)}return Or(n,[{key:"_update",value:function(t){t.mask&&(t.validate=function(e){return e.search(t.mask)>=0}),Nr(Tr(n.prototype),"_update",this).call(this,t);}}]),n}(ru);iu.MaskedRegExp=du;var vu=["_blocks"],gu=function(t){Pr(n,t);var e=Vr(n);function n(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return xr(this,n),t.definitions=Object.assign({},ou,t.definitions),e.call(this,Object.assign({},n.DEFAULTS,t))}return Or(n,[{key:"_update",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};t.definitions=Object.assign({},this.definitions,t.definitions),Nr(Tr(n.prototype),"_update",this).call(this,t),this._rebuildMask();}},{key:"_rebuildMask",value:function(){var t=this,e=this.definitions;this._blocks=[],this._stops=[],this._maskedBlocks={};var i=this.mask;if(i&&e)for(var r=!1,u=!1,s=0;s<i.length;++s){if(this.blocks)if("continue"===function(){var e=i.slice(s),n=Object.keys(t.blocks).filter((function(t){return 0===e.indexOf(t)}));n.sort((function(t,e){return e.length-t.length}));var r=n[0];if(r){var u=su(Object.assign({parent:t,lazy:t.lazy,eager:t.eager,placeholderChar:t.placeholderChar,overwrite:t.overwrite},t.blocks[r]));return u&&(t._blocks.push(u),t._maskedBlocks[r]||(t._maskedBlocks[r]=[]),t._maskedBlocks[r].push(t._blocks.length-1)),s+=r.length-1,"continue"}}())continue;var a=i[s],o=a in e;if(a!==n.STOP_CHAR)if("{"!==a&&"}"!==a)if("["!==a&&"]"!==a){if(a===n.ESCAPE_CHAR){if(++s,!(a=i[s]))break;o=!1;}var l=o?new lu({parent:this,lazy:this.lazy,eager:this.eager,placeholderChar:this.placeholderChar,mask:e[a],isOptional:u}):new hu({char:a,eager:this.eager,isUnmasking:r});this._blocks.push(l);}else u=!u;else r=!r;else this._stops.push(this._blocks.length);}}},{key:"state",get:function(){return Object.assign({},Nr(Tr(n.prototype),"state",this),{_blocks:this._blocks.map((function(t){return t.state}))})},set:function(t){var e=t._blocks,i=jr(t,vu);this._blocks.forEach((function(t,n){return t.state=e[n]})),zr(Tr(n.prototype),"state",i,this,!0);}},{key:"reset",value:function(){Nr(Tr(n.prototype),"reset",this).call(this),this._blocks.forEach((function(t){return t.reset()}));}},{key:"isComplete",get:function(){return this._blocks.every((function(t){return t.isComplete}))}},{key:"isFilled",get:function(){return this._blocks.every((function(t){return t.isFilled}))}},{key:"isFixed",get:function(){return this._blocks.every((function(t){return t.isFixed}))}},{key:"isOptional",get:function(){return this._blocks.every((function(t){return t.isOptional}))}},{key:"doCommit",value:function(){this._blocks.forEach((function(t){return t.doCommit()})),Nr(Tr(n.prototype),"doCommit",this).call(this);}},{key:"unmaskedValue",get:function(){return this._blocks.reduce((function(t,e){return t+e.unmaskedValue}),"")},set:function(t){zr(Tr(n.prototype),"unmaskedValue",t,this,!0);}},{key:"value",get:function(){return this._blocks.reduce((function(t,e){return t+e.value}),"")},set:function(t){zr(Tr(n.prototype),"value",t,this,!0);}},{key:"appendTail",value:function(t){return Nr(Tr(n.prototype),"appendTail",this).call(this,t).aggregate(this._appendPlaceholder())}},{key:"_appendEager",value:function(){var t,e=new Yr,n=null===(t=this._mapPosToBlock(this.value.length))||void 0===t?void 0:t.index;if(null==n)return e;this._blocks[n].isFilled&&++n;for(var i=n;i<this._blocks.length;++i){var r=this._blocks[i]._appendEager();if(!r.inserted)break;e.aggregate(r);}return e}},{key:"_appendCharRaw",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this._mapPosToBlock(this.value.length),i=new Yr;if(!n)return i;for(var r=n.index;;++r){var u,s=this._blocks[r];if(!s)break;var a=s._appendChar(t,Object.assign({},e,{_beforeTailState:null===(u=e._beforeTailState)||void 0===u?void 0:u._blocks[r]})),o=a.skip;if(i.aggregate(a),o||a.rawInserted)break}return i}},{key:"extractTail",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,i=new fu;return e===n||this._forEachBlocksInRange(e,n,(function(e,n,r,u){var s=e.extractTail(r,u);s.stop=t._findStopBefore(n),s.from=t._blockStartPos(n),s instanceof fu&&(s.blockIndex=n),i.extend(s);})),i}},{key:"extractInput",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(t===e)return "";var i="";return this._forEachBlocksInRange(t,e,(function(t,e,r,u){i+=t.extractInput(r,u,n);})),i}},{key:"_findStopBefore",value:function(t){for(var e,n=0;n<this._stops.length;++n){var i=this._stops[n];if(!(i<=t))break;e=i;}return e}},{key:"_appendPlaceholder",value:function(t){var e=this,n=new Yr;if(this.lazy&&null==t)return n;var i=this._mapPosToBlock(this.value.length);if(!i)return n;var r=i.index,u=null!=t?t:this._blocks.length;return this._blocks.slice(r,u).forEach((function(i){if(!i.lazy||null!=t){var r=null!=i._blocks?[i._blocks.length]:[],u=i._appendPlaceholder.apply(i,r);e._value+=u.inserted,n.aggregate(u);}})),n}},{key:"_mapPosToBlock",value:function(t){for(var e="",n=0;n<this._blocks.length;++n){var i=this._blocks[n],r=e.length;if(t<=(e+=i.value).length)return {index:n,offset:t-r}}}},{key:"_blockStartPos",value:function(t){return this._blocks.slice(0,t).reduce((function(t,e){return t+e.value.length}),0)}},{key:"_forEachBlocksInRange",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,n=arguments.length>2?arguments[2]:void 0,i=this._mapPosToBlock(t);if(i){var r=this._mapPosToBlock(e),u=r&&i.index===r.index,s=i.offset,a=r&&u?r.offset:this._blocks[i.index].value.length;if(n(this._blocks[i.index],i.index,s,a),r&&!u){for(var o=i.index+1;o<r.index;++o)n(this._blocks[o],o,0,this._blocks[o].value.length);n(this._blocks[r.index],r.index,0,r.offset);}}}},{key:"remove",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,i=Nr(Tr(n.prototype),"remove",this).call(this,t,e);return this._forEachBlocksInRange(t,e,(function(t,e,n,r){i.aggregate(t.remove(n,r));})),i}},{key:"nearestInputPos",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Gr;if(!this._blocks.length)return 0;var n=new pu(this,t);if(e===Gr)return n.pushRightBeforeInput()?n.pos:(n.popState(),n.pushLeftBeforeInput()?n.pos:this.value.length);if(e===Kr||e===$r){if(e===Kr){if(n.pushRightBeforeFilled(),n.ok&&n.pos===t)return t;n.popState();}if(n.pushLeftBeforeInput(),n.pushLeftBeforeRequired(),n.pushLeftBeforeFilled(),e===Kr){if(n.pushRightBeforeInput(),n.pushRightBeforeRequired(),n.ok&&n.pos<=t)return n.pos;if(n.popState(),n.ok&&n.pos<=t)return n.pos;n.popState();}return n.ok?n.pos:e===$r?0:(n.popState(),n.ok?n.pos:(n.popState(),n.ok?n.pos:0))}return e===Wr||e===Xr?(n.pushRightBeforeInput(),n.pushRightBeforeRequired(),n.pushRightBeforeFilled()?n.pos:e===Xr?this.value.length:(n.popState(),n.ok?n.pos:(n.popState(),n.ok?n.pos:this.nearestInputPos(t,Kr)))):t}},{key:"maskedBlock",value:function(t){return this.maskedBlocks(t)[0]}},{key:"maskedBlocks",value:function(t){var e=this,n=this._maskedBlocks[t];return n?n.map((function(t){return e._blocks[t]})):[]}}]),n}(ru);gu.DEFAULTS={lazy:!0,placeholderChar:"_"},gu.STOP_CHAR="`",gu.ESCAPE_CHAR="\\",gu.InputDefinition=lu,gu.FixedDefinition=hu,iu.MaskedPattern=gu;var ku=function(t){Pr(n,t);var e=Vr(n);function n(){return xr(this,n),e.apply(this,arguments)}return Or(n,[{key:"_matchFrom",get:function(){return this.maxLength-String(this.from).length}},{key:"_update",value:function(t){t=Object.assign({to:this.to||0,from:this.from||0,maxLength:this.maxLength||0},t);var e=String(t.to).length;null!=t.maxLength&&(e=Math.max(e,t.maxLength)),t.maxLength=e;for(var i=String(t.from).padStart(e,"0"),r=String(t.to).padStart(e,"0"),u=0;u<r.length&&r[u]===i[u];)++u;t.mask=r.slice(0,u).replace(/0/g,"\\0")+"0".repeat(e-u),Nr(Tr(n.prototype),"_update",this).call(this,t);}},{key:"isComplete",get:function(){return Nr(Tr(n.prototype),"isComplete",this)&&Boolean(this.value)}},{key:"boundaries",value:function(t){var e="",n="",i=qr(t.match(/^(\D*)(\d*)(\D*)/)||[],3),r=i[1],u=i[2];return u&&(e="0".repeat(r.length)+u,n="9".repeat(r.length)+u),[e=e.padEnd(this.maxLength,"0"),n=n.padEnd(this.maxLength,"9")]}},{key:"doPrepare",value:function(t){var e,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=Qr(Nr(Tr(n.prototype),"doPrepare",this).call(this,t.replace(/\D/g,""),i)),u=qr(r,2);if(t=u[0],e=u[1],!this.autofix||!t)return t;var s=String(this.from).padStart(this.maxLength,"0"),a=String(this.to).padStart(this.maxLength,"0"),o=this.value+t;if(o.length>this.maxLength)return "";var l=this.boundaries(o),h=qr(l,2),c=h[0],f=h[1];return Number(f)<this.from?s[o.length-1]:Number(c)>this.to?"pad"===this.autofix&&o.length<this.maxLength?["",e.aggregate(this.append(s[o.length-1]+t,i))]:a[o.length-1]:t}},{key:"doValidate",value:function(){var t,e=this.value,i=e.search(/[^0]/);if(-1===i&&e.length<=this._matchFrom)return !0;for(var r=this.boundaries(e),u=qr(r,2),s=u[0],a=u[1],o=arguments.length,l=new Array(o),h=0;h<o;h++)l[h]=arguments[h];return this.from<=Number(a)&&Number(s)<=this.to&&(t=Nr(Tr(n.prototype),"doValidate",this)).call.apply(t,[this].concat(l))}}]),n}(gu);iu.MaskedRange=ku;var yu=function(t){Pr(n,t);var e=Vr(n);function n(t){return xr(this,n),e.call(this,Object.assign({},n.DEFAULTS,t))}return Or(n,[{key:"_update",value:function(t){t.mask===Date&&delete t.mask,t.pattern&&(t.mask=t.pattern);var e=t.blocks;t.blocks=Object.assign({},n.GET_DEFAULT_BLOCKS()),t.min&&(t.blocks.Y.from=t.min.getFullYear()),t.max&&(t.blocks.Y.to=t.max.getFullYear()),t.min&&t.max&&t.blocks.Y.from===t.blocks.Y.to&&(t.blocks.m.from=t.min.getMonth()+1,t.blocks.m.to=t.max.getMonth()+1,t.blocks.m.from===t.blocks.m.to&&(t.blocks.d.from=t.min.getDate(),t.blocks.d.to=t.max.getDate())),Object.assign(t.blocks,this.blocks,e),Object.keys(t.blocks).forEach((function(e){var n=t.blocks[e];!("autofix"in n)&&"autofix"in t&&(n.autofix=t.autofix);})),Nr(Tr(n.prototype),"_update",this).call(this,t);}},{key:"doValidate",value:function(){for(var t,e=this.date,i=arguments.length,r=new Array(i),u=0;u<i;u++)r[u]=arguments[u];return (t=Nr(Tr(n.prototype),"doValidate",this)).call.apply(t,[this].concat(r))&&(!this.isComplete||this.isDateExist(this.value)&&null!=e&&(null==this.min||this.min<=e)&&(null==this.max||e<=this.max))}},{key:"isDateExist",value:function(t){return this.format(this.parse(t,this),this).indexOf(t)>=0}},{key:"date",get:function(){return this.typedValue},set:function(t){this.typedValue=t;}},{key:"typedValue",get:function(){return this.isComplete?Nr(Tr(n.prototype),"typedValue",this):null},set:function(t){zr(Tr(n.prototype),"typedValue",t,this,!0);}},{key:"maskEquals",value:function(t){return t===Date||Nr(Tr(n.prototype),"maskEquals",this).call(this,t)}}]),n}(gu);yu.DEFAULTS={pattern:"d{.}`m{.}`Y",format:function(t){return t?[String(t.getDate()).padStart(2,"0"),String(t.getMonth()+1).padStart(2,"0"),t.getFullYear()].join("."):""},parse:function(t){var e=qr(t.split("."),3),n=e[0],i=e[1],r=e[2];return new Date(r,i-1,n)}},yu.GET_DEFAULT_BLOCKS=function(){return {d:{mask:ku,from:1,to:31,maxLength:2},m:{mask:ku,from:1,to:12,maxLength:2},Y:{mask:ku,from:1900,to:9999}}},iu.MaskedDate=yu;var mu=function(){function t(){xr(this,t);}return Or(t,[{key:"selectionStart",get:function(){var t;try{t=this._unsafeSelectionStart;}catch(t){}return null!=t?t:this.value.length}},{key:"selectionEnd",get:function(){var t;try{t=this._unsafeSelectionEnd;}catch(t){}return null!=t?t:this.value.length}},{key:"select",value:function(t,e){if(null!=t&&null!=e&&(t!==this.selectionStart||e!==this.selectionEnd))try{this._unsafeSelect(t,e);}catch(t){}}},{key:"_unsafeSelect",value:function(t,e){}},{key:"isActive",get:function(){return !1}},{key:"bindEvents",value:function(t){}},{key:"unbindEvents",value:function(){}}]),t}();iu.MaskElement=mu;var bu=function(t){Pr(n,t);var e=Vr(n);function n(t){var i;return xr(this,n),(i=e.call(this)).input=t,i._handlers={},i}return Or(n,[{key:"rootElement",get:function(){var t,e,n;return null!==(t=null===(e=(n=this.input).getRootNode)||void 0===e?void 0:e.call(n))&&void 0!==t?t:document}},{key:"isActive",get:function(){return this.input===this.rootElement.activeElement}},{key:"_unsafeSelectionStart",get:function(){return this.input.selectionStart}},{key:"_unsafeSelectionEnd",get:function(){return this.input.selectionEnd}},{key:"_unsafeSelect",value:function(t,e){this.input.setSelectionRange(t,e);}},{key:"value",get:function(){return this.input.value},set:function(t){this.input.value=t;}},{key:"bindEvents",value:function(t){var e=this;Object.keys(t).forEach((function(i){return e._toggleEventHandler(n.EVENTS_MAP[i],t[i])}));}},{key:"unbindEvents",value:function(){var t=this;Object.keys(this._handlers).forEach((function(e){return t._toggleEventHandler(e)}));}},{key:"_toggleEventHandler",value:function(t,e){this._handlers[t]&&(this.input.removeEventListener(t,this._handlers[t]),delete this._handlers[t]),e&&(this.input.addEventListener(t,e),this._handlers[t]=e);}}]),n}(mu);bu.EVENTS_MAP={selectionChange:"keydown",input:"input",drop:"drop",click:"click",focus:"focus",commit:"blur"},iu.HTMLMaskElement=bu;var _u=function(t){Pr(n,t);var e=Vr(n);function n(){return xr(this,n),e.apply(this,arguments)}return Or(n,[{key:"_unsafeSelectionStart",get:function(){var t=this.rootElement,e=t.getSelection&&t.getSelection(),n=e&&e.anchorOffset,i=e&&e.focusOffset;return null==i||null==n||n<i?n:i}},{key:"_unsafeSelectionEnd",get:function(){var t=this.rootElement,e=t.getSelection&&t.getSelection(),n=e&&e.anchorOffset,i=e&&e.focusOffset;return null==i||null==n||n>i?n:i}},{key:"_unsafeSelect",value:function(t,e){if(this.rootElement.createRange){var n=this.rootElement.createRange();n.setStart(this.input.firstChild||this.input,t),n.setEnd(this.input.lastChild||this.input,e);var i=this.rootElement,r=i.getSelection&&i.getSelection();r&&(r.removeAllRanges(),r.addRange(n));}}},{key:"value",get:function(){return this.input.textContent},set:function(t){this.input.textContent=t;}}]),n}(bu);iu.HTMLContenteditableMaskElement=_u;var Au=["mask"],Cu=function(){function t(e,n){xr(this,t),this.el=e instanceof mu?e:e.isContentEditable&&"INPUT"!==e.tagName&&"TEXTAREA"!==e.tagName?new _u(e):new bu(e),this.masked=su(n),this._listeners={},this._value="",this._unmaskedValue="",this._saveSelection=this._saveSelection.bind(this),this._onInput=this._onInput.bind(this),this._onChange=this._onChange.bind(this),this._onDrop=this._onDrop.bind(this),this._onFocus=this._onFocus.bind(this),this._onClick=this._onClick.bind(this),this.alignCursor=this.alignCursor.bind(this),this.alignCursorFriendly=this.alignCursorFriendly.bind(this),this._bindEvents(),this.updateValue(),this._onChange();}return Or(t,[{key:"mask",get:function(){return this.masked.mask},set:function(t){if(!this.maskEquals(t))if(t instanceof iu.Masked||this.masked.constructor!==uu(t)){var e=su({mask:t});e.unmaskedValue=this.masked.unmaskedValue,this.masked=e;}else this.masked.updateOptions({mask:t});}},{key:"maskEquals",value:function(t){var e;return null==t||(null===(e=this.masked)||void 0===e?void 0:e.maskEquals(t))}},{key:"value",get:function(){return this._value},set:function(t){this.masked.value=t,this.updateControl(),this.alignCursor();}},{key:"unmaskedValue",get:function(){return this._unmaskedValue},set:function(t){this.masked.unmaskedValue=t,this.updateControl(),this.alignCursor();}},{key:"typedValue",get:function(){return this.masked.typedValue},set:function(t){this.masked.typedValue=t,this.updateControl(),this.alignCursor();}},{key:"_bindEvents",value:function(){this.el.bindEvents({selectionChange:this._saveSelection,input:this._onInput,drop:this._onDrop,click:this._onClick,focus:this._onFocus,commit:this._onChange});}},{key:"_unbindEvents",value:function(){this.el&&this.el.unbindEvents();}},{key:"_fireEvent",value:function(t){for(var e=arguments.length,n=new Array(e>1?e-1:0),i=1;i<e;i++)n[i-1]=arguments[i];var r=this._listeners[t];r&&r.forEach((function(t){return t.apply(void 0,n)}));}},{key:"selectionStart",get:function(){return this._cursorChanging?this._changingCursorPos:this.el.selectionStart}},{key:"cursorPos",get:function(){return this._cursorChanging?this._changingCursorPos:this.el.selectionEnd},set:function(t){this.el&&this.el.isActive&&(this.el.select(t,t),this._saveSelection());}},{key:"_saveSelection",value:function(){this.value!==this.el.value&&console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."),this._selection={start:this.selectionStart,end:this.cursorPos};}},{key:"updateValue",value:function(){this.masked.value=this.el.value,this._value=this.masked.value;}},{key:"updateControl",value:function(){var t=this.masked.unmaskedValue,e=this.masked.value,n=this.unmaskedValue!==t||this.value!==e;this._unmaskedValue=t,this._value=e,this.el.value!==e&&(this.el.value=e),n&&this._fireChangeEvents();}},{key:"updateOptions",value:function(t){var e=t.mask,n=jr(t,Au),i=!this.maskEquals(e),r=!tu(this.masked,n);i&&(this.mask=e),r&&this.masked.updateOptions(n),(i||r)&&this.updateControl();}},{key:"updateCursor",value:function(t){null!=t&&(this.cursorPos=t,this._delayUpdateCursor(t));}},{key:"_delayUpdateCursor",value:function(t){var e=this;this._abortUpdateCursor(),this._changingCursorPos=t,this._cursorChanging=setTimeout((function(){e.el&&(e.cursorPos=e._changingCursorPos,e._abortUpdateCursor());}),10);}},{key:"_fireChangeEvents",value:function(){this._fireEvent("accept",this._inputEvent),this.masked.isComplete&&this._fireEvent("complete",this._inputEvent);}},{key:"_abortUpdateCursor",value:function(){this._cursorChanging&&(clearTimeout(this._cursorChanging),delete this._cursorChanging);}},{key:"alignCursor",value:function(){this.cursorPos=this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos,Kr));}},{key:"alignCursorFriendly",value:function(){this.selectionStart===this.cursorPos&&this.alignCursor();}},{key:"on",value:function(t,e){return this._listeners[t]||(this._listeners[t]=[]),this._listeners[t].push(e),this}},{key:"off",value:function(t,e){if(!this._listeners[t])return this;if(!e)return delete this._listeners[t],this;var n=this._listeners[t].indexOf(e);return n>=0&&this._listeners[t].splice(n,1),this}},{key:"_onInput",value:function(t){if(this._inputEvent=t,this._abortUpdateCursor(),!this._selection)return this.updateValue();var e=new eu(this.el.value,this.cursorPos,this.value,this._selection),n=this.masked.rawInputValue,i=this.masked.splice(e.startChangePos,e.removed.length,e.inserted,e.removeDirection).offset,r=n===this.masked.rawInputValue?e.removeDirection:Gr,u=this.masked.nearestInputPos(e.startChangePos+i,r);r!==Gr&&(u=this.masked.nearestInputPos(u,Gr)),this.updateControl(),this.updateCursor(u),delete this._inputEvent;}},{key:"_onChange",value:function(){this.value!==this.el.value&&this.updateValue(),this.masked.doCommit(),this.updateControl(),this._saveSelection();}},{key:"_onDrop",value:function(t){t.preventDefault(),t.stopPropagation();}},{key:"_onFocus",value:function(t){this.alignCursorFriendly();}},{key:"_onClick",value:function(t){this.alignCursorFriendly();}},{key:"destroy",value:function(){this._unbindEvents(),this._listeners.length=0,delete this.el;}}]),t}();iu.InputMask=Cu;var Eu=function(t){Pr(n,t);var e=Vr(n);function n(){return xr(this,n),e.apply(this,arguments)}return Or(n,[{key:"_update",value:function(t){t.enum&&(t.mask="*".repeat(t.enum[0].length)),Nr(Tr(n.prototype),"_update",this).call(this,t);}},{key:"doValidate",value:function(){for(var t,e=this,i=arguments.length,r=new Array(i),u=0;u<i;u++)r[u]=arguments[u];return this.enum.some((function(t){return t.indexOf(e.unmaskedValue)>=0}))&&(t=Nr(Tr(n.prototype),"doValidate",this)).call.apply(t,[this].concat(r))}}]),n}(gu);iu.MaskedEnum=Eu;var Fu=function(t){Pr(n,t);var e=Vr(n);function n(t){return xr(this,n),e.call(this,Object.assign({},n.DEFAULTS,t))}return Or(n,[{key:"_update",value:function(t){Nr(Tr(n.prototype),"_update",this).call(this,t),this._updateRegExps();}},{key:"_updateRegExps",value:function(){var t="^"+(this.allowNegative?"[+|\\-]?":""),e=(this.scale?"("+Jr(this.radix)+"\\d{0,"+this.scale+"})?":"")+"$";this._numberRegExpInput=new RegExp(t+"(0|([1-9]+\\d*))?"+e),this._numberRegExp=new RegExp(t+"\\d*"+e),this._mapToRadixRegExp=new RegExp("["+this.mapToRadix.map(Jr).join("")+"]","g"),this._thousandsSeparatorRegExp=new RegExp(Jr(this.thousandsSeparator),"g");}},{key:"_removeThousandsSeparators",value:function(t){return t.replace(this._thousandsSeparatorRegExp,"")}},{key:"_insertThousandsSeparators",value:function(t){var e=t.split(this.radix);return e[0]=e[0].replace(/\B(?=(\d{3})+(?!\d))/g,this.thousandsSeparator),e.join(this.radix)}},{key:"doPrepare",value:function(t){var e;t=t.replace(this._mapToRadixRegExp,this.radix);for(var i=this._removeThousandsSeparators(t),r=arguments.length,u=new Array(r>1?r-1:0),s=1;s<r;s++)u[s-1]=arguments[s];var a=Qr((e=Nr(Tr(n.prototype),"doPrepare",this)).call.apply(e,[this,i].concat(u))),o=qr(a,2),l=o[0],h=o[1];return t&&!i&&(h.skip=!0),[l,h]}},{key:"_separatorsCount",value:function(t){for(var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=0,i=0;i<t;++i)this._value.indexOf(this.thousandsSeparator,i)===i&&(++n,e&&(t+=this.thousandsSeparator.length));return n}},{key:"_separatorsCountFromSlice",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this._value;return this._separatorsCount(this._removeThousandsSeparators(t).length,!0)}},{key:"extractInput",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,i=arguments.length>2?arguments[2]:void 0,r=this._adjustRangeWithSeparators(t,e),u=qr(r,2);return t=u[0],e=u[1],this._removeThousandsSeparators(Nr(Tr(n.prototype),"extractInput",this).call(this,t,e,i))}},{key:"_appendCharRaw",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!this.thousandsSeparator)return Nr(Tr(n.prototype),"_appendCharRaw",this).call(this,t,e);var i=e.tail&&e._beforeTailState?e._beforeTailState._value:this._value,r=this._separatorsCountFromSlice(i);this._value=this._removeThousandsSeparators(this.value);var u=Nr(Tr(n.prototype),"_appendCharRaw",this).call(this,t,e);this._value=this._insertThousandsSeparators(this._value);var s=e.tail&&e._beforeTailState?e._beforeTailState._value:this._value,a=this._separatorsCountFromSlice(s);return u.tailShift+=(a-r)*this.thousandsSeparator.length,u.skip=!u.rawInserted&&t===this.thousandsSeparator,u}},{key:"_findSeparatorAround",value:function(t){if(this.thousandsSeparator){var e=t-this.thousandsSeparator.length+1,n=this.value.indexOf(this.thousandsSeparator,e);if(n<=t)return n}return -1}},{key:"_adjustRangeWithSeparators",value:function(t,e){var n=this._findSeparatorAround(t);n>=0&&(t=n);var i=this._findSeparatorAround(e);return i>=0&&(e=i+this.thousandsSeparator.length),[t,e]}},{key:"remove",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.value.length,n=this._adjustRangeWithSeparators(t,e),i=qr(n,2);t=i[0],e=i[1];var r=this.value.slice(0,t),u=this.value.slice(e),s=this._separatorsCount(r.length);this._value=this._insertThousandsSeparators(this._removeThousandsSeparators(r+u));var a=this._separatorsCountFromSlice(r);return new Yr({tailShift:(a-s)*this.thousandsSeparator.length})}},{key:"nearestInputPos",value:function(t,e){if(!this.thousandsSeparator)return t;switch(e){case Gr:case Kr:case $r:var n=this._findSeparatorAround(t-1);if(n>=0){var i=n+this.thousandsSeparator.length;if(t<i||this.value.length<=i||e===$r)return n}break;case Wr:case Xr:var r=this._findSeparatorAround(t);if(r>=0)return r+this.thousandsSeparator.length}return t}},{key:"doValidate",value:function(t){var e=(t.input?this._numberRegExpInput:this._numberRegExp).test(this._removeThousandsSeparators(this.value));if(e){var i=this.number;e=e&&!isNaN(i)&&(null==this.min||this.min>=0||this.min<=this.number)&&(null==this.max||this.max<=0||this.number<=this.max);}return e&&Nr(Tr(n.prototype),"doValidate",this).call(this,t)}},{key:"doCommit",value:function(){if(this.value){var t=this.number,e=t;null!=this.min&&(e=Math.max(e,this.min)),null!=this.max&&(e=Math.min(e,this.max)),e!==t&&(this.unmaskedValue=String(e));var i=this.value;this.normalizeZeros&&(i=this._normalizeZeros(i)),this.padFractionalZeros&&this.scale>0&&(i=this._padFractionalZeros(i)),this._value=i;}Nr(Tr(n.prototype),"doCommit",this).call(this);}},{key:"_normalizeZeros",value:function(t){var e=this._removeThousandsSeparators(t).split(this.radix);return e[0]=e[0].replace(/^(\D*)(0*)(\d*)/,(function(t,e,n,i){return e+i})),t.length&&!/\d$/.test(e[0])&&(e[0]=e[0]+"0"),e.length>1&&(e[1]=e[1].replace(/0*$/,""),e[1].length||(e.length=1)),this._insertThousandsSeparators(e.join(this.radix))}},{key:"_padFractionalZeros",value:function(t){if(!t)return t;var e=t.split(this.radix);return e.length<2&&e.push(""),e[1]=e[1].padEnd(this.scale,"0"),e.join(this.radix)}},{key:"unmaskedValue",get:function(){return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix,".")},set:function(t){zr(Tr(n.prototype),"unmaskedValue",t.replace(".",this.radix),this,!0);}},{key:"typedValue",get:function(){return Number(this.unmaskedValue)},set:function(t){zr(Tr(n.prototype),"unmaskedValue",String(t),this,!0);}},{key:"number",get:function(){return this.typedValue},set:function(t){this.typedValue=t;}},{key:"allowNegative",get:function(){return this.signed||null!=this.min&&this.min<0||null!=this.max&&this.max<0}}]),n}(ru);Fu.DEFAULTS={radix:",",thousandsSeparator:"",mapToRadix:["."],scale:2,signed:!1,normalizeZeros:!0,padFractionalZeros:!1},iu.MaskedNumber=Fu;var Su=function(t){Pr(n,t);var e=Vr(n);function n(){return xr(this,n),e.apply(this,arguments)}return Or(n,[{key:"_update",value:function(t){t.mask&&(t.validate=t.mask),Nr(Tr(n.prototype),"_update",this).call(this,t);}}]),n}(ru);iu.MaskedFunction=Su;var wu=["compiledMasks","currentMaskRef","currentMask"],Bu=function(t){Pr(n,t);var e=Vr(n);function n(t){var i;return xr(this,n),(i=e.call(this,Object.assign({},n.DEFAULTS,t))).currentMask=null,i}return Or(n,[{key:"_update",value:function(t){Nr(Tr(n.prototype),"_update",this).call(this,t),"mask"in t&&(this.compiledMasks=Array.isArray(t.mask)?t.mask.map((function(t){return su(t)})):[]);}},{key:"_appendCharRaw",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=this._applyDispatch(t,e);return this.currentMask&&n.aggregate(this.currentMask._appendChar(t,e)),n}},{key:"_applyDispatch",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.tail&&null!=e._beforeTailState?e._beforeTailState._value:this.value,i=this.rawInputValue,r=e.tail&&null!=e._beforeTailState?e._beforeTailState._rawInputValue:i,u=i.slice(r.length),s=this.currentMask,a=new Yr,o=s&&s.state;if(this.currentMask=this.doDispatch(t,Object.assign({},e)),this.currentMask)if(this.currentMask!==s){if(this.currentMask.reset(),r){var l=this.currentMask.append(r,{raw:!0});a.tailShift=l.inserted.length-n.length;}u&&(a.tailShift+=this.currentMask.append(u,{raw:!0,tail:!0}).tailShift);}else this.currentMask.state=o;return a}},{key:"_appendPlaceholder",value:function(){var t=this._applyDispatch.apply(this,arguments);return this.currentMask&&t.aggregate(this.currentMask._appendPlaceholder()),t}},{key:"_appendEager",value:function(){var t=this._applyDispatch.apply(this,arguments);return this.currentMask&&t.aggregate(this.currentMask._appendEager()),t}},{key:"doDispatch",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return this.dispatch(t,this,e)}},{key:"doValidate",value:function(){for(var t,e,i=arguments.length,r=new Array(i),u=0;u<i;u++)r[u]=arguments[u];return (t=Nr(Tr(n.prototype),"doValidate",this)).call.apply(t,[this].concat(r))&&(!this.currentMask||(e=this.currentMask).doValidate.apply(e,r))}},{key:"reset",value:function(){var t;null===(t=this.currentMask)||void 0===t||t.reset(),this.compiledMasks.forEach((function(t){return t.reset()}));}},{key:"value",get:function(){return this.currentMask?this.currentMask.value:""},set:function(t){zr(Tr(n.prototype),"value",t,this,!0);}},{key:"unmaskedValue",get:function(){return this.currentMask?this.currentMask.unmaskedValue:""},set:function(t){zr(Tr(n.prototype),"unmaskedValue",t,this,!0);}},{key:"typedValue",get:function(){return this.currentMask?this.currentMask.typedValue:""},set:function(t){var e=String(t);this.currentMask&&(this.currentMask.typedValue=t,e=this.currentMask.unmaskedValue),this.unmaskedValue=e;}},{key:"isComplete",get:function(){var t;return Boolean(null===(t=this.currentMask)||void 0===t?void 0:t.isComplete)}},{key:"isFilled",get:function(){var t;return Boolean(null===(t=this.currentMask)||void 0===t?void 0:t.isFilled)}},{key:"remove",value:function(){var t,e=new Yr;this.currentMask&&e.aggregate((t=this.currentMask).remove.apply(t,arguments)).aggregate(this._applyDispatch());return e}},{key:"state",get:function(){return Object.assign({},Nr(Tr(n.prototype),"state",this),{_rawInputValue:this.rawInputValue,compiledMasks:this.compiledMasks.map((function(t){return t.state})),currentMaskRef:this.currentMask,currentMask:this.currentMask&&this.currentMask.state})},set:function(t){var e=t.compiledMasks,i=t.currentMaskRef,r=t.currentMask,u=jr(t,wu);this.compiledMasks.forEach((function(t,n){return t.state=e[n]})),null!=i&&(this.currentMask=i,this.currentMask.state=r),zr(Tr(n.prototype),"state",u,this,!0);}},{key:"extractInput",value:function(){var t;return this.currentMask?(t=this.currentMask).extractInput.apply(t,arguments):""}},{key:"extractTail",value:function(){for(var t,e,i=arguments.length,r=new Array(i),u=0;u<i;u++)r[u]=arguments[u];return this.currentMask?(t=this.currentMask).extractTail.apply(t,r):(e=Nr(Tr(n.prototype),"extractTail",this)).call.apply(e,[this].concat(r))}},{key:"doCommit",value:function(){this.currentMask&&this.currentMask.doCommit(),Nr(Tr(n.prototype),"doCommit",this).call(this);}},{key:"nearestInputPos",value:function(){for(var t,e,i=arguments.length,r=new Array(i),u=0;u<i;u++)r[u]=arguments[u];return this.currentMask?(t=this.currentMask).nearestInputPos.apply(t,r):(e=Nr(Tr(n.prototype),"nearestInputPos",this)).call.apply(e,[this].concat(r))}},{key:"overwrite",get:function(){return this.currentMask?this.currentMask.overwrite:Nr(Tr(n.prototype),"overwrite",this)},set:function(t){console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');}},{key:"eager",get:function(){return this.currentMask?this.currentMask.eager:Nr(Tr(n.prototype),"eager",this)},set:function(t){console.warn('"eager" option is not available in dynamic mask, use this option in siblings');}},{key:"maskEquals",value:function(t){return Array.isArray(t)&&this.compiledMasks.every((function(e,n){var i;return e.maskEquals(null===(i=t[n])||void 0===i?void 0:i.mask)}))}}]),n}(ru);Bu.DEFAULTS={dispatch:function(t,e,n){if(e.compiledMasks.length){var i=e.rawInputValue,r=e.compiledMasks.map((function(e,r){return e.reset(),e.append(i,{raw:!0}),e.append(t,n),{weight:e.rawInputValue.length,index:r}}));return r.sort((function(t,e){return e.weight-t.weight})),e.compiledMasks[r[0].index]}}},iu.MaskedDynamic=Bu;var Du={MASKED:"value",UNMASKED:"unmaskedValue",TYPED:"typedValue"};function xu(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Du.MASKED,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:Du.MASKED,i=su(t);return function(t){return i.runIsolated((function(i){return i[e]=t,i[n]}))}}function Mu(t){for(var e=arguments.length,n=new Array(e>1?e-1:0),i=1;i<e;i++)n[i-1]=arguments[i];return xu.apply(void 0,n)(t)}iu.PIPE_TYPE=Du,iu.createPipe=xu,iu.pipe=Mu;try{globalThis.IMask=iu;}catch(t){}t.HTMLContenteditableMaskElement=_u,t.HTMLMaskElement=bu,t.InputMask=Cu,t.MaskElement=mu,t.Masked=ru,t.MaskedDate=yu,t.MaskedDynamic=Bu,t.MaskedEnum=Eu,t.MaskedFunction=Su,t.MaskedNumber=Fu,t.MaskedPattern=gu,t.MaskedRange=ku,t.MaskedRegExp=du,t.PIPE_TYPE=Du,t.createMask=su,t.createPipe=xu,t.default=iu,t.pipe=Mu,Object.defineProperty(t,"__esModule",{value:!0});}));

    // libs https://imask.js.org/


    /**
     * Basic UI: Mask.
     */
    const BasicMask = (() => {

        class Core {

            constructor(element, options) {

                this.$el = element;            
                            
                let dataMaskOptions = JSON.parse(this.$el.getAttribute('data-mask-options')) || {};
                
                this.$options = options || {
                    'type':      dataMaskOptions['type']      || 'default',
                    'pattern':   dataMaskOptions['pattern']   || false,
                    'max':       dataMaskOptions['max']       || false,
                    'min':       dataMaskOptions['min']       || false,
                    'separator': dataMaskOptions['separator'] || ' ', 
                    'lazy':      dataMaskOptions['lazy'] !== undefined ? dataMaskOptions['lazy'] : true
                };

            }


            init() {

                this.build();            

            }


            build() {

                let maskOptions = {},
                    maskMax = null,
                    maskMin = null,
                    maskPattern = null;


                // default
                if (this.$options['type'] == 'default' || this.$options['type'] == 'phone') {

                    maskPattern = this.$options['pattern'] || '+{7}(000)000-00-00';
                    maskOptions = {
                        mask: maskPattern,
                        lazy: this.$options['lazy']
                    };

                }
                
                
                // date
                if (this.$options['type'] == 'date') {

                    maskPattern = this.$options['pattern'] || 'd{.}`m{.}`Y'; // default DD.MM.YYYY
                    maskMin = this.$options['min'] ? new Date(this.$options['min']) : new Date(1900, 0, 1);
                    maskMax = this.$options['max'] ? new Date(this.$options['max']) : new Date(9999, 0, 1);
                    maskOptions = {
                        mask: Date,
                        pattern: maskPattern,
                        min: maskMin,
                        max: maskMax,
                        lazy: this.$options['lazy']
                    };

                }


                // number or currency
                if (this.$options['type'] == 'number' || this.$options['type'] == 'currency') {

                    maskMin = this.$options['min'] ? Number.parseInt(this.$options['min']) : 0;
                    maskMax = this.$options['max'] ? Number.parseInt(this.$options['max']) : 1000000000;
                    
                    // number
                    if (this.$options['type'] == 'number') {

                        maskPattern = this.$options['pattern'] || Number;
                        maskOptions = {
                            mask: maskPattern,
                            min: maskMin,
                            max: maskMax,
                            lazy: this.$options['lazy'],
                            thousandsSeparator: this.$options['separator']
                        };

                    }

                    // currency
                    if (this.$options['type'] == 'currency') {

                        maskPattern = this.$options['pattern'] || 'num ₽';
                        maskOptions = {
                            mask: maskPattern,
                            blocks: {
                                num: {
                                    mask: Number,
                                    max: maskMax,
                                    lazy: this.$options['lazy'],
                                    thousandsSeparator: this.$options['separator']
                                }
                            }
                        };

                    }

                }


                // init IMask
                this.$iMask = new IMask(this.$el, maskOptions);
                this.$el.classList.add('mask-init');

            }


            method_options() {

            	this.$iMask = new IMask(this.$el, this.$options);
                this.$el.classList.add('mask-init');

            }

        }


        let active = null;


    	/**
    	 * Mask initialization
    	 * @param {Object|string} variable - element for initializing mask
    	 */
        const init = (variable) => {

            let element = null,
                elements = BasicCore.variables(variable, '.js-mask:not(.mask-init)');

                
            try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
                
                elements.forEach((value) => {
                    
                    element = value;

                    active = new Core(value);
                    active.init();

                });

                return active;
            
            } catch(error) {

    			console.error(`${BasicCore.logging['name']} Mask init. \nMessage: ${error.message} \nElement: `, element);

    		}

        };    


    	/**
    	 * Method: Initialization with parameters 
    	 * @param {Object|string} variable - element for initializing mask;
    	 * @param {Object}        config   - element parameters.
    	 */
        const options = (variable, config) => {

            let options = config || false,
                element = null,
                elements = BasicCore.variables(variable, '.js-mask');

                
            try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
                
                elements.forEach((value) => {
                    
                    element = value;

                    active = new Core(value, options);
                    active.method_options();

                });

                return active;
            
            } catch(error) {

    			console.error(`${BasicCore.logging['name']} Mask options. \nMessage: ${error.message} \nElement:`, element);
                return false;

    		}

        };


        return { init, options };

    })();


    window.BasicMask = BasicMask;

    function At(n,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(n,r.key,r);}}
    /*!
     * Splide.js
     * Version  : 3.6.12
     * License  : MIT
     * Copyright: 2022 Naotoshi Fujita
     */
    var n,t;n=undefined,t=function(){var m="splide",a="data-"+m,n={CREATED:1,MOUNTED:2,IDLE:3,MOVING:4,DESTROYED:5},R=10;function _(n){n.length=0;}function I(n){return !u(n)&&"object"==typeof n}function r(n){return Array.isArray(n)}function D(n){return "string"==typeof n}function O(n){return void 0===n}function u(n){return null===n}function y(n){return n instanceof HTMLElement}function w(n){return r(n)?n:[n]}function b(n,t){w(n).forEach(t);}function x(n,t){return -1<n.indexOf(t)}function k(n,t){return n.push.apply(n,w(t)),n}var o=Array.prototype;function s(n,t,i){return o.slice.call(n,t,i)}function E(t,n,i){t&&b(n,function(n){n&&t.classList[i?"add":"remove"](n);});}function A(n,t){E(n,D(t)?t.split(" "):t,!0);}function L(n,t){b(t,n.appendChild.bind(n));}function S(n,i){b(n,function(n){var t=i.parentNode;t&&t.insertBefore(n,i);});}function W(n,t){return y(n)&&(n.msMatchesSelector||n.matches).call(n,t)}function z(n,t){return n?s(n.children).filter(function(n){return W(n,t)}):[]}function P(n,t){return t?z(n,t)[0]:n.firstElementChild}function e(n,t,i){if(n)for(var r=Object.keys(n),r=i?r.reverse():r,u=0;u<r.length;u++){var o=r[u];if("__proto__"!==o&&!1===t(n[o],o))break}return n}function M(r){return s(arguments,1).forEach(function(i){e(i,function(n,t){r[t]=i[t];});}),r}function l(i,n){return e(n,function(n,t){r(n)?i[t]=n.slice():I(n)?i[t]=l(I(i[t])?i[t]:{},n):i[t]=n;}),i}function T(t,n){t&&b(n,function(n){t.removeAttribute(n);});}function j(i,n,t){I(n)?e(n,function(n,t){j(i,t,n);}):u(t)?T(i,n):i.setAttribute(n,String(t));}function F(n,t,i){n=document.createElement(n);return t&&(D(t)?A:j)(n,t),i&&L(i,n),n}function C(n,t,i){if(O(i))return getComputedStyle(n)[t];u(i)||(n=n.style)[t]!==(i=""+i)&&(n[t]=i);}function N(n,t){C(n,"display",t);}function X(n,t){return n.getAttribute(t)}function B(n,t){return n&&n.classList.contains(t)}function G(n){return n.getBoundingClientRect()}function H(n){b(n,function(n){n&&n.parentNode&&n.parentNode.removeChild(n);});}function Y(n){return P((new DOMParser).parseFromString(n,"text/html").body)}function U(n,t){n.preventDefault(),t&&(n.stopPropagation(),n.stopImmediatePropagation());}function q(n,t){return n&&n.querySelector(t)}function J(n,t){return s(n.querySelectorAll(t))}function K(n,t){E(n,t,!1);}function V(n){return D(n)?n:n?n+"px":""}function Q(n,t){if(void 0===t&&(t=""),!n)throw new Error("["+m+"] "+t)}function g(n){setTimeout(n);}function Z(){}function v(n){return requestAnimationFrame(n)}var $=Math.min,nn=Math.max,tn=Math.floor,rn=Math.ceil,un=Math.abs;function on(n,t,i,r){var u=$(t,i),i=nn(t,i);return r?u<n&&n<i:u<=n&&n<=i}function en(n,t,i){var r=$(t,i),i=nn(t,i);return $(nn(r,n),i)}function cn(n){return (0<n)-(n<0)}function fn(t,n){return b(n,function(n){t=t.replace("%s",""+n);}),t}function an(n){return n<10?"0"+n:""+n}var sn={};function c(){var o={};function r(n,r){t(n,function(n,t){var i=o[n];o[n]=i&&i.filter(function(n){return n.n?n.n!==r:r||n.t!==t});});}function t(n,t){w(n).join(" ").split(" ").forEach(function(n){n=n.split(".");t(n[0],n[1]);});}return {on:function(n,i,r,u){void 0===u&&(u=R),t(n,function(n,t){o[n]=o[n]||[],k(o[n],{i:n,r:i,t:t,u:u,n:r}).sort(function(n,t){return n.u-t.u});});},off:r,offBy:function(i){e(o,function(n,t){r(t,i);});},emit:function(n){var t=arguments;(o[n]||[]).forEach(function(n){n.r.apply(n,s(t,1));});},destroy:function(){o={};}}}var ln="mounted",dn="move",vn="moved",hn="shifted",pn="click",gn="active",mn="inactive",yn="visible",wn="hidden",_n="slide:keydown",bn="refresh",xn="updated",kn="resize",An="resized",Ln="repositioned",En="scrolled",f="destroy",Sn="navigation:mounted",zn="lazyload:loaded";function Pn(n){var r=n.event,u={},o=[];function t(n,t,r){e(n,t,function(t,i){o=o.filter(function(n){return !!(n[0]!==t||n[1]!==i||r&&n[2]!==r)||(t.removeEventListener(i,n[2],n[3]),!1)});});}function e(n,t,i){b(n,function(n){n&&t.split(" ").forEach(i.bind(null,n));});}function i(){o=o.filter(function(n){return t(n[0],n[1])}),r.offBy(u);}return r.on(f,i,u),{on:function(n,t,i){r.on(n,t,u,i);},off:function(n){r.off(n,u);},emit:r.emit,bind:function(n,t,i,r){e(n,t,function(n,t){o.push([n,t,i,r]),n.addEventListener(t,i,r);});},unbind:t,destroy:i}}function Rn(t,i,r,u){var o,n,e=Date.now,c=0,f=!0,a=0;function s(){if(!f){var n=e()-o;if(t<=n?(c=1,o=e()):c=n/t,r&&r(c),1===c&&(i(),u&&++a>=u))return l();v(s);}}function l(){f=!0;}function d(){cancelAnimationFrame(n),f=!(n=c=0);}return {start:function(n){n||d(),o=e()-(n?c*t:0),f=!1,v(s);},rewind:function(){o=e(),c=0,r&&r(c);},pause:l,cancel:d,set:function(n){t=n;},isPaused:function(){return f}}}function d(n){var t=n;return {set:function(n){t=n;},is:function(n){return x(w(n),t)}}}function Dn(i,r){var u;return function(){var n=arguments,t=this;u||(u=Rn(r||0,function(){i.apply(t,n),u=null;},null,1)).start();}}var h={marginRight:["marginBottom","marginLeft"],autoWidth:["autoHeight"],fixedWidth:["fixedHeight"],paddingLeft:["paddingTop","paddingRight"],paddingRight:["paddingBottom","paddingLeft"],width:["height"],left:["top","right"],right:["bottom","left"],x:["y"],X:["Y"],Y:["X"],ArrowLeft:["ArrowUp","ArrowRight"],ArrowRight:["ArrowDown","ArrowLeft"]};var On=m,Mn=m+"__slider",Tn=m+"__track",jn=m+"__list",Fn=m+"__slide",In=Fn+"--clone",Wn=Fn+"__container",Cn=m+"__arrows",t=m+"__arrow",Nn=t+"--prev",Xn=t+"--next",i=m+"__pagination",Bn=m+"__progress",Gn=Bn+"__bar",Hn=m+"__autoplay",Yn=m+"__play",Un=m+"__pause",qn="is-active",Jn="is-prev",Kn="is-next",Vn="is-visible",Qn="is-loading",Zn=[qn,Vn,Jn,Kn,Qn];var $n="role",nt="aria-controls",tt="aria-current",it="aria-label",rt="aria-hidden",ut="tabindex",p="aria-orientation",ot=[$n,nt,tt,it,rt,p,ut,"disabled"],et="slide",ct="loop",ft="fade";function at(u,i,r,o){var t,n=Pn(u),e=n.on,c=n.emit,f=n.bind,a=n.destroy,s=u.Components,l=u.root,d=u.options,v=d.isNavigation,h=d.updateOnMove,p=s.Direction.resolve,g=X(o,"style"),m=-1<r,y=P(o,"."+Wn),w=d.focusableNodes&&J(o,d.focusableNodes);function _(){var n=m?r:i,t=fn(d.i18n.slideX,n+1),n=u.splides.map(function(n){return n.splide.root.id}).join(" ");j(o,it,t),j(o,nt,n),j(o,$n,"menuitem"),k(A());}function b(){t||x();}function x(){var n;t||(n=u.index,k(A()),function(n){var t=!n&&(!A()||m);j(o,rt,t||null),j(o,ut,!t&&d.slideFocus?0:null),w&&w.forEach(function(n){j(n,ut,t?-1:null);});n!==B(o,Vn)&&(E(o,Vn,n),c(n?yn:wn,L));}(function(){if(u.is(ft))return A();var n=G(s.Elements.track),t=G(o),i=p("left"),r=p("right");return tn(n[i])<=rn(t[i])&&tn(t[r])<=rn(n[r])}()),E(o,Jn,i===n-1),E(o,Kn,i===n+1));}function k(n){n!==B(o,qn)&&(E(o,qn,n),v&&j(o,tt,n||null),c(n?gn:mn,L));}function A(){var n=u.index;return n===i||d.cloneStatus&&n===r}var L={index:i,slideIndex:r,slide:o,container:y,isClone:m,mount:function(){m||(o.id=l.id+"-slide"+an(i+1)),f(o,"click keydown",function(n){c("click"===n.type?pn:_n,L,n);}),e([bn,Ln,hn,vn,En],x),e(Sn,_),h&&e(dn,b);},destroy:function(){t=!0,a(),K(o,Zn),T(o,ot),j(o,"style",g);},update:x,style:function(n,t,i){C(i&&y||o,n,t);},isWithin:function(n,t){return n=un(n-i),(n=!m&&(d.rewind||u.is(ct))?$(n,u.length-n):n)<=t}};return L}var st=a+"-interval";var lt={passive:!1,capture:!0},dt="touchmove mousemove",vt="touchend touchcancel mouseup";var ht=["Left","Right","Up","Down"],pt="keydown";var gt=a+"-lazy",mt=gt+"-srcset",yt="["+gt+"], ["+mt+"]";var wt=[" ","Enter","Spacebar"];var _t=Object.freeze({__proto__:null,Options:function(t,n,r){var u,o,i,e=Dn(f);function c(n){n&&removeEventListener("resize",e);}function f(){var n=(n=function(n){return n[1].matches},s(o).filter(n)[0]||[]);n[0]!==i&&function(n){n=r.breakpoints[n]||u;n.destroy?(t.options=u,t.destroy("completely"===n.destroy)):(t.state.is(5)&&(c(!0),t.mount()),t.options=n);}(i=n[0]);}return {setup:function(){try{l(r,JSON.parse(X(t.root,a)));}catch(n){Q(!1,n.message);}u=l({},r);var i,n=r.breakpoints;n&&(i="min"===r.mediaQuery,o=Object.keys(n).sort(function(n,t){return i?+t-+n:+n-+t}).map(function(n){return [n,matchMedia("("+(i?"min":"max")+"-width:"+n+"px)")]}),f());},mount:function(){o&&addEventListener("resize",e);},destroy:c}},Direction:function(n,t,r){return {resolve:function(n,t){var i=r.direction;return h[n]["rtl"!==i||t?"ttb"===i?0:-1:1]||n},orient:function(n){return n*("rtl"===r.direction?1:-1)}}},Elements:function(n,t,i){var r,u,o,e,c=Pn(n).on,f=n.root,a={},s=[];function l(){var n;!function(){u=P(f,"."+Mn),o=q(f,"."+Tn),e=P(o,"."+jn),Q(o&&e,"A track/list element is missing."),k(s,z(e,"."+Fn+":not(."+In+")"));var n=p("."+Hn),t=p("."+Cn);M(a,{root:f,slider:u,track:o,list:e,slides:s,arrows:t,autoplay:n,prev:q(t,"."+Nn),next:q(t,"."+Xn),bar:q(p("."+Bn),"."+Gn),play:q(n,"."+Yn),pause:q(n,"."+Un)});}(),n=f.id||function(n){return ""+n+an(sn[n]=(sn[n]||0)+1)}(m),f.id=n,o.id=o.id||n+"-track",e.id=e.id||n+"-list",A(f,r=g());}function d(){[f,o,e].forEach(function(n){T(n,"style");}),_(s),K(f,r);}function v(){d(),l();}function h(){K(f,r),A(f,r=g());}function p(n){return P(f,n)||P(u,n)}function g(){return [On+"--"+i.type,On+"--"+i.direction,i.drag&&On+"--draggable",i.isNavigation&&On+"--nav",qn]}return M(a,{setup:l,mount:function(){c(bn,v,R-2),c(xn,h);},destroy:d})},Slides:function(r,u,o){var n=Pn(r),t=n.on,e=n.emit,c=n.bind,f=(n=u.Elements).slides,a=n.list,s=[];function i(){f.forEach(function(n,t){v(n,t,-1);});}function l(){p(function(n){n.destroy();}),_(s);}function d(){l(),i();}function v(n,t,i){n=at(r,t,i,n);n.mount(),s.push(n);}function h(n){return n?g(function(n){return !n.isClone}):s}function p(n,t){h(t).forEach(n);}function g(t){return s.filter("function"==typeof t?t:function(n){return D(t)?W(n.slide,t):x(w(t),n.index)})}return {mount:function(){i(),t(bn,d),t([ln,bn],function(){s.sort(function(n,t){return n.index-t.index});});},destroy:l,update:function(){p(function(n){n.update();});},register:v,get:h,getIn:function(n){var t=u.Controller,i=t.toIndex(n),r=t.hasFocus()?1:o.perPage;return g(function(n){return on(n.index,i,i+r-1)})},getAt:function(n){return g(n)[0]},add:function(n,u){b(n,function(n){var t,i,r;y(n=D(n)?Y(n):n)&&((t=f[u])?S(n,t):L(a,n),A(n,o.classes.slide),n=n,i=e.bind(null,kn),n=J(n,"img"),(r=n.length)?n.forEach(function(n){c(n,"load error",function(){--r||i();});}):i());}),e(bn);},remove:function(n){H(g(n).map(function(n){return n.slide})),e(bn);},forEach:p,filter:g,style:function(t,i,r){p(function(n){n.style(t,i,r);});},getLength:function(n){return (n?f:s).length},isEnough:function(){return s.length>o.perPage}}},Layout:function(n,t,i){var r,u,o=Pn(n),e=o.on,c=o.bind,f=o.emit,a=t.Slides,s=t.Direction.resolve,l=(t=t.Elements).root,d=t.track,v=t.list,h=a.getAt;function p(){u=null,r="ttb"===i.direction,C(l,"maxWidth",V(i.width)),C(d,s("paddingLeft"),m(!1)),C(d,s("paddingRight"),m(!0)),g();}function g(){var n=G(l);u&&u.width===n.width&&u.height===n.height||(C(d,"height",function(){var n="";r&&(Q(n=y(),"height or heightRatio is missing."),n="calc("+n+" - "+m(!1)+" - "+m(!0)+")");return n}()),a.style(s("marginRight"),V(i.gap)),a.style("width",(i.autoWidth?"":V(i.fixedWidth)||(r?"":w()))||null),a.style("height",V(i.fixedHeight)||(r?i.autoHeight?"":w():y())||null,!0),u=n,f(An));}function m(n){var t=i.padding,n=s(n?"right":"left");return t&&V(t[n]||(I(t)?0:t))||"0px"}function y(){return V(i.height||G(v).width*i.heightRatio)}function w(){var n=V(i.gap);return "calc((100%"+(n&&" + "+n)+")/"+(i.perPage||1)+(n&&" - "+n)+")"}function _(n,t){var i=h(n);if(i){n=G(i.slide)[s("right")],i=G(v)[s("left")];return un(n-i)+(t?0:b())}return 0}function b(){var n=h(0);return n&&parseFloat(C(n.slide,s("marginRight")))||0}return {mount:function(){p(),c(window,"resize load",Dn(f.bind(this,kn))),e([xn,bn],p),e(kn,g);},listSize:function(){return G(v)[s("width")]},slideSize:function(n,t){return (n=h(n||0))?G(n.slide)[s("width")]+(t?0:b()):0},sliderSize:function(){return _(n.length-1,!0)-_(-1,!0)},totalSize:_,getPadding:function(n){return parseFloat(C(d,s("padding"+(n?"Right":"Left"))))||0}}},Clones:function(c,n,f){var t,i=Pn(c),r=i.on,u=i.emit,a=n.Elements,s=n.Slides,o=n.Direction.resolve,l=[];function e(){(t=p())&&(function(u){var o=s.get().slice(),e=o.length;if(e){for(;o.length<u;)k(o,o);k(o.slice(-u),o.slice(0,u)).forEach(function(n,t){var i=t<u,r=function(n,t){n=n.cloneNode(!0);return A(n,f.classes.clone),n.id=c.root.id+"-clone"+an(t+1),n}(n.slide,t);i?S(r,o[0].slide):L(a.list,r),k(l,r),s.register(r,t-u+(i?0:e),n.index);});}}(t),u(kn));}function d(){H(l),_(l);}function v(){d(),e();}function h(){t<p()&&u(bn);}function p(){var n,t,i=f.clones;return c.is(ct)?i||(n=a.list,D(t=f[o("fixedWidth")])&&(t=G(n=F("div",{style:"width: "+t+"; position: absolute;"},n)).width,H(n)),i=((t=t)&&rn(G(a.track)[o("width")]/t)||f[o("autoWidth")]&&c.length||f.perPage)*(f.drag?(f.flickMaxPages||1)+1:2)):i=0,i}return {mount:function(){e(),r(bn,v),r([xn,kn],h);},destroy:d}},Move:function(e,c,f){var a,n=Pn(e),t=n.on,s=n.emit,r=(n=c.Layout).slideSize,i=n.getPadding,u=n.totalSize,o=n.listSize,l=n.sliderSize,d=(n=c.Direction).resolve,v=n.orient,h=(n=c.Elements).list,p=n.track;function g(){k()||(c.Scroll.cancel(),m(e.index),s(Ln));}function m(n){y(_(n,!0));}function y(n,t){e.is(ft)||(t=t?n:function(n){{var t,i;e.is(ct)&&(i=v(n-b()),t=A(!1,n)&&i<0,i=A(!0,n)&&0<i,(t||i)&&(n=w(n,i)));}return n}(n),h.style.transform="translate"+d("X")+"("+t+"px)",n!==t&&s(hn));}function w(n,t){var i=n-x(t),r=l();return n-=v(r*(rn(un(i)/r)||1))*(t?1:-1)}function _(n,t){var i=v(u(n-1)-(i=n,"center"===(n=f.focus)?(o()-r(i,!0))/2:+n*r(i)||0));return t?function(n){f.trimSpace&&e.is(et)&&(n=en(n,0,v(l()-o())));return n}(i):i}function b(){var n=d("left");return G(h)[n]-G(p)[n]+v(i(!1))}function x(n){return _(n?c.Controller.getEnd():0,!!f.trimSpace)}function k(){return e.state.is(4)&&f.waitForTransition}function A(n,t){t=O(t)?b():t;var i=!0!==n&&v(t)<v(x(!1)),t=!1!==n&&v(t)>v(x(!0));return i||t}return {mount:function(){a=c.Transition,t([ln,An,xn,bn],g);},destroy:function(){T(h,"style");},move:function(n,t,i,r){var u,o;k()||(u=e.state.set,o=b(),n!==t&&(a.cancel(),y(w(o,t<n),!0)),u(4),s(dn,t,i,n),a.start(t,function(){u(3),s(vn,t,i,n),"move"===f.trimSpace&&n!==i&&o===b()?c.Controller.go(i<n?">":"<",!1,r):r&&r();}));},jump:m,translate:y,shift:w,cancel:function(){y(b()),a.cancel();},toIndex:function(n){for(var t=c.Slides.get(),i=0,r=1/0,u=0;u<t.length;u++){var o=t[u].index,e=un(_(o,!0)-n);if(!(e<=r))break;r=e,i=o;}return i},toPosition:_,getPosition:b,getLimit:x,isBusy:k,exceededLimit:A}},Controller:function(n,e,u){var o,c,f,t=Pn(n).on,a=e.Move,s=a.getPosition,l=a.getLimit,i=e.Slides,d=i.isEnough,r=i.getLength,v=n.is(ct),h=n.is(et),p=u.start||0,g=p;function m(){o=r(!0),c=u.perMove,f=u.perPage,p=en(p,0,o-1);}function y(n,t,i,r,u){var o=t?n:S(n);e.Scroll.scroll(t||i?a.toPosition(o,!0):n,r,function(){z(a.toIndex(a.getPosition())),u&&u();});}function w(n){return b(!1,n)}function _(n){return b(!0,n)}function b(n,t){var i,r,u=c||(P()?1:f),o=x(p+u*(n?-1:1),p);return -1!==o||!h||(i=s(),r=l(!n),u=1,un(i-r)<u)?t?o:A(o):n?0:k()}function x(n,t,i){var r;return d()?(r=k(),n<0||r<n?n=on(0,n,t,!0)||on(r,t,n,!0)?L(E(n)):v?c||P()?n:n<0?-(o%f||f):o:u.rewind?n<0?r:0:-1:i||n===t||(n=c?n:L(E(t)+(n<t?-1:1)))):n=-1,n}function k(){var n=o-f;return (P()||v&&c)&&(n=o-1),nn(n,0)}function A(n){return v?d()?n%o+(n<0?o:0):-1:n}function L(n){return en(P()?n:f*n,0,k())}function E(n){return P()||(n=on(n,o-f,o-1)?o-1:n,n=tn(n/f)),n}function S(n){n=a.toIndex(n);return h?en(n,0,k()):n}function z(n){n!==p&&(g=p,p=n);}function P(){return !O(u.focus)||u.isNavigation}return {mount:function(){m(),t([xn,bn],m,R-1);},go:function(n,t,i){var r=function(n){var t=p;{var i,r;D(n)?(r=n.match(/([+\-<>])(\d+)?/)||[],i=r[1],r=r[2],"+"===i||"-"===i?t=x(p+ +(""+i+(+r||1)),p,!0):">"===i?t=r?L(+r):w(!0):"<"===i&&(t=_(!0))):t=v?n:en(n,0,k());}return t}(n);u.useScroll?y(r,!0,!0,u.speed,i):-1<(n=A(r))&&!a.isBusy()&&(t||n!==p)&&(z(n),a.move(r,n,g,i));},scroll:y,getNext:w,getPrev:_,getAdjacent:b,getEnd:k,setIndex:z,getIndex:function(n){return n?g:p},toIndex:L,toPage:E,toDest:S,hasFocus:P}},Arrows:function(u,n,i){var r,t=Pn(u),o=t.on,e=t.bind,c=t.emit,f=i.classes,a=i.i18n,s=n.Elements,l=n.Controller,d=s.arrows,v=s.prev,h=s.next,p={};function g(){var n,t;i.arrows&&(v&&h||(d=F("div",f.arrows),v=m(!0),h=m(!1),r=!0,L(d,[v,h]),S(d,P("slider"===i.arrows&&s.slider||u.root)))),v&&h&&(p.prev?N(d,!1===i.arrows?"none":""):(n=s.track.id,j(v,nt,n),j(h,nt,n),p.prev=v,p.next=h,t=l.go,o([ln,vn,xn,bn,En],y),e(h,"click",function(){t(">",!0);}),e(v,"click",function(){t("<",!0);}),c("arrows:mounted",v,h)));}function m(n){return Y('<button class="'+f.arrow+" "+(n?f.prev:f.next)+'" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40"><path d="'+(i.arrowPath||"m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z")+'" />')}function y(){var n=u.index,t=l.getPrev(),i=l.getNext(),r=-1<t&&n<t?a.last:a.prev,n=-1<i&&i<n?a.first:a.next;v.disabled=t<0,h.disabled=i<0,j(v,it,r),j(h,it,n),c("arrows:updated",v,h,t,i);}return {arrows:p,mount:function(){g(),o(xn,g);},destroy:function(){r?H(d):(T(v,ot),T(h,ot));}}},Autoplay:function(t,i,r){var u,o,e,n=Pn(t),c=n.on,f=n.bind,a=n.emit,s=Rn(r.interval,t.go.bind(t,">"),function(n){var t=d.bar;t&&C(t,"width",100*n+"%"),a("autoplay:playing",n);}),l=s.isPaused,d=i.Elements;function v(n){var t=n?"pause":"play",i=d[t];i&&(j(i,nt,d.track.id),j(i,it,r.i18n[t]),f(i,"click",n?p:h));}function h(){l()&&i.Slides.isEnough()&&(s.start(!r.resetProgress),o=u=e=!1,a("autoplay:play"));}function p(n){void 0===n&&(n=!0),l()||(s.pause(),a("autoplay:pause")),e=n;}function g(){e||(u||o?p(!1):h());}function m(){var n=i.Slides.getAt(t.index);s.set(n&&+X(n.slide,st)||r.interval);}return {mount:function(){var n=r.autoplay;n&&(v(!0),v(!1),function(){var n=d.root;r.pauseOnHover&&f(n,"mouseenter mouseleave",function(n){u="mouseenter"===n.type,g();});r.pauseOnFocus&&f(n,"focusin focusout",function(n){o="focusin"===n.type,g();});c([dn,"scroll",bn],s.rewind),c(dn,m);}(),"pause"!==n&&h());},destroy:s.cancel,play:h,pause:p,isPaused:l}},Cover:function(n,t,i){var r=Pn(n).on;function u(i){t.Slides.forEach(function(n){var t=P(n.container||n.slide,"img");t&&t.src&&o(i,t,n);});}function o(n,t,i){i.style("background",n?'center/cover no-repeat url("'+t.src+'")':"",!0),N(t,n?"none":"");}return {mount:function(){i.cover&&(r(zn,function(n,t){o(!0,n,t);}),r([ln,xn,bn],u.bind(null,!0)));},destroy:function(){u(!1);}}},Scroll:function(c,n,f){var a,s,t=Pn(c),i=t.on,l=t.emit,d=n.Move,v=d.getPosition,h=d.getLimit,p=d.exceededLimit;function g(r,n,t,u){var i,o=v(),e=1;n=n||(i=un(r-o),nn(i/1.5,800)),s=t,y(),a=Rn(n,m,function(n){var t=v(),i=(o+(r-o)*(i=n,(n=f.easingFunc)?n(i):1-Math.pow(1-i,4))-v())*e;d.translate(t+i),c.is(et)&&!u&&p()&&(e*=.6,un(i)<10&&(i=p(!1),g(h(!i),600,null,!0)));},1),l("scroll"),a.start();}function m(){var n=v(),t=d.toIndex(n);on(t,0,c.length-1)||d.translate(d.shift(n,0<t),!0),s&&s(),l(En);}function y(){a&&a.cancel();}function r(){a&&!a.isPaused()&&(y(),m());}return {mount:function(){i(dn,y),i([xn,bn],r);},destroy:y,scroll:g,cancel:r}},Drag:function(u,o,e){var c,f,a,s,l,d,v,r,h,n=Pn(u),t=n.on,p=n.emit,g=n.bind,m=n.unbind,y=o.Move,w=o.Scroll,_=o.Controller,b=o.Elements.track,i=(n=o.Direction).resolve,x=n.orient,k=y.getPosition,A=y.exceededLimit,L=!1;function E(){var n=e.drag;F(!n),l="free"===n;}function S(n){var t,i;r||(i=e.noDrag,t=j(n),i=!i||!W(n.target,i),v=!1,!i||!t&&n.button||(y.isBusy()?U(n,!0):(h=t?b:window,s=a=null,g(h,dt,z,lt),g(h,vt,P,lt),y.cancel(),w.cancel(),R(n))));}function z(n){var t,i,r;s||p("drag"),(s=n).cancelable&&(t=M(n)-M(f),d?(y.translate(c+t/(L&&u.is(et)?5:1)),i=200<T(n)-T(f),r=L!==(L=A()),(i||r)&&R(n),p("dragging"),v=!0,U(n)):(r=I(r=e.dragMinThreshold)?r:{mouse:0,touch:+r||10},d=un(t)>(j(n)?r.touch:r.mouse),O()&&U(n)));}function P(n){m(h,dt,z),m(h,vt,P);var t,i,r=u.index;s?((d||n.cancelable&&O())&&(t=function(n){if(u.is(ct)||!L){var t=f===s&&a||f,i=M(s)-M(t),t=T(n)-T(t),n=T(n)-T(s)<200;if(t&&n)return i/t}return 0}(n),i=t,i=k()+cn(i)*$(un(i)*(e.flickPower||600),l?1/0:o.Layout.listSize()*(e.flickMaxPages||1)),l?_.scroll(i):u.is(ft)?_.go(r+x(cn(t))):_.go(_.toDest(i),!0),U(n)),p("dragged")):l||k()===y.toPosition(r)||_.go(r,!0),d=!1;}function R(n){a=f,f=n,c=k();}function D(n){!r&&v&&U(n,!0);}function O(){var n=un(M(s)-M(f));return un(M(s,!0)-M(f,!0))<n}function M(n,t){return (j(n)?n.touches[0]:n)["page"+i(t?"Y":"X")]}function T(n){return n.timeStamp}function j(n){return "undefined"!=typeof TouchEvent&&n instanceof TouchEvent}function F(n){r=n;}return {mount:function(){g(b,dt,Z,lt),g(b,vt,Z,lt),g(b,"touchstart mousedown",S,lt),g(b,"click",D,{capture:!0}),g(b,"dragstart",U),t([ln,xn],E);},disable:F,isDragging:function(){return d}}},Keyboard:function(t,n,i){var r,u,o=Pn(t),e=o.on,c=o.bind,f=o.unbind,a=t.root,s=n.Direction.resolve;function l(){var n=i.keyboard;n&&("focused"===n?j(r=a,ut,0):r=window,c(r,pt,p));}function d(){f(r,pt),y(r)&&T(r,ut);}function v(){var n=u;u=!0,g(function(){u=n;});}function h(){d(),l();}function p(n){u||(n=n.key,(n=x(ht,n)?"Arrow"+n:n)===s("ArrowLeft")?t.go("<"):n===s("ArrowRight")&&t.go(">"));}return {mount:function(){l(),e(xn,h),e(dn,v);},destroy:d,disable:function(n){u=n;}}},LazyLoad:function(i,n,e){var t=Pn(i),r=t.on,u=t.off,o=t.bind,c=t.emit,f="sequential"===e.lazyLoad,a=[],s=0;function l(){v(),d();}function d(){n.Slides.forEach(function(o){J(o.slide,yt).forEach(function(n){var t,i,r=X(n,gt),u=X(n,mt);r===n.src&&u===n.srcset||(t=e.classes.spinner,j(i=P(i=n.parentElement,"."+t)||F("span",t,i),$n,"presentation"),a.push({o:n,e:o,src:r,srcset:u,c:i}),n.src||N(n,"none"));});}),f&&g();}function v(){s=0,a=[];}function h(){(a=a.filter(function(n){var t=e.perPage*((e.preloadPages||1)+1)-1;return !n.e.isWithin(i.index,t)||p(n)})).length||u(vn);}function p(t){var i=t.o;A(t.e.slide,Qn),o(i,"load error",function(n){!function(n,t){var i=n.e;K(i.slide,Qn),t||(H(n.c),N(n.o,""),c(zn,n.o,i),c(kn));f&&g();}(t,"error"===n.type);}),["srcset","src"].forEach(function(n){t[n]&&(j(i,n,t[n]),T(i,"src"===n?gt:mt));});}function g(){s<a.length&&p(a[s++]);}return {mount:function(){e.lazyLoad&&(d(),r(bn,l),f||r([ln,bn,vn,En],h));},destroy:v}},Pagination:function(l,n,d){var v,t=Pn(l),i=t.on,r=t.emit,h=t.bind,u=t.unbind,p=n.Slides,g=n.Elements,o=n.Controller,m=o.hasFocus,e=o.getIndex,y=[];function c(){f(),d.pagination&&p.isEnough()&&(function(){var n=l.length,t=d.classes,i=d.i18n,r=d.perPage,u="slider"===d.pagination&&g.slider||g.root,o=m()?n:rn(n/r);v=F("ul",t.pagination,u);for(var e=0;e<o;e++){var c=F("li",null,v),f=F("button",{class:t.page,type:"button"},c),a=p.getIn(e).map(function(n){return n.slide.id}),s=!m()&&1<r?i.pageX:i.slideX;h(f,"click",w.bind(null,e)),j(f,nt,a.join(" ")),j(f,it,fn(s,e+1)),y.push({li:c,button:f,page:e});}}(),r("pagination:mounted",{list:v,items:y},a(l.index)),s());}function f(){v&&(H(v),y.forEach(function(n){u(n.button,"click");}),_(y),v=null);}function w(t){o.go(">"+t,!0,function(){var n=p.getAt(o.toIndex(t));n&&((n=n.slide).setActive&&n.setActive()||n.focus({preventScroll:!0}));});}function a(n){return y[o.toPage(n)]}function s(){var n=a(e(!0)),t=a(e());n&&(K(n.button,qn),T(n.button,tt)),t&&(A(t.button,qn),j(t.button,tt,!0)),r("pagination:updated",{list:v,items:y},n,t);}return {items:y,mount:function(){c(),i([xn,bn],c),i([dn,En],s);},destroy:f,getAt:a,update:s}},Sync:function(u,n,i){var r=n.Elements.list,o=[];function t(){var n,t;u.splides.forEach(function(n){var i;n.isParent||(i=n.splide,[u,i].forEach(function(n){var t=Pn(n),r=n===u?i:u;t.on(dn,function(n,t,i){r.go(r.is(ct)?i:n);}),o.push(t);}));}),i.isNavigation&&(n=Pn(u),(t=n.on)(pn,f),t(_n,a),t([ln,xn],c),j(r,$n,"menu"),o.push(n),n.emit(Sn,u.splides));}function e(){T(r,ot),o.forEach(function(n){n.destroy();}),_(o);}function c(){j(r,p,"ttb"!==i.direction?"horizontal":null);}function f(n){u.go(n.index);}function a(n,t){x(wt,t.key)&&(f(n),U(t));}return {mount:t,destroy:e,remount:function(){e(),t();}}},Wheel:function(i,r,u){var n=Pn(i).bind;function t(n){var t;!n.cancelable||(t=n.deltaY)&&(i.go((t=t<0)?"<":">"),t=t,u.releaseWheel&&!i.state.is(4)&&-1===r.Controller.getAdjacent(t)||U(n));}return {mount:function(){u.wheel&&n(r.Elements.track,"wheel",t,lt);}}}}),bt={type:"slide",speed:400,waitForTransition:!0,perPage:1,cloneStatus:!0,arrows:!0,pagination:!0,interval:5e3,pauseOnHover:!0,pauseOnFocus:!0,resetProgress:!0,keyboard:!0,easing:"cubic-bezier(0.25, 1, 0.5, 1)",drag:!0,direction:"ltr",slideFocus:!0,trimSpace:!0,focusableNodes:"a, button, textarea, input, select, iframe",classes:{slide:Fn,clone:In,arrows:Cn,arrow:t,prev:Nn,next:Xn,pagination:i,page:i+"__page",spinner:m+"__spinner"},i18n:{prev:"Previous slide",next:"Next slide",first:"Go to first slide",last:"Go to last slide",slideX:"Go to slide %s",pageX:"Go to page %s",play:"Start autoplay",pause:"Pause autoplay"}};function xt(n,r,t){var i=Pn(n).on;return {mount:function(){i([ln,bn],function(){g(function(){r.Slides.style("transition","opacity "+t.speed+"ms "+t.easing);});});},start:function(n,t){var i=r.Elements.track;C(i,"height",V(G(i).height)),g(function(){t(),C(i,"height","");});},cancel:Z}}function kt(o,n,e){var c,t=Pn(o).bind,f=n.Move,a=n.Controller,i=n.Elements.list;function r(){s("");}function s(n){C(i,"transition",n);}return {mount:function(){t(i,"transitionend",function(n){n.target===i&&c&&(r(),c());});},start:function(n,t){var i=f.toPosition(n,!0),r=f.getPosition(),u=function(n){var t=e.rewindSpeed;if(o.is(et)&&t){var i=a.getIndex(!0),r=a.getEnd();if(0===i&&r<=n||r<=i&&0===n)return t}return e.speed}(n);1<=un(i-r)&&1<=u?(s("transform "+u+"ms "+e.easing),f.translate(i,!0),c=t):(f.jump(n),t());},cancel:r}}i=function(){function i(n,t){this.event=c(),this.Components={},this.state=d(1),this.splides=[],this.f={},this.a={};n=D(n)?q(document,n):n;Q(n,n+" is invalid."),this.root=n,l(bt,i.defaults),l(l(this.f,bt),t||{});}var n,r=i.prototype;return r.mount=function(n,t){var i=this,r=this.state,u=this.Components;return Q(r.is([1,5]),"Already mounted!"),r.set(1),this.s=u,this.l=t||this.l||(this.is(ft)?xt:kt),this.a=n||this.a,e(M({},_t,this.a,{Transition:this.l}),function(n,t){n=n(i,u,i.f);(u[t]=n).setup&&n.setup();}),e(u,function(n){n.mount&&n.mount();}),this.emit(ln),A(this.root,"is-initialized"),r.set(3),this.emit("ready"),this},r.sync=function(n){return this.splides.push({splide:n}),n.splides.push({splide:this,isParent:!0}),this.state.is(3)&&(this.s.Sync.remount(),n.Components.Sync.remount()),this},r.go=function(n){return this.s.Controller.go(n),this},r.on=function(n,t){return this.event.on(n,t,null,20),this},r.off=function(n){return this.event.off(n),this},r.emit=function(n){var t;return (t=this.event).emit.apply(t,[n].concat(s(arguments,1))),this},r.add=function(n,t){return this.s.Slides.add(n,t),this},r.remove=function(n){return this.s.Slides.remove(n),this},r.is=function(n){return this.f.type===n},r.refresh=function(){return this.emit(bn),this},r.destroy=function(t){void 0===t&&(t=!0);var n=this.event,i=this.state;return i.is(1)?n.on("ready",this.destroy.bind(this,t),this):(e(this.s,function(n){n.destroy&&n.destroy(t);},!0),n.emit(f),n.destroy(),t&&_(this.splides),i.set(5)),this},n=i,(r=[{key:"options",get:function(){return this.f},set:function(n){var t=this.f;l(t,n),this.state.is(1)||this.emit(xn,t);}},{key:"length",get:function(){return this.s.Slides.getLength(!0)}},{key:"index",get:function(){return this.s.Controller.getIndex()}}])&&At(n.prototype,r),Object.defineProperty(n,"prototype",{writable:!1}),i}();return i.defaults={},i.STATES=n,i},"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).Splide=t();

    // libs https://splidejs.com/


    /**
     * Basic UI: Slider(Splide.js).
     */
    const BasicSliderInitArray = [];
    const BasicSlider = (() => {

        class Core {

            constructor(element) {

                this.$el = element;
                this.$slides = Array.from(this.$el.querySelectorAll('.splide__slide'));            // slides.
                this.$type = (this.$el.getAttribute('data-slider-thumbs')) ? 'thumbs' : 'default'; // type: thumbs or default.                  

            }


            init() {

                this.variables();                                
                this.build();

            }


            variables() {
                
                let thumbsOptionsObject = JSON.parse(this.$el.getAttribute('data-thumbs-options')) || {}; // thumbs parameters data-attr.
                let sliderOptionsObject = JSON.parse(this.$el.getAttribute('data-slider-options')) || {}; // slider parameters data-attr.
                let dataSliderClasses = JSON.parse(this.$el.getAttribute('data-slider-classes'))   || {}; // clesses data-attr.            
                let dataSliderPadding = JSON.parse(this.$el.getAttribute('data-slider-padding'))   || {}; // paddings data-attr. 
                let dataSliderBreakpoints = JSON.parse(this.$el.getAttribute('data-slider-breakpoints')); // breakpoints data-attr.            

                /* 
                    The following options are missing(values default):
                    * keyboard
                    * dragAngleThreshold
                    * swipeDistanceThreshold
                    * flickVelocityThreshold
                    * flickPower
                    * flickMaxPages
                    * accessibility
                    * slideFocus
                    * isNavigation
                    * trimSpace
                    * updateOnMove
                    * throttle            
                */
                this.$sliderOptions = {
                    /* 
                        type slider:
                            'slide' 
                                EN: A carousel with the slide transition 
                                RU: Карусель со слайд-переходом.                        
                            'loop'
                                EN: A carousel carousel
                                RU: Слайдер-карусель.                        
                            'fade'
                                EN: A carousel with the fade transition. This does not support the perPage option
                                RU: Карусель с плавным переходом. Не поддерживает параметр perPage.
                    */    
                    'type': (sliderOptionsObject['type'] || 'slide'),
                    
                    /*
                     * EN: Determines whether to rewind the carousel or not. This does not work in the loop mode
                     * RU: Определяет, перематывать карусель назад или нет. Не работает в циклическом режиме.
                    */
                    'rewind': (sliderOptionsObject['rewind'] || false),
                    
                    /*
                     * EN: The transition speed in milliseconds. If 0, the carousel immediately jumps to the target slide
                     * RU: Скорость перехода в миллисекундах. Если 0, карусель сразу переходит к целевому слайду.                 
                     */
                    'speed': (sliderOptionsObject['speed'] || 400),
                    
                    /*
                     * EN: The transition speed on rewind in milliseconds. The speed value is used as default
                     * RU: Скорость перехода при перемотке назад в миллисекундах. Значение скорости используется по умолчанию. 
                     */
                    'rewindSpeed': (sliderOptionsObject['rewindSpeed'] || 0),
                    
                    /*
                     * EN: Determines whether to disable any actions while the carousel is transitioning. Even if false, the carousel forcibly waits for the transition on the loop points
                     * RU: Определяет, отключать ли какие-либо действия во время перехода карусели. Даже если false, карусель принудительно ожидает перехода по точкам цикла. 
                     */
                    'waitForTransition': (sliderOptionsObject['waitForTransition'] !== undefined ? sliderOptionsObject['waitForTransition'] : true),
                    
                    /*
                     * EN: Defines the carousel max width, accepting the CSS format such as 10em, 80vw
                     * RU: Определяет максимальную ширину карусели, принимая такой формат CSS, как 10em, 80vw.  
                     */
                    'width': (sliderOptionsObject['width'] || 0),
                    
                    /*
                     * EN: Defines the slide height, accepting the CSS format except for %
                     * RU: Определяет высоту слайда, принимая формат CSS, кроме %.
                     */
                    'height': (sliderOptionsObject['height'] || 0),
                    
                    /*
                     * EN: Fixes width of slides, accepting the CSS format. The carousel will ignore the perPage option if you provide this value
                     * RU: Фиксирует ширину слайдов, принимая формат CSS. Карусель будет игнорировать параметр perPage, если вы укажете это значение.
                     */
                    'fixedWidth': (sliderOptionsObject['fixedWidth'] || 0),
                    
                    /*
                     * EN: Fixes height of slides, accepting the CSS format except for %. The carousel will ignore perPage, height and heightRatio options if you provide this value
                     * RU: Фиксирует высоту слайдов, принимая формат CSS, кроме %. Карусель будет игнорировать параметры perPage, height и heightRatio, если вы укажете это значение.
                     */
                    'fixedHeight': (sliderOptionsObject['fixedHeight'] || 0),
                    
                    /*
                     * EN: Determines height of slides by the ratio to the carousel width. For example, when the carousel width is 1000 and the ratio is 0.3, the height will be 300. Be aware that Splide ignores this option when height or fixedHeight is provided
                     * RU: Определяет высоту слайдов по отношению к ширине карусели. Например, если ширина карусели равна 1000, а коэффициент равен 0,3, высота будет равна 300. Имейте в виду, что Splide игнорирует этот параметр, если указана высота или fixedHeight. 
                     */
                    'heightRatio': (sliderOptionsObject['heightRatio'] || 0),
                    
                    /*
                     * EN: If true, the width of slides are determined by their width. Do not provide perPage and perMove options (or set them to 1)
                     * RU: Если true, ширина слайдов определяется их шириной. Не указывайте параметры perPage и perMove (или установите для них значение 1).
                     */
                    'autoWidth': (sliderOptionsObject['autoWidth'] || false),
                    
                    /*
                     * EN: If true, the height of slides are determined by their height. Do not provide perPage and perMove options (or set them to 1)
                     * RU: Если true, высота слайдов определяется их высотой. Не указывайте параметры perPage и perMove (или установите для них значение 1).
                     */
                    'autoHeight': (sliderOptionsObject['autoHeight'] || false),
                    
                    /*
                     * EN: Determines the number of slides to display in a page. The value must be an integer
                     * RU: Определяет количество слайдов, отображаемых на странице. Значение должно быть целым числом.
                     */
                    'perPage': (sliderOptionsObject['perPage'] || 1),
                    
                    /*
                     * EN: Determines the number of slides to move at once. The following example displays 3 slides per page but moves slides one by one. The value must be an integer
                     * RU: Определяет количество слайдов, которые нужно перемещать одновременно. В следующем примере отображаются 3 слайда на странице, но слайды перемещаются по одному. Значение должно быть целым числом.
                     */
                    'perMove': (sliderOptionsObject['perMove'] || 1),
                    
                    /*
                     * EN: Specifies the number of clones on each side of the loop carousel
                     * RU: Указывает количество клонов на каждой стороне карусели цикла.
                     */
                    'сlones': (sliderOptionsObject['сlones'] || 0),
                    
                    /*
                     * EN: Defines the start index
                     * RU: Определяет начальный индекс.
                     */
                    'start': (sliderOptionsObject['start'] || 0),
                       
                    /*
                     * EN: Determines which slide should be active if the carousel has multiple slides in a page
                     * RU: Определяет, какой слайд должен быть активным, если карусель содержит несколько слайдов на странице.  
                     */   
                    'focus': (sliderOptionsObject['focus'] || 0),
                    
                    /*
                     * EN: The gap between slides. The CSS format is acceptable, such as 1em
                     * RU: Промежуток между слайдами. Допустим формат CSS, например 1em.
                     */
                    'gap': (sliderOptionsObject['gap'] || 0),
                    
                    /*
                     * EN: The timing function for the CSS transition, such as linear, ease or cubic-bezier()
                     * RU: Функция синхронизации для перехода CSS, например linear, easy или cube-bezier().
                     */
                    'easing': (sliderOptionsObject['easing'] || 'cubic-bezier(.42,.65,.27,.99)'),
                    
                    /*
                     * EN: Determines whether to create arrows or not. This option still must be true if you provide arrows by HTML
                     * RU: Определяет, создавать стрелки или нет. Этот параметр по-прежнему должен быть истинным, если вы предоставляете стрелки с помощью HTML.
                     */
                    'arrows': (sliderOptionsObject['arrows'] !== undefined ? sliderOptionsObject['arrows'] : true),
                    
                    /*
                     * EN: Changes the arrow SVG path, like 'm7.61 0.807-2.12...'. The SVG size must be 40×40
                     * RU: Изменяет путь стрелки SVG, например «m7.61 0.807-2.12...». Размер SVG должен быть 40×40.
                     */
                    'arrowPath': (sliderOptionsObject['arrowPath'] || ''),
                    
                    /*
                     * EN: Determines whether to create pagination (indicator dots) or not  
                     * RU: Определяет, создавать ли нумерацию страниц (точки индикатора) или нет.
                     */   
                    'pagination': (sliderOptionsObject['pagination'] !== undefined ? sliderOptionsObject['pagination'] : true),
                    
                    /*
                     * EN: Determines whether to enable autoplay or not. If 'paused', it will not begin when the carousel becomes active, which means you need to provide a play button or manually start it by Autoplay#play()
                     * RU: Определяет, включать автозапуск или нет. Если «пауза», она не начнется, когда карусель станет активной, что означает, что вам нужно предоставить кнопку воспроизведения или запустить ее вручную с помощью Autoplay#play().
                     */
                    'autoplay': (sliderOptionsObject['autoplay'] !== undefined ? sliderOptionsObject['autoplay'] : false),
                    
                    /*
                     * EN: The autoplay interval duration in milliseconds
                     * RU: Продолжительность интервала автовоспроизведения в миллисекундах.
                     */
                    'interval': (sliderOptionsObject['interval'] || 5000),

                    /*
                     * EN: Determines whether to pause autoplay on mouseover. This should be true for accessibility
                     * RU: Определяет, следует ли приостанавливать автовоспроизведение при наведении курсора мыши. Это должно быть верно для доступности.
                     */
                    'pauseOnHover': (sliderOptionsObject['pauseOnHover'] !== undefined ? sliderOptionsObject['pauseOnHover'] : true),
                    
                    /*
                     * EN: Determines whether to pause autoplay while the carousel contains the active element (focused element). This should be true for accessibility
                     * RU: Определяет, следует ли приостанавливать автовоспроизведение, пока карусель содержит активный элемент (элемент в фокусе). Это должно быть верно для доступности.
                     */
                    'pauseOnFocus': (sliderOptionsObject['pauseOnFocus'] !== undefined ? sliderOptionsObject['pauseOnFocus'] : true),
                    
                    /*
                     * EN: Determines whether to reset the autoplay progress when it is requested to start again
                     * RU: Определяет, сбрасывать ли прогресс автовоспроизведения, когда его запрашивают для повторного запуска.
                     */
                    'resetProgress': (sliderOptionsObject['resetProgress'] !== undefined ? sliderOptionsObject['resetProgress'] : true),
                    
                    /*
                     * EN: To make lazy load work, the img element in the slide must have the data-splide-lazy attribute that indicates the path or URL to the source file
                     * RU: Чтобы отложенная загрузка работала, элемент img на слайде должен иметь атрибут data-splide-lazy, указывающий путь или URL-адрес исходного файла.
                        values:
                            * false — Disables lazy loading / Отключает ленивую загрузку;
                            * nearby — Starts loading only images around the active slide (page) / Начинает загружать только изображения вокруг активного слайда (страницы);
                            * sequentia — Loads images sequentially / Загружает изображения последовательно
                     */
                    'lazyLoad': (sliderOptionsObject['lazyLoad'] || 'nearby'),
                    
                    /*
                     * EN: Determines how many pages (not slides) around the active slide should be loaded beforehand. This only works when the lazyLoad option is 'nearby'
                     * RU: Определяет, сколько страниц (не слайдов) вокруг активного слайда должно быть загружено заранее. Это работает только тогда, когда опция lazyLoad находится рядом.
                     */
                    'preloadPages': (sliderOptionsObject['preloadPages'] || 1),
                    
                    /*
                     * EN: Determines whether to allow the user to drag the carousel or not
                     * RU: Определяет, разрешить ли пользователю перетаскивать карусель или нет.
                        values:
                            * true —  Enables drag / Включает перетаскивание;
                            * false — Disables drag / Отключает перетаскивание;
                            * 'free' — Enables the drag free mode / Включает режим без перетаскивания.
                     */
                    'drag': (sliderOptionsObject['drag'] !== undefined ? sliderOptionsObject['drag'] : true),
                    /*
                     * EN: The direction of the carousel
                     * RU: Направление карусели.
                        values:
                            * 'ltr' — Left to right / Слева направо;
                            * 'rtl' — Right to left / Справа налево;
                            * 'ttb' — Top to bottom / Сверху вниз.
                     */   
                    'direction': (sliderOptionsObject['direction'] || "ltr"),
                    
                    /*
                     * EN: Converts the image src to the css background-image URL of the parent element. This requires height, fixedHeight or heightRatio option.
                     * RU: Преобразует исходный код изображения в URL-адрес фонового изображения css родительского элемента. Для этого требуется опция height, fixedHeight или heightRatio.
                     */
                    'cover': sliderOptionsObject['core'] || false,

                    /*
                     * EN: A set of adaptive options
                     * RU: Набор адаптивных опций.
                     */
                    'breakpoints': dataSliderBreakpoints || false,

                    /*
                     * EN: The collection of class names
                     * RU: Коллекция имен классов.
                     */
                    'classes': {
                      
                        // arrows.
                        'arrows': `splide__arrows ${ dataSliderClasses['arrows'] || '' }`,
                        'arrow' : `splide__arrow  ${ dataSliderClasses['arrow'] || '' }`,
                        'prev'  : `splide__arrow--prev ${ dataSliderClasses['prev'] || '' }`,
                        'next'  : `splide__arrow--next ${ dataSliderClasses['next'] || '' }`,
                        
                        // pagination.
                        'pagination': `splide__pagination ${ dataSliderClasses['pagination'] || '' }`, // container
                        'page'      : `splide__pagination__page ${ dataSliderClasses['page'] || '' }`, // each button
                    
                    },

                    /*
                     * EN: Sets the left/right padding for a horizontal carousel or top/bottom for a vertical carousel
                     * RU: Устанавливает отступ слева/справа для горизонтальной карусели или сверху/снизу для вертикальной карусели.
                     */
                    'padding': {
                        'top': dataSliderPadding['top'] || 0,
                        'left': dataSliderPadding['left'] || 0,
                        'right': dataSliderPadding['right'] || 0,
                        'bottom': dataSliderPadding['bottom'] || 0
                    }                
                };


                // thumbs
                this.$thumbsOptions = {                
                    pagination: false,
                    rewind: true,                
                    cover: true,
                    isNavigation: true,
                    
                    // включить отложенную загрузку(по умолчанию 'nearby' — загружать img только у активного слайда)
                    lazyLoad: 'nearby',                
                    
                    // эта опция работает, если в опции lazyLoad указано значение nearby
                    preloadPages: 1,
                    
                    // фиксировання ширина слайдера(любая единица измерения в css)
                    fixedWidth: (thumbsOptionsObject['fixedWidth'] || 100),
                    
                    // масимальная высота слайдера(любая единица измерения в css)
                    fixedHeight: (thumbsOptionsObject['fixedHeight'] || 64),

                    // индекс слайда для начала слайдера
                    start: (thumbsOptionsObject['start'] || 0),
                       
                    // индекс слайда на котором следует сфокусироваться    
                    focus: (thumbsOptionsObject['focus'] || 0),

                    // расстояние между слайдами
                    gap: (thumbsOptionsObject['gap'] || 10),
                    
                    // функция синхронизации анимации для перехода CSS
                    easing: (thumbsOptionsObject['easing'] || 'cubic-bezier(.42,.65,.27,.99)'),
                    
                    // стрелки(prev, next)
                    arrows: (thumbsOptionsObject['arrows'] !== undefined ? thumbsOptionsObject['arrows'] : false),
                    
                    // путь svg стрелки(формат 'm7.61 0.807-2.12…', размер svg 40x40)
                    arrowPath: (thumbsOptionsObject['arrowPath'] || ''),                

                    // адаптивный режим
                    breakpoints: thumbsOptionsObject['breakpoints'] || false,
                };

            }


            build() {
                
                // init
                if (this.$type == 'default') this.build_default();            
                if (this.$type == 'thumbs')  this.build_thumbs();
                
                this.$el.classList.add('slider');
                this.$el.classList.add('slider-init');

            }


            build_default() {

                this.$splide = new Splide(this.$el, this.$sliderOptions).mount();
                BasicSliderInitArray.push(this.$splide);

            }


            build_thumbs() {

                this.create_thumbs(); // соберём разметку thumbs-слайдера.
                this.$sliderOptions['pagination'] = false; // для основного слайдера выключим пагинацию.
                        
                this.$splide = new Splide(this.$el, this.$sliderOptions),
                this.$thumbnails = new Splide(this.thumbsSlider, this.$thumbsOptions); 
                
                this.$splide.sync(this.$thumbnails).mount();
                this.$thumbnails.mount();

                BasicSliderInitArray.push(this.$splide);

            }


            create_thumbs() {

                let imgElement = null,
                    slideElement = null,                
                    thumbsElement = null;


                // create main body
                thumbsElement = document.createElement('div');
                thumbsElement.classList.add('slider-thumbs');
                thumbsElement.classList.add('splide');
                thumbsElement.innerHTML = '<div class="splide__track"><div class="splide__list"></div></div>';

                // create slides
                this.$slides.forEach((value) => {

                    slideElement = document.createElement('div');
                    slideElement.classList.add('splide__slide');

                    // pic
                    if (value.getAttribute('data-slider-thumb') !== null) {

                        imgElement = document.createElement('img');
                        imgElement.setAttribute('src', value.getAttribute('data-slider-thumb'));                    
                        slideElement.innerHTML = imgElement.outerHTML;                     

                    // no pic    
                    } else {

                        slideElement.classList.add('splide__slide--no-pic');

                    } 

                    thumbsElement.querySelector('.splide__list').appendChild(slideElement);
                    
                });


                // add the created thumbs-slider
                this.$el.insertAdjacentHTML('afterend', thumbsElement.outerHTML);
                this.thumbsSlider = this.$el.nextElementSibling;

            }


            // events
            on({event, listener}) {

                let splide = BasicSliderInitArray.filter(element => element.root == this.$el) || false;

                if (splide !== false) splide[0].on(event, listener);
            
            }

        }


        let active = null;


    	/**
    	 * Slider initialization
    	 * @param {object|string} variable - element for initializing slider 
    	 * @param {object}        config   - element parameters 
    	 */
        const init = (variable, config) => {

            let options =  config || {},
                element = null,
                elements = BasicCore.variables(variable, '.js-slider');

                
            try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
                

                elements.forEach((value) => {

                    element = value;

                    active = new Core(value, options);
                    active.init();

                });

                
                return active;

            } catch(error) {

    			console.error(`${BasicCore.logging['name']} Slider init. \nMessage: ${error.message} \nElement: `, element);

    		}

        };


        /**
         * Slider events
         * @param {object|string} variable - slider for listening
         * @param {object}        config   - event parameters 
         */
        const on = (variable, config) => {

            let options =  config || {},
                element = null,
                elements = BasicCore.variables(variable, '.js-slider:not(.slider-init)');

            try {

                if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
                if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);
                

                // run
    			elements.forEach((value) => {

                    element = value;
                    active = new Core(value);
                    active.on(options);

                });

                
                return active;

            } catch(error) {

                console.error(`${BasicCore.logging['name']} Slider on. \nMessage: ${error.message} \nElement: `, element);

            }

        };


        return { init, on };

    })();


    window.BasicSlider = BasicSlider;

    /**
     * Basic UI: Lazy loading img.
     */
    const BasicLazyLoadingImg = (() => {

    	class Core {

    	    constructor(elements) {
    	        
    	        this.$elems = elements;


    			if ('loading' in HTMLImageElement.prototype) { 
    			    
    			    this.$elems.forEach(value => {

    			    	let dataLazySrc = value.getAttribute('data-lazy-src'); 
    					
    			    	value.setAttribute('src', dataLazySrc);
    			    	value.removeAttribute('data-lazy-src'); 
    			    	value.onload = () => value.classList.add('loaded');
    			    
    			    });

    			} else {

    				this.lazy_loading();
    				window.addEventListener('scroll', this.lazy_loading.bind(this), false);
    				
    			}
    	        		    	
    	    }


    		lazy_loading(event) {
    			
    			this.$elems.forEach((value, index, array) => {

    				if (window.outerHeight > Math.abs(value.getBoundingClientRect().top) && value.hasAttribute('src') == false) {

    					let lazy = value.getAttribute('data-lazy-src');
    					
    					value.setAttribute('src', lazy);
    					value.removeAttribute('data-lazy-src');
    					value.onload = () => value.classList.add('loaded');

    					array.splice(index, 1);

    				}				

    				
    				// если изображений с ленивой загрузкой больше на странице нет, то остановим обработчик.
    				if(array.length == 0) event.stopPropagation();

    			});

    		}
    	
    	}


    	let active = null;


    	/**
    	 * Lazy loading images initialization
    	 * @param {Object|string} variable - element for initializing lazy loading
    	 */
    	const init = (variable) => {

    		let elements = Array.from(document.querySelectorAll(variable || '[data-lazy-src]'));			
    		
    		active = new Core(elements);
    		return active;

    	};   


    	return { init };

    })();


    window.BasicLazyLoadingImg = BasicLazyLoadingImg;

    var localeRu = {
        days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        daysShort: ['Вос','Пон','Вто','Сре','Чет','Пят','Суб'],
        daysMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        today: 'Сегодня',
        clear: 'Очистить',
        dateFormat: 'dd.MM.yyyy',
        timeFormat: 'HH:mm',
        firstDay: 1
    };

    var consts = {
        days: 'days',
        months: 'months',
        years: 'years',
        day: 'day',
        month: 'month',
        year: 'year',

        eventChangeViewDate: 'changeViewDate',
        eventChangeCurrentView: 'changeCurrentView',

        /**
         * @param {Boolean} [viewDateTransition] - should perform transition to new viewDate
         * if passed date is out current month/year/decade range
         */
        eventChangeFocusDate: 'changeFocusDate',

        /**
         * @param {String} action
         * @param {Date} date
         * @param {Boolean} [updateTime] - if true, then timepicker will take time from passed date and save it to instance
         * @param {Boolean} [silent] - if true, then onChange event wont be triggered
         */
        eventChangeSelectedDate: 'changeSelectedDate',

        eventChangeTime: 'changeTime',
        eventChangeLastSelectedDate: 'changeLastSelectedDate',

        actionSelectDate: 'selectDate',
        actionUnselectDate: 'unselectDate',

        cssClassWeekend: '-weekend-'
    };

    var defaults = {
        classes: '',
        inline: false,
        locale: localeRu,
        startDate: new Date(),
        firstDay: '',
        weekends: [6, 0],
        dateFormat: '',
        altField: '',
        altFieldDateFormat: 'T',
        toggleSelected: true,
        keyboardNav: true,
        selectedDates: false,
        container: '',
        isMobile: false,
        visible: false,

        position: 'bottom left',
        offset: 12,

        view: consts.days,
        minView: consts.days,

        showOtherMonths: true,
        selectOtherMonths: true,
        moveToOtherMonthsOnSelect: true,

        showOtherYears: true,
        selectOtherYears: true,
        moveToOtherYearsOnSelect: true,

        minDate: '',
        maxDate: '',
        disableNavWhenOutOfRange: true,

        multipleDates: false, // Boolean or Number
        multipleDatesSeparator: ', ',
        range: false,
        dynamicRange: true,
        buttons: false,
        monthsField: 'monthsShort',

        showEvent: 'focus',
        autoClose: false,

        // navigation
        prevHtml: '<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',
        nextHtml: '<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',
        navTitles: {
            days: 'MMMM, <i>yyyy</i>',
            months: 'yyyy',
            years: 'yyyy1 - yyyy2'
        },

        timepicker: false,
        onlyTimepicker: false,
        dateTimeSeparator: ' ',
        timeFormat: '',
        minHours: 0,
        maxHours: 24,
        minMinutes: 0,
        maxMinutes: 59,
        hoursStep: 1,
        minutesStep: 1,

        onSelect: false,
        onChangeViewDate: false,
        onChangeView: false,
        onRenderCell: false,
        onShow: false,
        onHide: false,
    };

    /**
     * Finds DOM element
     * @param {HTMLElement, String} el
     * @param {Document|HTMLElement} [context=document]
     */

    function getEl(el, context = document) {
        return typeof el === 'string'
            ? context['querySelector'](el)
            : el;
    }

    /**
     * Creates HTML DOM element
     * @param {String} [tagName] - element's tag name
     * @param {String} [className]
     * @param {String} [innerHtml]
     * @param {String} [id]
     * @param {Object} [attrs]
     * @returns {HTMLElement}
     */
    function createElement({tagName = 'div', className = '', innerHtml = '', id = '', attrs = {}} = {}) {
        let $element = document.createElement(tagName);
        if (className) $element.classList.add(...className.split(' '));
        if (id) $element.id = id;

        if (innerHtml) {
            $element.innerHTML = innerHtml;
        }

        if (attrs) {
            for (let attr in attrs) {
                $element.setAttribute(attr, attrs[attr]);
            }
        }

        return $element;
    }

    /**
     * Sets multiple attributes of element
     * @param {HTMLElement} el
     * @param {Object} attrs - attributes object
     * @returns {HTMLElement}
     */
    function setAttribute(el, attrs) {
        for (let [name, value] of Object.entries(attrs)) {
            el.setAttribute(name, value);
        }
        return el;
    }

    /**
     * Inserts newElement after targetElement
     * @param {HTMLElement} newElement - element to be inserted
     * @param {HTMLElement} targetElement - after which must be inserted
     * @return {HTMLElement} newElement
     */
    function insertAfter(newElement, targetElement) {
        targetElement.parentNode
            .insertBefore(newElement, targetElement.nextSibling);
        return newElement;
    }

    /**
     * Makes object deep copy
     * @param {Object} obj
     * @return {Object}
     */
    function deepCopy(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    /**
     * Calculates amount of days in passed date
     * @param {Date} date
     * @return {number}
     */
    function getDaysCount(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    /**
     * Get detailed date object
     * @param {Date} date
     * @return {{
     *  date: number,
     *  hours: number,
     *  fullDate: (string|*),
     *  month: number,
     *  fullHours: (string|*),
     *  year: number,
     *  minutes: number,
     *  fullMonth: string,
     *  day: number,
     *  fullMinutes: (string|*)
     * }}
     */
    function getParsedDate(date) {
        let hours = date.getHours(),
            hours12 = hours % 12 === 0 ? 12 : hours % 12;

        return {
            year: date.getFullYear(),
            month: date.getMonth(),
            fullMonth: (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1, // One based
            date: date.getDate(),
            fullDate: date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
            day: date.getDay(),
            hours,
            fullHours: getLeadingZeroNum(hours),
            hours12,
            fullHours12: getLeadingZeroNum(hours12),
            minutes: date.getMinutes(),
            fullMinutes:  date.getMinutes() < 10 ? '0' + date.getMinutes() :  date.getMinutes()
        };
    }

    /**
     * Converts 1 -> 01
     * @param {Number} num
     * @return {String|Number}
     */
    function getLeadingZeroNum(num) {
        return num < 10 ? '0' + num : num;
    }

    /**
     * Calculates current decade
     * @param {Date} date
     * @return {number[]} - array of two years, decade start - decade end
     */
    function getDecade(date) {
        let firstYear = Math.floor(date.getFullYear() / 10) * 10;
        return [firstYear, firstYear + 9];
    }

    /**
     * Subtract days from date
     * @param {Date} date
     * @param {Number} days
     * @return {Date}
     */
    function subDays(date, days) {
        let {year, month, date: _date} = getParsedDate(date);
        return new Date(year, month, _date - days);
    }

    /**
     * Class names handler, inspired by https://github.com/JedWatson/classnames but very simplified
     * @param {String|Object} classes - class names, could contain strings or object
     */
    function classNames(...classes) {
        let classNames = [];

        classes.forEach((c) => {
            if (typeof c === 'object') {
                for (let cName in c) {
                    if (c[cName]) {
                        classNames.push(cName);
                    }
                }
            } else if (c) {
                classNames.push(c);
            }
        });
        return classNames.join(' ');
    }

    function toggleClass(el, classes) {
        for (let className in classes) {
            if (classes[className]) {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        }
    }

    function removeClass(el, ...classes) {
        if (el.length) {
            el.forEach((node) => {
                node.classList.remove(...classes);
            });
        } else {
            el.classList.remove(...classes);
        }
    }

    /**
     * Checks if passed dates are the same
     * @param {Date} date1
     * @param {Date} date2
     * @param {String} cellType - one of days|months|years
     * @return {boolean}
     */
    function isSameDate(date1, date2, cellType = consts.days) {
        if (!date1 || !date2) return false;
        let d1 = getParsedDate(date1),
            d2 = getParsedDate(date2),

            conditions = {
                [consts.days]: d1.date === d2.date && d1.month === d2.month && d1.year === d2.year,
                [consts.months]: d1.month === d2.month && d1.year === d2.year,
                [consts.years]: d1.year === d2.year
            };

        return conditions[cellType];
    }

    function isDateBigger(date, comparedDate, loose) {
        let d1 = copyDate(date, false).getTime(),
            d2 = copyDate(comparedDate, false).getTime();

        return loose
            ? d1 >= d2
            : d1 > d2;
    }

    function isDateSmaller(date, comparedDate) {
        return !isDateBigger(date, comparedDate, true);
    }

    /**
     * Copies date
     * @param {Date} date
     * @param {Boolean} [keepTime] - should keep the time in a new date or not
     * @return {Date}
     */
    function copyDate(date, keepTime = true) {
        let newDate = new Date(date.getTime());

        if (typeof keepTime === 'boolean' && !keepTime) {
            resetTime(newDate);
        }

        return newDate;
    }

    function resetTime(date) {
        date.setHours(0, 0, 0, 0);
        return date;
    }

    function isDateBetween(date, dateFrom, dateTo) {
        return isDateBigger(date, dateFrom) && isDateSmaller(date, dateTo);
    }

    /**
     * Adds event listener to DOM element
     * @param {HTMLElement|HTMLCollection} el
     * @param {String} type
     * @param {Function} listener
     */
    function addEventListener$1(el, type, listener) {
        if (el.length) {
            el.forEach((e) => {
                e.addEventListener(type, listener);
            });
        } else {
            el.addEventListener(type, listener);
        }
    }

    /**
     * Finds closest DOM element to passed target. Similar to jQuery.closest()
     * @param {HTMLElement} target
     * @param {String} selector
     * @return {HTMLElement|Boolean}
     */
    function closest(target, selector) {
        if (!target || target === document ||  target instanceof DocumentFragment) return false;

        if (target.matches(selector)) {
            return target;
        }

        return closest(target.parentNode, selector);
    }

    /**
     * Clamps number between min and max
     * @param {Number} val
     * @param {Number} min
     * @param {Number} max
     * @return {Number}
     */
    function clamp(val, min, max,) {
        return val > max
            ? max
            : val < min
                ? min
                : val;
    }

    /**
     * Deep merge of objects or arrays, used to merge options
     * @param {object|array} target - target object or array
     * @param {object|array} objects - source objects
     * @return {object|array}
     */
    function deepMerge(target, ...objects) {
        objects.filter(o => o).forEach((obj) => {
            for (let [key, value] of Object.entries(obj)) {
                let arrayOrObject = value !== undefined ? value.toString() === ('[object Object]' ) : false;

                if (arrayOrObject) {
                    let targetType = target[key] !== undefined ? target[key].toString() : undefined,
                        sourceType = value.toString(),
                        initialValue = Array.isArray(value) ? [] : {};

                    // If target and source types are different, e.g. we try to merge number with object,
                    // then take source type
                    target[key] = target[key]
                        ? targetType !== sourceType
                            ? initialValue
                            : target[key]
                        : initialValue;

                    deepMerge(target[key], value);
                } else {
                    target[key] = value;
                }
            }
        });

        return target;
    }

    /**
     * Creates Date object from string or number. If passed param is instance of Date, then just returns it.
     * @param {number|string|Date} date
     * @return {Date | boolean}
     */
    function createDate(date) {
        let resultDate = date;

        if (!(date instanceof Date)) {
            resultDate = new Date(date);
        }

        if (isNaN(resultDate.getTime())) {
            console.log(`Unable to convert value "${date}" to Date object`);
            resultDate = false;
        }

        return resultDate;
    }

    function getWordBoundaryRegExp(sign) {
        let symbols = '\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;';

        return new RegExp('(^|>|' + symbols + ')(' + sign + ')($|<|' + symbols + ')', 'g');
    }

    class DatepickerCell {
        constructor({type, date, dp, opts, body} = {}) {
            this.type = type;
            this.singleType = this.type.slice(0, -1); // days -> day etc.'`
            this.date = date;
            this.dp = dp;
            this.opts = opts;
            this.body = body;
            this.customData = false;

            this.init();
        }

        init() {
            let {range, onRenderCell} = this.opts;

            if (onRenderCell) {
                this.customData = onRenderCell({
                    date: this.date,
                    cellType: this.singleType,
                    datepicker: this.dp,
                });
            }

            this._createElement();
            this._bindDatepickerEvents();
            this._handleInitialFocusStatus();
            if (this.dp.hasSelectedDates) {
                this._handleSelectedStatus();
                if (range) {
                    this._handleRangeStatus();
                }
            }
        }

        _bindDatepickerEvents() {
            this.dp.on(consts.eventChangeSelectedDate, this.onChangeSelectedDate);
            this.dp.on(consts.eventChangeFocusDate, this.onChangeFocusDate);
        }

        unbindDatepickerEvents() {
            this.dp.off(consts.eventChangeSelectedDate, this.onChangeSelectedDate);
            this.dp.off(consts.eventChangeFocusDate, this.onChangeFocusDate);
        }

        _createElement() {
            let {year, month, date} = getParsedDate(this.date);

            this.$cell = createElement({
                className: this._getClassName(),
                attrs: {
                    'data-year': year,
                    'data-month': month,
                    'data-date': date
                }
            });
        }

        _getClassName() {
            let currentDate = new Date();
            let {selectOtherMonths, selectOtherYears} = this.opts;
            let {minDate, maxDate} = this.dp;
            let {day} = getParsedDate(this.date);
            let isOutOfMinMaxRange = this._isOutOfMinMaxRange();
            let disabled = this.customData?.disabled;

            let classNameCommon = classNames(
                'air-datepicker-cell',
                `-${this.singleType}-`, // days -> day etc.'`
                {
                    '-current-': isSameDate(currentDate, this.date, this.type),
                    '-min-date-': minDate && isSameDate(minDate, this.date, this.type),
                    '-max-date-': maxDate && isSameDate(maxDate, this.date, this.type),
                }
            );
            let classNameType = '';

            switch (this.type) {
                case consts.days:
                    classNameType = classNames({
                        '-weekend-': this.dp.isWeekend(day),
                        '-other-month-': this.isOtherMonth,
                        '-disabled-': this.isOtherMonth && !selectOtherMonths || isOutOfMinMaxRange || disabled
                    });
                    break;
                case consts.months:
                    classNameType = classNames({
                        '-disabled-': isOutOfMinMaxRange || disabled
                    });
                    break;
                case consts.years:
                    classNameType = classNames({
                        '-other-decade-': this.isOtherDecade,
                        '-disabled-': isOutOfMinMaxRange || (this.isOtherDecade && !selectOtherYears) || disabled
                    });
                    break;
            }

            return classNames(classNameCommon, classNameType, this.customData?.classes);
        }

        _getHtml() {
            let {year, month, date} = getParsedDate(this.date);
            let {showOtherMonths, showOtherYears} = this.opts;

            if (this.customData?.html) {
                return this.customData.html;
            }

            switch (this.type) {
                case consts.days:
                    return !showOtherMonths && this.isOtherMonth ? '' : date;
                case consts.months:
                    return this.dp.locale[this.opts.monthsField][month];
                case consts.years:
                    return !showOtherYears && this.isOtherDecade ? '' : year;
            }
        }

        _isOutOfMinMaxRange() {
            let {minDate, maxDate} = this.dp;
            let {type, date: cellDate} = this;
            let {month, year, date} = getParsedDate(cellDate);
            let isDay = type === consts.days;
            let isYear = type === consts.years;

            //Since in months cells date is set to the first day of month we should change it value to from min or max dates
            //to be able to mark cell as disabled correctly
            //Same goes to year cells
            let cellMinDate = minDate
                ? new Date(year, isYear ? minDate.getMonth() : month, isDay ? date : minDate.getDate())
                : false;
            let cellMaxDate = maxDate
                ? new Date(year, isYear ? maxDate.getMonth() : month, isDay ? date : maxDate.getDate())
                : false;

            if (minDate && maxDate) {
                return isDateSmaller(cellMinDate, minDate) || isDateBigger(cellMaxDate, maxDate);
            }

            if (minDate) {
                return isDateSmaller(cellMinDate, minDate);
            }

            if (maxDate) {
                return isDateBigger(cellMaxDate, maxDate);
            }
        }

        destroy() {
            this.unbindDatepickerEvents();
        }

        focus = () => {
            this.$cell.classList.add('-focus-');
            this.focused = true;
        }

        removeFocus = () => {
            this.$cell.classList.remove('-focus-');
            this.focused = false;
        }

        select = () => {
            this.$cell.classList.add('-selected-');
            this.selected = true;
        }

        removeSelect = () => {
            this.$cell.classList.remove('-selected-', '-range-from-', '-range-to-');
            this.selected = false;
        }

        _handleRangeStatus() {
            let {rangeDateFrom, rangeDateTo} = this.dp;
            let classes = classNames({
                '-in-range-': rangeDateFrom && rangeDateTo && isDateBetween(this.date, rangeDateFrom, rangeDateTo),
                '-range-from-': rangeDateFrom && isSameDate(this.date, rangeDateFrom, this.type),
                '-range-to-': rangeDateTo && isSameDate(this.date, rangeDateTo, this.type)
            });

            this.$cell.classList.remove('-range-from-', '-range-to-', '-in-range-');

            if (classes) {
                this.$cell.classList.add(...classes.split(' '));
            }
        }

        _handleSelectedStatus() {
            let selected = this.dp._checkIfDateIsSelected(this.date, this.type);
            if (selected) {
                this.select();
            } else if (!selected && this.selected) {
                this.removeSelect();
            }
        }

        _handleInitialFocusStatus() {
            let datesAreSame = isSameDate(this.dp.focusDate, this.date, this.type);

            if (datesAreSame) {
                this.focus();
            }
        }

        get isDisabled() {
            return this.$cell.matches('.-disabled-');
        }

        get isOtherMonth() {
            return this.dp.isOtherMonth(this.date);
        }

        get isOtherDecade() {
            return this.dp.isOtherDecade(this.date);
        }

        onChangeSelectedDate = () => {
            if (this.isDisabled) return;

            this._handleSelectedStatus();
            if (this.opts.range) {
                this._handleRangeStatus();
            }
        }

        onChangeFocusDate = (date) => {
            if (!date) {
                if (this.focused) {
                    this.removeFocus();
                }
                return;
            }

            let datesAreSame = isSameDate(date, this.date, this.type);

            if (datesAreSame) {
                this.focus();
            } else if (!datesAreSame && this.focused) {
                this.removeFocus();
            }

            if (this.opts.range) {
                this._handleRangeStatus();
            }
        }

        render = () => {
            this.$cell.innerHTML = this._getHtml();
            this.$cell.adpCell = this;

            return this.$cell;
        }
    }

    let templates = {
        [consts.days]:'' +
            '<div class="air-datepicker-body--day-names"></div>' +
            `<div class="air-datepicker-body--cells -${consts.days}-"></div>`,
        [consts.months]: `<div class="air-datepicker-body--cells -${consts.months}-"></div>`,
        [consts.years]: `<div class="air-datepicker-body--cells -${consts.years}-"></div>`
    };

    class DatepickerBody {
        constructor({dp, type, opts}) {
            this.dp = dp;
            this.type = type;
            this.opts = opts;
            this.cells = [];
            this.$el = '';
            this.pressed = false;
            this.isVisible = true;

            this.init();
        }

        init() {
            this._buildBaseHtml();
            if (this.type === consts.days) {
                this.renderDayNames();
            }
            this.render();
            this._bindEvents();
            this._bindDatepickerEvents();
        }

        _bindEvents() {
            let {range, dynamicRange} = this.opts;

            addEventListener$1(this.$el, 'mouseover', this.onMouseOverCell);
            addEventListener$1(this.$el, 'mouseout', this.onMouseOutCell);
            addEventListener$1(this.$el, 'click', this.onClickCell);

            if (range && dynamicRange) {
                addEventListener$1(this.$el, 'mousedown', this.onMouseDown);
                addEventListener$1(this.$el, 'mousemove', this.onMouseMove);
                addEventListener$1(window.document, 'mouseup', this.onMouseUp);
            }

        }

        _bindDatepickerEvents() {
            this.dp.on(consts.eventChangeViewDate, this.onChangeViewDate);
            this.dp.on(consts.eventChangeCurrentView, this.onChangeCurrentView);
        }

        _buildBaseHtml() {
            this.$el = createElement({
                className: `air-datepicker-body -${this.type}-`,
                innerHtml: templates[this.type]
            });

            this.$names = getEl('.air-datepicker-body--day-names', this.$el);
            this.$cells = getEl('.air-datepicker-body--cells', this.$el);
        }

        _getDayNamesHtml(firstDay = this.dp.locale.firstDay) {
            let html = '',
                isWeekend = this.dp.isWeekend,
                curDay = firstDay,
                i = 0;

            while (i < 7) {
                let day = curDay % 7;
                let className = classNames('air-datepicker-body--day-name', {
                    [consts.cssClassWeekend]: isWeekend(day)
                });
                let dayName = this.dp.locale.daysMin[day];

                html += `<div class="${className}">${dayName}</div>`;

                i++;
                curDay++;
            }
            return html;
        }

        _getDaysCells() {
            let {viewDate, locale: {firstDay}} = this.dp,
                totalMonthDays = getDaysCount(viewDate),
                {year, month} = getParsedDate(viewDate),
                firstMonthDay = new Date(year, month, 1),
                lastMonthDay = new Date(year, month, totalMonthDays),
                daysFromPrevMonth = firstMonthDay.getDay() - firstDay,
                daysFromNextMonth = 6 - lastMonthDay.getDay() + firstDay;

            daysFromPrevMonth = daysFromPrevMonth < 0 ? daysFromPrevMonth + 7 : daysFromPrevMonth;
            daysFromNextMonth = daysFromNextMonth > 6 ? daysFromNextMonth - 7 : daysFromNextMonth;

            let firstRenderDate = subDays(firstMonthDay, daysFromPrevMonth),
                totalRenderDays = totalMonthDays + daysFromPrevMonth + daysFromNextMonth,
                firstRenderDayDate = firstRenderDate.getDate(),
                {year:renderYear, month: renderMonth} = getParsedDate(firstRenderDate),
                i = 0;

            while (i < totalRenderDays) {
                let date = new Date(renderYear, renderMonth, firstRenderDayDate + i);
                this._generateCell(date);
                i++;
            }
        }

        _generateCell(date) {
            let {type, dp, opts} = this;
            let cell = new DatepickerCell({
                type,
                dp,
                opts,
                date,
                body: this
            });

            this.cells.push(cell);

            return cell;
        }

        _generateDayCells() {
            this._getDaysCells();
        }

        _generateMonthCells() {
            let totalMonths = 12,
                {year} = this.dp.parsedViewDate,
                currentMonth = 0;

            while (currentMonth < totalMonths) {
                this.cells.push(this._generateCell(new Date(year, currentMonth)));
                currentMonth++;
            }
        }

        _generateYearCells() {
            let decade = getDecade(this.dp.viewDate),
                firstYear = decade[0] - 1,
                lastYear = decade[1] + 1,
                year = firstYear;

            while (year <= lastYear) {
                this.cells.push(this._generateCell(new Date(year, 0)));
                year++;
            }
        }

        renderDayNames() {
            this.$names.innerHTML =  this._getDayNamesHtml();
        }

        _generateCells() {
            switch (this.type) {
                case consts.days:
                    this._generateDayCells();
                    break;
                case consts.months:
                    this._generateMonthCells();
                    break;
                case consts.years:
                    this._generateYearCells();
                    break;
            }
        }

        show() {
            this.isVisible = true;
            this.$el.classList.remove('-hidden-');
        }

        hide() {
            this.isVisible = false;
            this.$el.classList.add('-hidden-');
        }

        destroyCells() {
            this.cells.forEach(c => c.destroy());
            this.cells = [];
            this.$cells.innerHTML = '';
        }

        destroy() {
            this.destroyCells();
            this.dp.off(consts.eventChangeViewDate, this.onChangeViewDate);
            this.dp.off(consts.eventChangeCurrentView, this.onChangeCurrentView);
        }

        handleClick = (e) => {
            let $cell = closest(e.target, '.air-datepicker-cell');
            if (!$cell) return;
            let cell = $cell.adpCell;
            if (cell.isDisabled) return;

            if (!this.dp.isMinViewReached) {
                this.dp.down();
                return;
            }

            let alreadySelectedDate = this.dp._checkIfDateIsSelected(cell.date, cell.type);

            if (alreadySelectedDate) {
                this.dp._handleAlreadySelectedDates(alreadySelectedDate, cell.date);
            } else {
                this.dp.selectDate(cell.date);
            }
        }

        onChangeCurrentView = (view) => {
            if (view !== this.type) {
                this.hide();
            } else {
                this.show();
                this.render();
            }
        }

        onMouseOverCell = (e) => {
            let $cell = closest(e.target, '.air-datepicker-cell');
            this.dp.setFocusDate($cell ? $cell.adpCell.date : false);
        }

        onMouseOutCell = () => {
            this.dp.setFocusDate(false);
        }

        onClickCell = (e) => {
            this.handleClick(e);
        }

        onMouseDown = (e) => {
            this.pressed = true;

            let $cell = closest(e.target, '.air-datepicker-cell'),
                cell = $cell && $cell.adpCell;

            if (isSameDate(cell.date, this.dp.rangeDateFrom)) {
                this.rangeFromFocused = true;
            }
            if (isSameDate(cell.date, this.dp.rangeDateTo)) {
                this.rangeToFocused = true;
            }
        }

        onMouseMove = (e) => {
            if (!this.pressed || !this.dp.isMinViewReached) return;
            e.preventDefault();

            let $cell = closest(e.target, '.air-datepicker-cell'),
                cell = $cell && $cell.adpCell,
                {selectedDates, rangeDateTo, rangeDateFrom} = this.dp;

            if (!cell || cell.isDisabled) return;

            let {date} = cell;

            // Allow user to change selected range
            if (selectedDates.length === 2) {
                // Add hours and minute to new selected date, to update time sliders properly
                if (this.rangeFromFocused && !isDateBigger(date, rangeDateTo)) {
                    let {hours, minutes} = getParsedDate(rangeDateFrom);
                    date.setHours(hours);
                    date.setMinutes(minutes);

                    this.dp.rangeDateFrom = date;
                    this.dp.replaceDate(rangeDateFrom, date);
                }
                if (this.rangeToFocused && !isDateSmaller(date, rangeDateFrom)) {
                    let {hours, minutes} = getParsedDate(rangeDateTo);
                    date.setHours(hours);
                    date.setMinutes(minutes);

                    this.dp.rangeDateTo = date;
                    this.dp.replaceDate(rangeDateTo, date);
                }
            }
        }

        onMouseUp = () => {
            this.pressed = false;
            this.rangeFromFocused = false;
            this.rangeToFocused = false;
        }

        onChangeViewDate = (date, oldViewDate) => {
            // Handle only visible views
            if (!this.isVisible) return;

            let decade1 = getDecade(date),
                decade2 = getDecade(oldViewDate);

            // Prevent unnecessary cell rendering when going up or down to next view
            switch (this.dp.currentView) {
                case (consts.days):
                    if (isSameDate(date, oldViewDate, consts.months)) {
                        return;
                    }
                    break;
                case (consts.months):
                    if (isSameDate(date, oldViewDate, consts.years)) {
                        return;
                    }
                    break;
                case (consts.years):
                    if (decade1[0] === decade2[0] && decade1[1] === decade2[1]) {
                        return;
                    }
                    break;
            }

            this.render();
        }

        render = () => {
            this.destroyCells();


            this._generateCells();
            this.cells.forEach((c) => {
                this.$cells.appendChild(c.render());
            });
        }
    }

    class DatepickerNav {
        constructor({dp, opts}) {
            this.dp = dp;
            this.opts = opts;

            this.init();
        }

        init() {
            this._createElement();
            this._buildBaseHtml();
            this._defineDOM();

            this.render();

            this.handleNavStatus();
            this._bindEvents();
            this._bindDatepickerEvents();
        }

        _defineDOM() {
            this.$title = getEl('.air-datepicker-nav--title', this.$el);
            this.$prev = getEl('[data-action="prev"]', this.$el);
            this.$next = getEl('[data-action="next"]', this.$el);
        }

        _bindEvents() {
            this.$el.addEventListener('click', this.onClickNav);
            this.$title.addEventListener('click', this.onClickNavTitle);
        }

        _bindDatepickerEvents() {
            this.dp.on(consts.eventChangeViewDate, this.onChangeViewDate);
            this.dp.on(consts.eventChangeCurrentView, this.onChangeCurrentView);

            if (this.isNavIsFunction) {
                // Wait till time is added to date
                this.dp.on(consts.eventChangeSelectedDate, this.renderDelay);

                if (this.dp.opts.timepicker) {
                    this.dp.on(consts.eventChangeTime, this.render);
                }
            }
        }

        destroy() {
            this.dp.off(consts.eventChangeViewDate, this.onChangeViewDate);
            this.dp.off(consts.eventChangeCurrentView, this.onChangeCurrentView);
            if (this.isNavIsFunction) {
                this.dp.off(consts.eventChangeSelectedDate, this.renderDelay);
                if (this.dp.opts.timepicker) {
                    this.dp.off(consts.eventChangeTime, this.render);
                }
            }
        }

        _createElement() {
            this.$el = createElement({
                tagName: 'nav',
                className: 'air-datepicker-nav'
            });
        }

        _getTitle() {
            let {dp, opts} = this;
            let template = opts.navTitles[dp.currentView];

            if (typeof template === 'function') {
                return template(dp);
            }

            return dp.formatDate(dp.viewDate, template);
        }

        handleNavStatus() {
            let {disableNavWhenOutOfRange} = this.opts;
            let {minDate, maxDate} = this.dp;
            if (!(minDate || maxDate) || !disableNavWhenOutOfRange) return;

            let {year, month} = this.dp.parsedViewDate;
            let minDateParsed = minDate ? getParsedDate(minDate) : false;
            let maxDateParsed = maxDate ? getParsedDate(maxDate) : false;

            switch (this.dp.currentView) {
                case consts.days:
                    if (minDate && (minDateParsed.month >= month && minDateParsed.year >= year)) {
                        this._disableNav('prev');
                    }
                    if (maxDate && maxDateParsed.month <= month && maxDateParsed.year <= year) {
                        this._disableNav('next');
                    }
                    break;
                case consts.months:
                    if (minDate && minDateParsed.year >= year) {
                        this._disableNav('prev');
                    }
                    if (maxDate && maxDateParsed.year <= year) {
                        this._disableNav('next');
                    }
                    break;
                case consts.years: {
                    let decade = getDecade(this.dp.viewDate);
                    if (minDate && minDateParsed.year >= decade[0]) {
                        this._disableNav('prev');
                    }
                    if (maxDate && maxDateParsed.year <= decade[1]) {
                        this._disableNav('next');
                    }
                    break;
                }
            }
        }

        _disableNav(actionName) {
            getEl('[data-action="' + actionName + '"]', this.$el).classList.add('-disabled-');
        }

        _resetNavStatus() {
            removeClass(this.$el.querySelectorAll('.air-datepicker-nav--action'), '-disabled-');
        }

        onClickNav = (e) => {
            let $item = closest(e.target, '.air-datepicker-nav--action');
            if (!$item) return;

            let actionName = $item.dataset.action;

            this.dp[actionName]();
        }

        onChangeViewDate = () => {
            this.render();
            this._resetNavStatus();
            this.handleNavStatus();
        }

        onChangeCurrentView = () => {
            this.render();
            this._resetNavStatus();
            this.handleNavStatus();
        }

        onClickNavTitle = () => {
            if (this.dp.isFinalView) return;
            this.dp.up();
        }

        _buildBaseHtml() {
            let {prevHtml, nextHtml} = this.opts;

            this.$el.innerHTML = '' +
                `<div class="air-datepicker-nav--action" data-action="prev">${prevHtml}</div>` +
                '<div class="air-datepicker-nav--title"></div>' +
                `<div class="air-datepicker-nav--action" data-action="next">${nextHtml}</div>`;
        }

        get isNavIsFunction() {
            let {navTitles} = this.opts;

            return Object.keys(navTitles).find((view) => {
                return typeof navTitles[view] === 'function';
            });
        }

        update = () => {
            let {prevHtml, nextHtml} = this.opts;

            this.$prev.innerHTML = prevHtml;
            this.$next.innerHTML = nextHtml;

            this._resetNavStatus();
            this.render();
            this.handleNavStatus();
        }

        renderDelay = () => {
            setTimeout(this.render);
        }

        render = () => {
            this.$title.innerHTML = this._getTitle();

            toggleClass(this.$title, {
                '-disabled-': this.dp.isFinalView
            });
        }
    }

    var buttonPresets = {
        today: {
            content: dp => dp.locale.today,
            onClick: dp => dp.setViewDate(new Date()),
        },
        clear: {
            content: dp => dp.locale.clear,
            onClick: dp => dp.clear()
        }
    };

    class DatepickerButtons {
        constructor({dp, opts}) {
            this.dp = dp;
            this.opts = opts;

            this.init();
        }

        init() {
            this.createElement();
            this.render();
        }

        createElement() {
            this.$el = createElement({className: 'air-datepicker-buttons'});
        }

        destroy() {
            this.$el.parentNode.removeChild(this.$el);
        }

        clearHtml() {
            this.$el.innerHTML = '';
            return this;
        }

        generateButtons() {
            let {buttons} = this.opts;

            if (!Array.isArray(buttons)) {
                buttons = [buttons];
            }

            buttons.forEach((b) => {
                let data = b;

                if (typeof b === 'string' && buttonPresets[b]) {
                    data = buttonPresets[b];
                }

                let button = this.createButton(data);
                if (data.onClick) {
                    this.attachEventToButton(button, data.onClick);
                }

                this.$el.appendChild(button);
            });

        }

        attachEventToButton(button, onClick) {
            button.addEventListener('click', () => {
                onClick(this.dp);
            });
        }

        /**
         * Creates datepicker button HTML element
         * @param {String|Function} content - button content
         * @param {String} [className]
         * @param {String} [tagName=button]
         * @param {Object} [attrs]
         * @return HTMLElement
         */
        createButton({content, className, tagName = 'button', attrs = {}}) {
            let _content = typeof content === 'function' ? content(this.dp) : content;

            return createElement({
                tagName,
                innerHtml: `<span tabindex='-1'>${_content}</span>`,
                className: classNames('air-datepicker-button', className),
                attrs
            });
        }

        render() {
            this.generateButtons();
        }
    }

    /**
     * Timepicker
     *
     * How does it work:
     * Timepicker has its own hour and minute values. At the start they will be equal to current time, or to min/max date values.
     * When user selects date, timepicker add its values to the date (when consts.eventChangeSelectedDate is triggered).
     * When lastSelectedDate is changed (e.g. when user clicks on already selected date in multiple dates mode or in range mode)
     * then hour and minute values are taken from this date and stored in a timepicker instance.
     *
     */
    class DatepickerTime {
        constructor({opts, dp} = {}) {
            this.opts = opts;
            this.dp = dp;
            let {timeFormat} = this.dp.locale;

            if (timeFormat && (timeFormat.match(getWordBoundaryRegExp('h')) || timeFormat.match(getWordBoundaryRegExp('hh')))) {
                this.ampm = true;
            }

            this.init();
        }

        init() {
            this.setTime(this.dp.lastSelectedDate || this.dp.viewDate);
            this.createElement();
            this.buildHtml();
            this.defineDOM();
            this.render();

            this.bindDatepickerEvents();
            this.bindDOMEvents();
        }

        bindDatepickerEvents() {
            this.dp.on(consts.eventChangeSelectedDate, this.onChangeSelectedDate);
            this.dp.on(consts.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
        }

        bindDOMEvents() {
            let changeEvent = 'input';
            if (navigator.userAgent.match(/trident/gi)) {
                changeEvent = 'change';
            }

            addEventListener$1(this.$ranges, changeEvent, this.onChangeInputRange);
            addEventListener$1(this.$ranges, 'mouseenter', this.onMouseEnterLeave);
            addEventListener$1(this.$ranges, 'mouseleave', this.onMouseEnterLeave);
            addEventListener$1(this.$ranges, 'focus', this.onFocus);
            addEventListener$1(this.$ranges, 'mousedown', this.onFocus);
            addEventListener$1(this.$ranges, 'blur', this.onBlur);
        }

        createElement() {
            this.$el = createElement({className: classNames('air-datepicker-time', {'-am-pm-': this.dp.ampm})});
        }

        destroy() {
            this.dp.off(consts.eventChangeSelectedDate, this.onChangeSelectedDate);
            this.dp.off(consts.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
            this.$el.parentNode.removeChild(this.$el);
        }

        buildHtml() {
            let {
                ampm, hours, displayHours, minutes, minHours, minMinutes, maxHours, maxMinutes, dayPeriod,
                opts: {hoursStep, minutesStep}
            } = this;

            this.$el.innerHTML = '' +
                '<div class="air-datepicker-time--current">' +
                `   <span class="air-datepicker-time--current-hours">${getLeadingZeroNum(displayHours)}</span>` +
                '   <span class="air-datepicker-time--current-colon">:</span>' +
                `   <span class="air-datepicker-time--current-minutes">${getLeadingZeroNum(minutes)}</span>` +
                `   ${ampm ? `<span class='air-datepicker-time--current-ampm'>${dayPeriod}</span>` : ''}` +
                '</div>' +
                '<div class="air-datepicker-time--sliders">' +
                '   <div class="air-datepicker-time--row">' +
                // eslint-disable-next-line max-len
                `      <input type="range" name="hours" value="${hours}" min="${minHours}" max="${maxHours}" step="${hoursStep}"/>` +
                '   </div>' +
                '   <div class="air-datepicker-time--row">' +
                // eslint-disable-next-line max-len
                `      <input type="range" name="minutes" value="${minutes}" min="${minMinutes}" max="${maxMinutes}" step="${minutesStep}"/>` +
                '   </div>' +
                '</div>';
        }

        defineDOM() {
            let getElWithContext = selector => getEl(selector, this.$el);

            this.$ranges = this.$el.querySelectorAll('[type="range"]');
            this.$hours = getElWithContext('[name="hours"]');
            this.$minutes = getElWithContext('[name="minutes"]');
            this.$hoursText = getElWithContext('.air-datepicker-time--current-hours');
            this.$minutesText = getElWithContext('.air-datepicker-time--current-minutes');
            this.$ampm = getElWithContext('.air-datepicker-time--current-ampm');
        }


        setTime(date) {
            this.setMinMaxTime(date);
            this.setCurrentTime(date);
        }

        addTimeToDate(date) {
            if (!date) return;
            date.setHours(this.hours);
            date.setMinutes(this.minutes);
        }

        setMinMaxTime(date) {
            this.setMinMaxTimeFromOptions();

            if (date) {
                let {minDate, maxDate} = this.dp;
                if (minDate && isSameDate(date, minDate)) {
                    this.setMinTimeFromMinDate(minDate);
                }
                if (maxDate && isSameDate(date, maxDate)) {
                    this.setMaxTimeFromMaxDate(maxDate);
                }
            }
        }

        setCurrentTime(date) {
            let {hours, minutes} = date ? getParsedDate(date) : this;

            this.hours = clamp(hours, this.minHours, this.maxHours);
            this.minutes = clamp(minutes, this.minMinutes, this.maxMinutes);
        }

        setMinMaxTimeFromOptions() {
            let maxHoursPossible = 23,
                maxMinutesPossible = 59,
                {minHours, minMinutes, maxHours, maxMinutes} = this.opts;

            this.minHours = clamp(minHours, 0, maxHoursPossible);
            this.minMinutes = clamp(minMinutes, 0, maxMinutesPossible);
            this.maxHours = clamp(maxHours, 0, maxHoursPossible);
            this.maxMinutes = clamp(maxMinutes, 0, maxMinutesPossible);
        }

        setMinTimeFromMinDate(date) {
            let {lastSelectedDate} = this.dp;

            this.minHours = date.getHours();

            if (lastSelectedDate && lastSelectedDate.getHours() > date.getHours()) {
                this.minMinutes = this.opts.minMinutes;
            } else {
                this.minMinutes = date.getMinutes();
            }
        }

        setMaxTimeFromMaxDate(date) {
            let {lastSelectedDate} = this.dp;

            this.maxHours = date.getHours();

            if (lastSelectedDate && lastSelectedDate.getHours() < date.getHours()) {
                this.maxMinutes = this.opts.maxMinutes;
            } else {
                this.maxMinutes = date.getMinutes();
            }
        }

        /**
         * Calculates valid hour value to display in text input and datepicker's body.
         * @param date {Date|Number} - date or hours
         * @param [ampm] {Boolean} - 12 hours mode
         * @returns {{hours: number, dayPeriod: string}}
         */
        getDayPeriod(date, ampm) {
            let _date = date,
                hours = Number(date);

            if (date instanceof Date) {
                _date = getParsedDate(date);
                hours = Number(_date.hours);
            }

            let _ampm = ampm || this.ampm,
                dayPeriod = 'am';

            if (_ampm) {
                switch (true) {
                    case hours === 12:
                        dayPeriod = 'pm';
                        break;
                    case hours > 11:
                        dayPeriod = 'pm';
                        break;
                }

                hours = hours % 12 === 0 ? 12 : hours % 12;
            }

            return {
                hours,
                dayPeriod
            };
        }

        updateSliders() {
            setAttribute(this.$hours, {
                min: this.minHours,
                max: this.maxHours
            }).value = this.hours;

            setAttribute(this.$minutes, {
                min: this.minMinutes,
                max: this.maxMinutes
            }).value = this.minutes;
        }

        updateText() {
            this.$hoursText.innerHTML = getLeadingZeroNum(this.displayHours);
            this.$minutesText.innerHTML =  getLeadingZeroNum(this.minutes);

            if (this.ampm) {
                this.$ampm.innerHTML = this.dayPeriod;
            }
        }

        toggleTimepickerIsActive = (value) => {
            this.dp.timepickerIsActive = value;
        }

        onChangeSelectedDate = ({date, updateTime = false}) => {
            if (!date) return;

            // Check if date is minDate or maxDate and set timepicker's time to corresponding values
            this.setMinMaxTime(date);
            this.setCurrentTime(updateTime ? date : false);

            this.addTimeToDate(date);
        }

        onChangeLastSelectedDate = (date) => {
            if (!date) return;

            this.setTime(date);
            this.render();
        }

        onChangeInputRange = (e) => {
            let $target = e.target,
                name = $target.getAttribute('name');

            this[name] = $target.value;
            this.updateText();

            this.dp.trigger(consts.eventChangeTime, {
                hours: this.hours,
                minutes: this.minutes
            });
        }

        onMouseEnterLeave = (e) => {
            let name = e.target.getAttribute('name'),
                $el = this.$minutesText;

            if (name === 'hours') {
                $el = this.$hoursText;
            }

            $el.classList.toggle('-focus-');
        }

        onFocus = () => {
            this.toggleTimepickerIsActive(true);
        }

        onBlur = () => {
            this.toggleTimepickerIsActive(false);
        }

        set hours(val) {
            this._hours = val;

            let {hours, dayPeriod} = this.getDayPeriod(val);

            this.displayHours = hours;
            this.dayPeriod = dayPeriod;
        }

        get hours() {
            return this._hours;
        }

        render() {
            this.updateSliders();
            this.updateText();
        }
    }

    class DatepickerKeyboard {
        pressedKeys = new Set();
        
        hotKeys = new Map(
            [
                [[['Control', 'ArrowRight'], ['Control', 'ArrowUp']], dateParts =>  dateParts.month++],
                [[['Control', 'ArrowLeft'], ['Control', 'ArrowDown']], dateParts =>  dateParts.month--],
                [[['Shift', 'ArrowRight'], ['Shift', 'ArrowUp']], dateParts =>  dateParts.year++],
                [[['Shift', 'ArrowLeft'], ['Shift', 'ArrowDown']], dateParts =>  dateParts.year--],
                [[['Alt', 'ArrowRight'], ['Alt', 'ArrowUp']], dateParts =>  dateParts.year += 10],
                [[['Alt', 'ArrowLeft'], ['Alt', 'ArrowDown']], dateParts =>  dateParts.year -= 10],
                [['Control', 'Shift', 'ArrowUp'], (dateParts, dp) =>  dp.up()],
            ]
        )

        constructor({dp, opts}) {
            this.dp = dp;
            this.opts = opts;

            this.init();
        }

        init() {
            this.bindKeyboardEvents();
        }

        bindKeyboardEvents() {
            let {$el} = this.dp;

            $el.addEventListener('keydown', this.onKeyDown);
            $el.addEventListener('keyup', this.onKeyUp);
        }

        destroy() {
            let {$el} = this.dp;

            $el.removeEventListener('keydown', this.onKeyDown);
            $el.removeEventListener('keyup', this.onKeyUp);
            this.hotKeys = null;
            this.pressedKeys = null;
        }
        
        getInitialFocusDate() {
            let {focusDate, currentView, selectedDates, parsedViewDate: {year, month}} = this.dp;
            let potentialFocused  = focusDate || selectedDates[selectedDates.length - 1];

            if (!potentialFocused) {
                switch (currentView) {
                    case consts.days:
                        potentialFocused = new Date(year, month, new Date().getDate());
                        break;
                    case consts.months:
                        potentialFocused = new Date(year, month, 1);
                        break;
                    case consts.years:
                        potentialFocused = new Date(year, 0, 1);
                        break;
                }
            }

            return potentialFocused;
        }

        focusNextCell(keyName) {
            let initialFocusDate = this.getInitialFocusDate(),
                {currentView} = this.dp,
                {days, months, years} = consts,
                parsedFocusDate = getParsedDate(initialFocusDate),
                y = parsedFocusDate.year,
                m = parsedFocusDate.month,
                d = parsedFocusDate.date;

            switch (keyName) {
                case 'ArrowLeft':
                    currentView === days ? (d -= 1) : '';
                    currentView === months ? (m -= 1) : '';
                    currentView === years ? (y -= 1) : '';
                    break;
                case 'ArrowUp':
                    currentView === days ? (d -= 7) : '';
                    currentView === months ? (m -= 3) : '';
                    currentView === years ? (y -= 4) : '';
                    break;
                case 'ArrowRight':
                    currentView === days ? (d += 1) : '';
                    currentView === months ? (m += 1) : '';
                    currentView === years ? (y += 1) : '';
                    break;
                case 'ArrowDown':
                    currentView === days ? (d += 7) : '';
                    currentView === months ? (m += 3) : '';
                    currentView === years ? (y += 4) : '';
                    break;
            }

            let newFocusedDate = this.dp.getClampedDate(new Date(y, m, d));
            this.dp.setFocusDate(newFocusedDate, {viewDateTransition: true});
        }

        registerKey(keyName) {
            this.pressedKeys.add(keyName);
        }

        removeKey(keyName) {
            this.pressedKeys.delete(keyName);
        }

        handleHotKey = (combination) => {
            let fn = this.hotKeys.get(combination),
                dateParts = getParsedDate(this.getInitialFocusDate());

            fn(dateParts, this.dp);

            let {year, month, date} = dateParts;

            let totalDaysInNextMonth = getDaysCount(new Date(year, month));

            if (totalDaysInNextMonth < date) {
                date = totalDaysInNextMonth;
            }

            let newFocusedDate = this.dp.getClampedDate(new Date(year, month, date));

            this.dp.setFocusDate(newFocusedDate, {viewDateTransition: true});
        }

        /**
         * Checks if one of hot key is pressed. If so, then returns array of matched combinations
          * @return {boolean | Array}
         */
        isHotKeyPressed = () => {
            let hotKeyIsPressed = false;
            let pressedKeysLength = this.pressedKeys.size;
            let isAllKeysArePressed = key => this.pressedKeys.has(key);

            for (let [combinations] of this.hotKeys) {
                if (hotKeyIsPressed) break;
                if (Array.isArray(combinations[0])) {
                    combinations.forEach((combination) => {
                        if (hotKeyIsPressed || pressedKeysLength !== combination.length) return;
                        hotKeyIsPressed = combination.every(isAllKeysArePressed) && combinations;
                    });
                } else {
                    if (pressedKeysLength !== combinations.length) continue;
                    hotKeyIsPressed = combinations.every(isAllKeysArePressed) && combinations;
                }
            }

            return hotKeyIsPressed;
        }

        isArrow = (keyCode) => {
            return keyCode >= 37 && keyCode <= 40;
        }

        onKeyDown = (e) => {
            let {key, which} = e;
            let {dp, dp: {focusDate}, opts} = this;

            this.registerKey(key);

            let pressedHotKey = this.isHotKeyPressed();

            if (pressedHotKey) {
                e.preventDefault();
                this.handleHotKey(pressedHotKey);
                return;
            }

            if (this.isArrow(which)) {
                e.preventDefault();
                this.focusNextCell(key);
                return;
            }

            if (key === 'Enter') {
                if (dp.currentView !== opts.minView) {
                    dp.down();
                    return;
                }
                if (focusDate) {
                    let alreadySelectedDate = dp._checkIfDateIsSelected(focusDate);
                    if (!alreadySelectedDate) {
                        dp.selectDate(focusDate);
                    } else {
                        dp._handleAlreadySelectedDates(alreadySelectedDate, focusDate);
                    }
                    return;
                }
            }

            if (key === 'Escape') {
                this.dp.hide();
            }
        }

        onKeyUp = (e) => {
            this.removeKey(e.key);
        }
    }

    let events = {
        on(eventName, handler) {
            if (!this.__events) {
                this.__events = {};
            }

            if (!this.__events[eventName]) {
                this.__events[eventName] = [handler];
            } else {
                this.__events[eventName].push(handler);
            }
        },

        off(eventName, handler) {
            if (!this.__events) return;
            if (!this.__events[eventName]) return;

            this.__events[eventName] = this.__events[eventName].filter(h => h !== handler);
        },

        removeAllEvents() {
            this.__events = {};
        },

        trigger(eventName, ...args) {
            if (!this.__events) return;
            if (!this.__events[eventName]) return;

            this.__events[eventName].forEach((handler) => {
                handler(...args);
            });
        }
    };

    function withEvents (target) {
        Object.assign(target, events);
    }

    let $body = '',
        $datepickersContainer = '',
        $datepickerOverlay = '',
        containerBuilt = false,
        baseTemplate = '' +
            '<i class="air-datepicker--pointer"></i>' +
            '<div class="air-datepicker--navigation"></div>' +
            '<div class="air-datepicker--content"></div>';

    function buildDatepickersContainer(id) {
        containerBuilt = true;

        $datepickersContainer = createElement({className: id, id});
        $body.appendChild($datepickersContainer);

        return $datepickersContainer;
    }

    class Datepicker {
        static defaults = defaults
        static version = '3.1.0'
        static defaultContainerId = 'air-datepicker-global-container'
        constructor(el, opts) {
            this.$el = getEl(el);

            if (!this.$el) return;

            this.$datepicker = createElement({className: 'air-datepicker'});
            this.opts = deepMerge({}, defaults, opts);
            this.$customContainer = this.opts.container ? getEl(this.opts.container) : false;
            this.$altField = getEl(this.opts.altField || false);

            if (!$body) {
                $body = getEl('body');
            }

            let {view, startDate} = this.opts;

            if (!startDate) {
                this.opts.startDate = new Date();
            }

            if (this.$el.nodeName === 'INPUT') {
                this.elIsInput = true;
            }

            this.inited = false;
            this.visible = false;

            this.viewDate = createDate(this.opts.startDate);
            this.focusDate = false;
            this.initialReadonly = this.$el.getAttribute('readonly');
            this.customHide = false;
            this.currentView = view;
            this.selectedDates = [];
            this.views = {};
            this.keys = [];
            this.rangeDateFrom = '';
            this.rangeDateTo = '';
            this.timepickerIsActive = false; // Need when autoClose and timepicker are both true
            this.treatAsInline = this.opts.inline || !this.elIsInput;

            this.init();
        }

        viewIndexes = [consts.days, consts.months, consts.years];

        init() {
            let {
                opts,
                treatAsInline,
                opts: {
                    inline,
                    isMobile,
                    selectedDates,
                    keyboardNav,
                    onlyTimepicker
                }
            } = this;

            if (!containerBuilt && !inline && this.elIsInput) {
                buildDatepickersContainer(Datepicker.defaultContainerId);
            }

            if (isMobile && !$datepickerOverlay && !treatAsInline) {
                this._createMobileOverlay();
            }

            this._handleLocale();
            this._bindSubEvents();
            this._createMinMaxDates();
            this._limitViewDateByMaxMinDates();

            if (this.elIsInput) {
                if (!inline) {
                    this._bindEvents();
                }

                if (keyboardNav && !onlyTimepicker) {
                    this.keyboardNav = new DatepickerKeyboard({dp: this, opts});
                }
            }

            if (selectedDates) {
                this.selectDate(selectedDates, {silent: true});
            }

            if (this.opts.visible && !treatAsInline) {
                this.show();
            }

            if (treatAsInline) {
                this._createComponents();
            }
        }

        _createMobileOverlay() {
            $datepickerOverlay = createElement({className: 'air-datepicker-overlay'});
            $datepickersContainer.appendChild($datepickerOverlay);
        }

        _createComponents() {
            let {
                opts,
                treatAsInline,
                opts: {
                    inline,
                    buttons,
                    timepicker,
                    position,
                    classes,
                    onlyTimepicker,
                    isMobile,
                }
            } = this;
            let dp = this;

            this._buildBaseHtml();

            if (this.elIsInput) {
                if (!inline) {
                    this._setPositionClasses(position);
                }
            }

            if (inline || !this.elIsInput) {
                this.$datepicker.classList.add('-inline-');
            }

            if (classes) {
                this.$datepicker.classList.add(...classes.split(' '));
            }

            if (onlyTimepicker) {
                this.$datepicker.classList.add('-only-timepicker-');
            }

            if (isMobile && !treatAsInline) {
                this._addMobileAttributes();
            }

            this.views[this.currentView] = new DatepickerBody({
                dp,
                type: this.currentView,
                opts
            });

            this.nav = new DatepickerNav({dp, opts});

            if (timepicker) {
                this._addTimepicker();
            }

            if (buttons) {
                this._addButtons();
            }

            this.$content.appendChild(this.views[this.currentView].$el);
            this.$nav.appendChild(this.nav.$el);
        }

        _destroyComponents() {
            for (let view in this.views) {
                this.views[view].destroy();
            }
            this.views = {};
            this.nav.destroy();
            if (this.timepicker) {
                this.timepicker.destroy();
            }
        }

        _addMobileAttributes() {
            $datepickerOverlay.addEventListener('click', this._onClickOverlay);

            this.$datepicker.classList.add('-is-mobile-');
            this.$el.setAttribute('readonly', true);
        }

        _removeMobileAttributes() {
            $datepickerOverlay.removeEventListener('click', this._onClickOverlay);

            this.$datepicker.classList.remove('-is-mobile-');

            if (!this.initialReadonly && this.initialReadonly !== '') {
                this.$el.removeAttribute('readonly');
            }
        }

        _createMinMaxDates() {
            let {minDate, maxDate} = this.opts;

            this.minDate = minDate ? createDate(minDate) : false;
            this.maxDate = maxDate ? createDate(maxDate) : false;
        }

        _addTimepicker() {
            this.$timepicker = createElement({className: 'air-datepicker--time'});
            this.$datepicker.appendChild(this.$timepicker);
            this.timepicker = new DatepickerTime({dp: this, opts: this.opts});
            this.$timepicker.appendChild(this.timepicker.$el);
        }

        _addButtons() {
            this.$buttons = createElement({className: 'air-datepicker--buttons'});
            this.$datepicker.appendChild(this.$buttons);
            this.buttons = new DatepickerButtons({dp: this, opts: this.opts});
            this.$buttons.appendChild(this.buttons.$el);
        }

        _bindSubEvents() {
            this.on(consts.eventChangeSelectedDate, this._onChangeSelectedDate);
            this.on(consts.eventChangeFocusDate, this._onChangeFocusedDate);
            this.on(consts.eventChangeTime, this._onChangeTime);
        }

        _buildBaseHtml() {
            let {inline} = this.opts;

            if  (this.elIsInput) {
                if (!inline) {
                    this.$container.appendChild(this.$datepicker);
                } else {
                    insertAfter(this.$datepicker, this.$el);
                }
            } else {
                this.$el.appendChild(this.$datepicker);
            }

            this.$datepicker.innerHTML = baseTemplate;

            this.$content = getEl('.air-datepicker--content',  this.$datepicker);
            this.$pointer = getEl('.air-datepicker--pointer', this.$datepicker);
            this.$nav = getEl('.air-datepicker--navigation', this.$datepicker);
        }

        _handleLocale() {
            let {locale, dateFormat, firstDay, timepicker, onlyTimepicker, timeFormat, dateTimeSeparator} = this.opts;
            this.locale = deepCopy(locale);

            if (dateFormat) {
                this.locale.dateFormat = dateFormat;
            }
            // Allow to remove time from formatted string
            // e.g. if user wants to display mm:hh yyyy MMMM (time first) instead of hardcoded order - 'date time`
            if (timeFormat !== undefined && timeFormat !== '') {
                this.locale.timeFormat = timeFormat;
            }

            let {timeFormat: timeFormatValidated} = this.locale;

            if (firstDay !== '') {
                this.locale.firstDay = firstDay;
            }

            if (timepicker && typeof dateFormat !== 'function') {
                let separator = timeFormatValidated ? dateTimeSeparator : '';
                this.locale.dateFormat = [this.locale.dateFormat, (timeFormatValidated ? timeFormatValidated : '')].join(separator);
            }

            if (onlyTimepicker) {
                this.locale.dateFormat = this.locale.timeFormat;
            }
        }

        _setPositionClasses(pos) {
            if (typeof pos === 'function') {
                this.$datepicker.classList.add('-custom-position-');

                return;
            }

            pos = pos.split(' ');
            let main = pos[0],
                sec = pos[1],
                classes = `air-datepicker -${main}-${sec}- -from-${main}-`;

            this.$datepicker.classList.add(...classes.split(' '));
        }

        _bindEvents() {
            this.$el.addEventListener(this.opts.showEvent, this._onFocus);
            this.$el.addEventListener('blur', this._onBlur);
            this.$datepicker.addEventListener('mousedown', this._onMouseDown);
            this.$datepicker.addEventListener('mouseup', this._onMouseUp);
            window.addEventListener('resize', this._onResize);
        }

        _limitViewDateByMaxMinDates() {
            let {viewDate, minDate, maxDate} = this;

            if (maxDate && isDateBigger(viewDate, maxDate)) {
                this.setViewDate(maxDate);
            }
            if (minDate && isDateSmaller(viewDate, minDate)) {
                this.setViewDate(minDate);
            }
        }

        formatDate(date = this.viewDate, string) {
            date = createDate(date);

            if (!(date instanceof Date)) return;

            let result = string,
                locale = this.locale,
                parsedDate = getParsedDate(date),
                decade = getDecade(date),
                replacer = Datepicker.replacer,
                dayPeriod = 'am';

            if (this.opts.timepicker && this.timepicker) {
                dayPeriod = this.timepicker.getDayPeriod(date).dayPeriod;
            }

            let formats = {
                // Time in ms
                T: date.getTime(),

                // Minutes
                m: parsedDate.minutes,
                mm: parsedDate.fullMinutes,

                // Hours
                h: parsedDate.hours12,
                hh: parsedDate.fullHours12,
                H: parsedDate.hours,
                HH: parsedDate.fullHours,

                // Day period
                aa: dayPeriod,
                AA: dayPeriod.toUpperCase(),

                // Day of week
                E: locale.daysShort[parsedDate.day],
                EEEE: locale.days[parsedDate.day],

                // Date of month
                d: parsedDate.date,
                dd: parsedDate.fullDate,

                // Months
                M: parsedDate.month + 1,
                MM: parsedDate.fullMonth,
                MMM: locale.monthsShort[parsedDate.month],
                MMMM: locale.months[parsedDate.month],

                // Years
                yy: parsedDate.year.toString().slice(-2),
                yyyy: parsedDate.year,
                yyyy1: decade[0],
                yyyy2: decade[1]
            };


            for (let [format, data] of Object.entries(formats)) {
                result = replacer(result, getWordBoundaryRegExp(format), data);
            }

            return result;
        }

        /**
         * Changes month, year, decade to next period
         */
        next = () => {
            let {year, month} = this.parsedViewDate;

            switch (this.currentView) {
                case consts.days:
                    this.setViewDate(new Date(year, month + 1, 1));
                    break;
                case consts.months:
                    this.setViewDate(new Date(year + 1, month, 1));
                    break;
                case consts.years:
                    this.setViewDate(new Date(year + 10, 0, 1));
                    break;
            }
        }

        /**
         * Changes month, year, decade to prev period
         */
        prev = () => {
            let {year, month} = this.parsedViewDate;

            switch (this.currentView) {
                case consts.days:
                    this.setViewDate(new Date(year, month - 1, 1));
                    break;
                case consts.months:
                    this.setViewDate(new Date(year - 1, month, 1));
                    break;
                case consts.years:
                    this.setViewDate(new Date(year - 10, 0, 1));
                    break;
            }
        }

        down(date) {
            this._handleUpDownActions(date, 'down');
        }

        up(date) {
            this._handleUpDownActions(date, 'up');
        }

        /**
         * Selects date, if array is passed then selects dates one by one
         * @param {DateLike|Array<DateLike>} date
         * @param {object} [params] - extra parameters
         * @param {boolean} [params.updateTime] - should update timepicker's time from passed date
         * @param {boolean} [params.silent] - if true, then onChange event wont be triggered
         * @return {Promise<unknown>} - returns promise, since input value updates asynchronously, after promise resolves, we need a promise tobe able to get current input value
         * @example selectDate(new Date()).then(() => {console.log(dp.$el.value)})
         */
        selectDate(date, params = {}) {
            let {currentView, parsedViewDate, selectedDates} = this;
            let {updateTime} = params;
            let {
                moveToOtherMonthsOnSelect,
                moveToOtherYearsOnSelect,
                multipleDates,
                range,
                autoClose
            } = this.opts;
            let selectedDaysLen = selectedDates.length;
            let newViewDate;

            if (Array.isArray(date)) {
                date.forEach((d) => {
                    this.selectDate(d, params);
                });

                return new Promise((resolve) => {
                    setTimeout(resolve);
                });
            }

            date = createDate(date);

            if (!(date instanceof Date)) return;

            // Checks if selected date is out of current month or decade
            // If so, change `viewDate`
            if (currentView === consts.days) {
                if (date.getMonth() !== parsedViewDate.month && moveToOtherMonthsOnSelect) {
                    newViewDate = new Date(date.getFullYear(), date.getMonth(), 1);
                }
            }

            if (currentView === consts.years) {
                if (date.getFullYear() !== parsedViewDate.year && moveToOtherYearsOnSelect) {
                    newViewDate = new Date(date.getFullYear(), 0, 1);
                }
            }

            if (newViewDate) {
                this.setViewDate(newViewDate);
            }

            if (multipleDates && !range) {
                if (selectedDaysLen === multipleDates) return;
                if (!this._checkIfDateIsSelected(date)) {
                    selectedDates.push(date);
                }
            } else if (range) {
                switch (selectedDaysLen) {
                    case 1:
                        selectedDates.push(date);
                        // Need to define this manually if call selectDate programmatically
                        if (!this.rangeDateTo) {
                            this.rangeDateTo = date;
                        }
                        // Swap dates if they were selected via dp.selectDate() and second date was smaller then first
                        if (isDateBigger(this.rangeDateFrom, this.rangeDateTo)) {
                            this.rangeDateTo = this.rangeDateFrom;
                            this.rangeDateFrom = date;
                        }
                        this.selectedDates = [this.rangeDateFrom, this.rangeDateTo];
                        break;
                    case 2:
                        this.selectedDates = [date];
                        this.rangeDateFrom = date;
                        this.rangeDateTo = '';
                        break;
                    default:
                        this.selectedDates = [date];
                        this.rangeDateFrom = date;
                }
            } else {
                this.selectedDates = [date];
            }

            this.trigger(consts.eventChangeSelectedDate, {
                action: consts.actionSelectDate,
                silent: params?.silent,
                date,
                updateTime
            });
            this._updateLastSelectedDate(date);

            if (autoClose && !this.timepickerIsActive && this.visible) {
                if (!multipleDates && !range) {
                    this.hide();
                } else if (range && selectedDaysLen === 1) {
                    this.hide();
                }
            }

            return new Promise((resolve) => {
                setTimeout(resolve);
            });
        }

        unselectDate(date) {
            let selected = this.selectedDates,
                _this = this;

            date = createDate(date);

            if (!(date instanceof Date)) return;

            return selected.some((curDate, i) => {
                if (isSameDate(curDate, date)) {
                    selected.splice(i, 1);

                    if (!_this.selectedDates.length) {
                        _this.rangeDateFrom = '';
                        _this.rangeDateTo = '';
                        _this._updateLastSelectedDate(false);
                    } else {
                        _this._updateLastSelectedDate(_this.selectedDates[_this.selectedDates.length - 1]);
                    }

                    this.trigger(consts.eventChangeSelectedDate, {action: consts.actionUnselectDate,  date});

                    return true;
                }
            });
        }

        replaceDate(selectedDate, newDate) {
            let date = this.selectedDates.find((d) => {
                return isSameDate(d, selectedDate, this.currentView);
            });
            let index = this.selectedDates.indexOf(date);

            if (index < 0) return;

            // Add check if same date exists, if so don't trigger change events
            if (isSameDate(this.selectedDates[index], newDate, this.currentView)) {
                return;
            }

            this.selectedDates[index] = newDate;

            this.trigger(consts.eventChangeSelectedDate, {
                action: consts.actionSelectDate,
                date: newDate,
                updateTime: true
            });

            this._updateLastSelectedDate(newDate);
        }

        clear() {
            this.selectedDates = [];
            this.rangeDateFrom = false;
            this.rangeDateTo = false;

            this.trigger(consts.eventChangeSelectedDate, {action: consts.actionUnselectDate});
        }

        show() {
            let {onShow, isMobile} = this.opts;
            this._cancelScheduledCall();

            if (!this.visible && !this.hideAnimation) {
                this._createComponents();
            }

            this.setPosition(this.opts.position);

            this.$datepicker.classList.add('-active-');
            this.visible = true;

            if (onShow) {
                this._scheduleCallAfterTransition(onShow);
            }

            if (isMobile) {
                this._showMobileOverlay();
            }
        }

        hide() {
            let {onHide, isMobile} = this.opts;
            let hasTransition = this._hasTransition();

            this.visible = false;
            this.hideAnimation = true;

            this.$datepicker.classList.remove('-active-');

            if (this.customHide) {
                this.customHide();
            }

            if (this.elIsInput) {
                this.$el.blur();
            }

            this._scheduleCallAfterTransition((isAnimationCompleted) => {
                if (
                    !this.customHide &&
                    ((isAnimationCompleted && hasTransition) ||
                    (!isAnimationCompleted && !hasTransition))
                ) {
                    this._finishHide();
                }
                onHide && onHide(isAnimationCompleted);
            });

            if (isMobile) {
                $datepickerOverlay.classList.remove('-active-');
            }
        }

        _finishHide = () => {
            this.hideAnimation = false;
            this._destroyComponents();
            this.$container.removeChild(this.$datepicker);
        }

        setPosition = (position, isViewChange = false) => {
            position = position || this.opts.position;

            if (typeof position === 'function') {
                this.customHide = position({
                    $datepicker: this.$datepicker,
                    $target: this.$el,
                    $pointer: this.$pointer,
                    isViewChange,
                    done: this._finishHide
                });
                return;
            }

            let  {isMobile} = this.opts;

            let vpDims = this.$el.getBoundingClientRect(),
                dims = this.$el.getBoundingClientRect(),
                $dpOffset = this.$datepicker.offsetParent,
                $elOffset = this.$el.offsetParent,
                selfDims = this.$datepicker.getBoundingClientRect(),
                pos = position.split(' '),
                top, left,
                scrollTop = window.scrollY,
                scrollLeft = window.scrollX,
                offset = this.opts.offset,
                main = pos[0],
                secondary = pos[1];

            if (isMobile) {
                this.$datepicker.style.cssText = 'left: 50%; top: 50%';
                return;
            }

            // If datepicker's container is the same with target element
            if ($dpOffset === $elOffset && $dpOffset !== document.body) {
                dims = {
                    top: this.$el.offsetTop,
                    left: this.$el.offsetLeft,
                    width: vpDims.width,
                    height: this.$el.offsetHeight
                };

                scrollTop = 0;
                scrollLeft = 0;
            }

            // If dp container is different from target offset parent
            // and dp offset parent has position not static (default case)
            if ($dpOffset !== $elOffset && $dpOffset !== document.body) {
                let dpOffsetDims = $dpOffset.getBoundingClientRect();

                dims = {
                    top: vpDims.top - dpOffsetDims.top,
                    left: vpDims.left - dpOffsetDims.left,
                    width: vpDims.width,
                    height: vpDims.height
                };

                scrollTop = 0;
                scrollLeft = 0;
            }

            switch (main) {
                case 'top':
                    top = dims.top - selfDims.height - offset;
                    break;
                case 'right':
                    left = dims.left + dims.width + offset;
                    break;
                case 'bottom':
                    top = dims.top + dims.height + offset;
                    break;
                case 'left':
                    left = dims.left - selfDims.width - offset;
                    break;
            }

            switch (secondary) {
                case 'top':
                    top = dims.top;
                    break;
                case 'right':
                    left = dims.left + dims.width - selfDims.width;
                    break;
                case 'bottom':
                    top = dims.top + dims.height - selfDims.height;
                    break;
                case 'left':
                    left = dims.left;
                    break;
                case 'center':
                    if (/left|right/.test(main)) {
                        top = dims.top + dims.height / 2 - selfDims.height / 2;
                    } else {
                        left = dims.left + dims.width / 2 - selfDims.width / 2;
                    }
            }

            this.$datepicker.style.cssText = `left: ${left + scrollLeft}px; top: ${top + scrollTop}px`;
        }

        _setInputValue = () => {
            let {opts, $altField, locale: {dateFormat}} = this,
                {altFieldDateFormat, altField} = opts;

            if (altField && $altField) {
                $altField.value = this._getInputValue(altFieldDateFormat);
            }

            this.$el.value = this._getInputValue(dateFormat);
        }

        _getInputValue = (dateFormat) => {
            let {selectedDates, opts} = this,
                {multipleDates, multipleDatesSeparator} = opts;

            if (!selectedDates.length) return '';

            let formatIsFunction = typeof dateFormat === 'function';

            let value = formatIsFunction
                ? dateFormat(multipleDates ? selectedDates : selectedDates[0])
                : selectedDates.map((date) => {
                    return this.formatDate(date, dateFormat);
                });

            value = formatIsFunction
                ? value
                : value.join(multipleDatesSeparator);

            return value;
        }

        _triggerOnSelect() {
            let dates = [],
                formattedDates = [],
                datepicker = this,
                {selectedDates, locale, opts: {onSelect, multipleDates, range}} = datepicker,
                isMultiple = multipleDates || range,
                formatIsFunction = typeof locale.dateFormat === 'function';

            if (selectedDates.length) {
                dates = selectedDates.map(copyDate);
                formattedDates = formatIsFunction
                    ? multipleDates
                        ? locale.dateFormat(dates)
                        : dates.map(date => locale.dateFormat(date))
                    : dates.map(date => this.formatDate(date, locale.dateFormat));
            }

            onSelect({
                date: isMultiple ? dates : dates[0],
                formattedDate: isMultiple ? formattedDates : formattedDates[0],
                datepicker
            });
        }

        /**
         * Checks if date is already selected, returns selected date if finds one
         * Returns selected date, need for timepicker
         * @param {Date} date
         * @param {String} cellType - days, months, years
         * @return {boolean|Date}
         * @private
         */
        _checkIfDateIsSelected = (date, cellType = consts.days) => {
            let alreadySelectedDate = false;

            this.selectedDates.some((selectedDate) => {
                let same = isSameDate(date, selectedDate, cellType);
                alreadySelectedDate = same && selectedDate;
                return same;
            });

            return alreadySelectedDate;
        }

        _handleAlreadySelectedDates(alreadySelectedDate, newSelectedDate) {
            let {range, toggleSelected} = this.opts;
            if (range) {
                if (!toggleSelected) {
                    // Add possibility to select same date when range is true
                    if (this.selectedDates.length !== 2) {
                        this.selectDate(newSelectedDate);
                    }
                } else {
                    this.unselectDate(newSelectedDate);
                }
            } else if (toggleSelected) {
                this.unselectDate(newSelectedDate);
            }

            // Change last selected date to be able to change time when clicking on this cell
            if (!toggleSelected) {
                this._updateLastSelectedDate(alreadySelectedDate);
            }
        }

        _handleUpDownActions(date, dir) {
            let maxViewIndex = 2,
                minViewIndex = 0;

            date = createDate(date || this.focusDate || this.viewDate);

            if (!(date instanceof Date)) return;

            let nextView = dir === 'up' ? this.viewIndex + 1 : this.viewIndex - 1;
            if (nextView > maxViewIndex) nextView = maxViewIndex;
            if (nextView < minViewIndex) nextView = minViewIndex;

            this.setViewDate(new Date(date.getFullYear(), date.getMonth(), 1));
            this.setCurrentView(this.viewIndexes[nextView]);
        }

        _handleRangeOnFocus() {
            if (this.selectedDates.length === 1) {
                let selectedDate = this.selectedDates[0];
                if (isDateBigger(selectedDate, this.focusDate)) {
                    this.rangeDateTo =  this.selectedDates[0];
                    this.rangeDateFrom = this.focusDate;
                } else {
                    this.rangeDateTo = this.focusDate;
                    this.rangeDateFrom = this.selectedDates[0];
                }
            }
        }

        _scheduleCallAfterTransition = (cb) => {
            this._cancelScheduledCall();

            cb && cb(false);

            this._onTransitionEnd = () => {
                cb && cb(true);
            };

            this.$datepicker.addEventListener('transitionend', this._onTransitionEnd, {once: true});
        }

        _cancelScheduledCall = () => {
            this.$datepicker.removeEventListener('transitionend', this._onTransitionEnd);
        }

        /**
         * Sets new view date of datepicker
         * @param {DateLike} date
         */
        setViewDate = (date) => {
            date = createDate(date);

            if (!(date instanceof Date)) return;

            if (isSameDate(date, this.viewDate)) return;
            let oldViewDate = this.viewDate;
            this.viewDate = date;
            let {onChangeViewDate} = this.opts;

            if (onChangeViewDate) {
                let {month, year} = this.parsedViewDate;
                onChangeViewDate({
                    month,
                    year,
                    decade: this.curDecade
                });
            }

            this.trigger(consts.eventChangeViewDate, date, oldViewDate);
        }

        /**
         * Sets new focusDate
         * @param {Date} date
         * @param {Object} [params]
         * @param {Boolean} params.viewDateTransition
         */
        setFocusDate = (date, params = {}) => {
            if (date) {
                date = createDate(date);

                if (!(date instanceof Date)) return;
            }

            this.focusDate = date;

            if (this.opts.range && date) {
                this._handleRangeOnFocus();
            }

            this.trigger(consts.eventChangeFocusDate, date, params);
        }

        /**
         * Sets new datepicker view
         * @param {ViewType} view
         */
        setCurrentView = (view) => {
            if (!this.viewIndexes.includes(view)) return;

            this.currentView = view;

            if (this.elIsInput && this.visible) this.setPosition(undefined, true);

            // Trigger inner event before new view is inited, to avoid multiple render calls in datepicker body
            this.trigger(consts.eventChangeCurrentView, view);

            if (!this.views[view]) {
                let newView = this.views[view] = new DatepickerBody({
                    dp: this,
                    opts: this.opts,
                    type: view
                });

                this.$content.appendChild(newView.$el);
            }

            // Trigger user event after, to be able to use datepicker api on rendered view
            if (this.opts.onChangeView) {
                this.opts.onChangeView(view);
            }
        }

        /**
         * Updates lastSelectedDate param and triggers corresponding event
         * @param {Date|Boolean} date - date or empty
         */
        _updateLastSelectedDate = (date) => {
            this.lastSelectedDate = date;
            this.trigger(consts.eventChangeLastSelectedDate, date);
        }

        /**
         * Finds cell HTML element
         * @param {DateLike} cellDate
         * @param {CellType} cellType
         * @return {HTMLElement | null}
         */
        getCell(cellDate, cellType = consts.day) {
            cellDate = createDate(cellDate);

            if (!(cellDate instanceof Date)) return;

            let {year, month, date} = getParsedDate(cellDate);

            let yearQuery = `[data-year="${year}"]`,
                monthQuery = `[data-month="${month}"]`,
                dayQuery = `[data-date="${date}"]`;

            let resultQuery = {
                [consts.day]: `${yearQuery}${monthQuery}${dayQuery}`,
                [consts.month]: `${yearQuery}${monthQuery}`,
                [consts.year]: `${yearQuery}`,
            };

            return this.views[this.currentView].$el.querySelector(resultQuery[cellType]);
        }

        destroy = () => {
            let {showEvent, isMobile} = this.opts;

            let parent = this.$datepicker.parentNode;
            if (parent) {
                parent.removeChild(this.$datepicker);
            }

            this.$el.removeEventListener(showEvent, this._onFocus);
            this.$el.removeEventListener('blur', this._onBlur);
            window.removeEventListener('resize', this._onResize);
            if (isMobile) {
                this._removeMobileAttributes();
            }

            if (this.keyboardNav) {
                this.keyboardNav.destroy();
            }

            this.views = null;
            this.nav = null;

            this.$datepicker = null;
            this.opts = null;
            this.$customContainer = null;

            this.viewDate = null;
            this.focusDate = null;
            this.selectedDates = null;
            this.rangeDateFrom = null;
            this.rangeDateTo = null;
        }

        update = (newOpts) => {
            let prevOpts = deepMerge({}, this.opts);
            deepMerge(this.opts, newOpts);

            let {timepicker, buttons, range, selectedDates, isMobile} = this.opts;
            let shouldUpdateDOM = this.visible || this.treatAsInline;

            this._createMinMaxDates();
            this._limitViewDateByMaxMinDates();
            this._handleLocale();

            if (!prevOpts.selectedDates && selectedDates) {
                this.selectDate(selectedDates);
            }

            if (newOpts.view) {
                this.setCurrentView(newOpts.view);
            }

            this._setInputValue();

            if (prevOpts.range && !range) {
                this.rangeDateTo = false;
                this.rangeDateFrom = false;
            } else if (!prevOpts.range && range) {
                if (this.selectedDates.length) {
                    this.rangeDateFrom = this.selectedDates[0];
                    this.rangeDateTo = this.selectedDates[1];
                }
            }

            if (prevOpts.timepicker && !timepicker) {
                shouldUpdateDOM && this.timepicker.destroy();
                this.timepicker = false;
                this.$timepicker.parentNode.removeChild(this.$timepicker);
            } else if (!prevOpts.timepicker && timepicker) {
                this._addTimepicker();
            }

            if (!prevOpts.buttons && buttons) {
                this._addButtons();
            } else if (prevOpts.buttons && !buttons) {
                this.buttons.destroy();
                this.$buttons.parentNode.removeChild(this.$buttons);
            } else {
                if (shouldUpdateDOM && prevOpts.buttons && buttons) {
                    this.buttons.clearHtml().render();
                }
            }

            if (!prevOpts.isMobile && isMobile) {
                if (!this.treatAsInline && !$datepickerOverlay) {
                    this._createMobileOverlay();
                }
                this._addMobileAttributes();
                if (this.visible) {
                    this._showMobileOverlay();
                }
            } else if (prevOpts.isMobile && !isMobile) {
                this._removeMobileAttributes();

                if (this.visible) {
                    $datepickerOverlay.classList.remove('-active-');
                    if (typeof this.opts.position !== 'function') {
                        this.setPosition();
                    }
                }
            }

            if (!shouldUpdateDOM) return;

            this.nav.update();
            this.views[this.currentView].render();
            if (this.currentView === consts.days) {
                this.views[this.currentView].renderDayNames();
            }
        }

        _showMobileOverlay() {
            $datepickerOverlay.classList.add('-active-');
        }

        _hasTransition() {
            let transition = window.getComputedStyle(this.$datepicker).getPropertyValue('transition-duration');
            let props = transition.split(', ');

            return props.reduce((sum, item) => {
                return parseFloat(item) + sum;
            }, 0) > 0;
        }

        //  Utils
        // -------------------------------------------------

        isOtherMonth = (date) => {
            let {month} = getParsedDate(date);

            return month !== this.parsedViewDate.month;
        }

        isOtherYear = (date) => {
            let {year} = getParsedDate(date);

            return year !== this.parsedViewDate.year;
        }

        isOtherDecade = (date) => {
            let {year} = getParsedDate(date);
            let [firstDecadeYear, lastDecadeYear] = getDecade(this.viewDate);

            return year < firstDecadeYear || year > lastDecadeYear;
        }

        //  Subscription events
        // -------------------------------------------------

        _onChangeSelectedDate = ({silent}) => {
            // Use timeout here for wait for all changes that could be made to selected date (e.g. timepicker adds time)
            setTimeout(() => {
                this._setInputValue();
                if (this.opts.onSelect && !silent) {
                    this._triggerOnSelect();
                }
            });
        }

        _onChangeFocusedDate = (date, {viewDateTransition} = {}) => {
            if (!date) return;
            let shouldPerformTransition = false;

            if (viewDateTransition) {
                shouldPerformTransition = this.isOtherMonth(date) || this.isOtherYear(date) || this.isOtherDecade(date);
            }

            if (shouldPerformTransition) {
                this.setViewDate(date);
            }

        }

        _onChangeTime = ({hours, minutes}) => {
            let today = new Date();
            let {lastSelectedDate, opts: {onSelect}} = this;
            let targetDate = lastSelectedDate;

            if (!lastSelectedDate) {
                targetDate = today;
            }

            let $cell = this.getCell(targetDate, this.currentViewSingular);
            let cell = $cell && $cell.adpCell;

            if (cell && cell.isDisabled) return;

            targetDate.setHours(hours);
            targetDate.setMinutes(minutes);

            if (!lastSelectedDate) {
                this.selectDate(targetDate);
            } else {
                this._setInputValue();
                if (onSelect) {
                    this._triggerOnSelect();
                }
            }
        }

        _onFocus = (e) => {
            if (!this.visible) {
                this.show();
            }
        }

        _onBlur = (e) => {
            if (!this.inFocus && this.visible && !this.opts.isMobile) {
                this.hide();
            }
        }

        _onMouseDown = (e) => {
            this.inFocus = true;
        }

        _onMouseUp = (e) => {
            this.inFocus = false;
            this.$el.focus();
        }

        _onResize = () => {
            if (this.visible && typeof this.opts.position !== 'function') {
                this.setPosition();
            }
        }

        _onClickOverlay = () => {
            if (this.visible) {
                this.hide();
            }
        }

        //  Helpers
        // -------------------------------------------------

        get parsedViewDate() {
            return getParsedDate(this.viewDate);
        }

        get currentViewSingular() {
            return this.currentView.slice(0, -1);
        }

        get curDecade() {
            return getDecade(this.viewDate);
        }

        get viewIndex() {
            return this.viewIndexes.indexOf(this.currentView);
        }

        get isFinalView() {
            return this.currentView === consts.years;
        }

        get hasSelectedDates() {
            return this.selectedDates.length > 0;
        }

        get isMinViewReached() {
            return this.currentView === this.opts.minView || this.currentView === consts.days;
        }

        get $container() {
            return this.$customContainer || $datepickersContainer;
        }

        isWeekend = (day) => {
            return this.opts.weekends.includes(day);
        }

        /**
         * Clamps passed date between min and max date
         * @param {Date} date
         */
        getClampedDate = (date) => {
            let {minDate, maxDate} = this,
                newDate = date;

            if (maxDate && isDateBigger(date, maxDate)) {
                newDate = maxDate;
            } else if (minDate && isDateSmaller(date, minDate)) {
                newDate = minDate;
            }

            return newDate;
        }

        static replacer(str, reg, data) {
            return str.replace(reg, function (match, p1, p2, p3) {
                return p1 + data + p3;
            });
        }
    }

    withEvents(Datepicker.prototype);

    /**
     * Basic UI: Datepicker.
     */
    const BasicDatepickerInitArray = [];
    const BasicDatepicker = (() => {

    	class Core {

    	    constructor(element, options) {
    	        
    	        this.$el = element;
    			this.$options = options || {};				
    			
    			this.build();

    	    }


    		build() {

    			if (this.$el.classList.contains('datepicker-init') == true) {

    				BasicDatepickerInitArray.find(variable => {

    					if (variable.el === this.$el) this.$airDatepicker =  variable.airDatepicker;

    				});
    			
    			}
    			

    			if (this.$el.classList.contains('datepicker-init') == false) {

    				this.$el.classList.add('datepicker-init');
    				this.$airDatepicker = new Datepicker(this.$el, this.$options);
    				
    				BasicDatepickerInitArray.push({
    					el: this.$el,
    					airDatepicker: this.$airDatepicker
    				});
    			
    			}

    		}


    		on({name, listener}) {

    			this.$options[name] = listener;
    			this.$airDatepicker.update(this.$options);

    		}


    		methods({name, options}) {

    			let values = Object.values(options);

    			this.$airDatepicker[name](...values);			
    			if (name == 'destroy') this.$el.classList.remove('datepicker-init');

    		}

    	}


    	let active = null;


    	/**
    	 * Datepicker initialization
    	 * @param {object|string} variable - element for initializing Datepicker,
    	 * @param {object} 		  config   - configuration for initializing Datepicker
    	 */
    	const init = (variable, config) => {

    		let options = config || {},
    			element = null,
    			elements = BasicCore.variables(variable, '.js-datepicker:not(.datepicker-init)');
    		

    		try {

    			if (elements == false && variable !== undefined) throw new Error(BasicCore.logging['error']['missing']);
    			if (elements == null  && variable !== undefined) throw new Error(BasicCore.logging['error']['type']);

    			elements.forEach((value) => {

    				element = value;
    				options = JSON.parse(element.getAttribute('data-datepicker-options')) || options;

    				active = new Core(value, options);				

    			});

    			return active;

    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Datepicker init. \nMessage: ${error.message} \nElement: `, element);

    		}	

    	};


    	/**
    	 * Datepicker events
    	 * @param {object|string} variable 		  - element for event Datepicker;
    	 * @param {string} 		  config.name     - name event Datepicker;
    	 * @param {function} 	  config.listener - listener for event Datepicker.
    	 */
    	const on = (variable, config) => {

    		let element = (typeof variable == 'string') ? document.querySelector(variable) : variable,
    			options = {
    				name: config.name || 'onSelect',
    				listener: config.listener || function({date, formattedDate, datepicker}) {}  
    			};
    		
    		
    		try {

    			active = new Core(element);	
    			active.on(options);

    			return active;

    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Datepicker on \nMessage: ${error.message} \nElement:`, variable);

    		}

    	};


    	/**
    	 * Datepicker methods
    	 * @param {object|string} variable      - element for methods Datepicker;
    	 * @param {string} 		  config.name   - name methods Datepicker;
    	 * @param {object} 		  config.config - config for method Datepicker.
    	 */
    	const methods = (variable, config) => {

    		let element = (typeof variable == 'string') ? document.querySelector(variable) : variable,
    			params = {
    				name: config.name || '',
    				options: config.config || {}
    			};
    				
    		
    		try {

    			active = new Core(element);	
    			active.methods(params);

    			return active;

    		} catch(error) {

    			console.error(`${BasicCore.logging['name']} Datepicker methods \nMessage: ${error.message} \nElement:`, variable);

    		}

    	};


    	return { init, on, methods };

    })();
    	

    window.BasicDatepicker = BasicDatepicker;

    // ** Polyfills **
    // import { BasicDropdown } 		     from './modules/basic-ui/ui/dropdown.js';
    // ** /Basic UI **


    // init
    document.addEventListener('DOMContentLoaded', function() {

    	// ** Common **
    	CommonTypography.init();


    	// ** Layout **
    	LayoutMenu.init();


    	// ** Components **
    	ComponentReceiptAction .init();
    	
    	
    	// ** Basic UI **
    	BasicAccordion.init();
    	BasicPopup.init();
    	BasicReadmore.init();
    	BasicTabs.init();
    	BasicToggleVisibleContent.init();
    	BasicClassTransfer.init();
    	BasicTooltip.init();
    	BasicMask.init();
    	BasicSlider.init();
    	BasicLazyLoadingImg.init();
    	BasicDatepicker.init();
    	// ** /Basic UI **

    });

})();
